import {
  AppBar,
  Button,
  Checkbox,
  Dialog,
  Divider,
  Drawer,
  Fab,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  Tab,
  TableContainer,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import InfoIcon from '@material-ui/icons/Info';
import SearchIcon from '@material-ui/icons/Search';
import { cloneDeep, debounce, isEmpty, isEqual, set, sortBy } from 'lodash-es';
import MaterialTable from 'material-table';
import moment from 'moment';
import React, { JSX, ReactElement } from 'react';
import update from 'react-addons-update';

import { ChannelEventTypes, track } from '~/src/dash/analytics/analytics';
import {
  BrandSafetyRuleTargetingTypeBidder,
  BrandSafetyRuleTargetingTypeBidderGroup,
  BrandSafetyRuleTargetingTypeChannel,
  BrandSafetyRuleTargetingTypeChannelGroup,
  BrandSafetyRuleTargetingTypeGlobal,
  IBrandSafetyRule,
} from '~/src/dash/api/brand-safety-rules';
import { IAdserverCampaign } from '~/src/dash/api/campaign/campaign';
import { getChannelGroupsPromise } from '~/src/dash/api/channel-group';
import { getSmallSites } from '~/src/dash/api/channels/channels_methods';
import {
  ESuperSiteTargetingLogicOperator,
  ESuperSiteTargetingObjectEndpointParamsType,
  ESuperSiteTargetingObjectEndpointParamsTypeValues,
  ESuperSiteTargetingObjectType,
  ESuperSiteTargetingObjectTypeValues,
  IEndpointRequestScore,
  ISmallSite,
  ISuperSiteTargetingObject,
} from '~/src/dash/api/channels/channels_models';
import {
  ESuperSiteTargetingObjectEndpointParamsTypeToString,
  ESuperSiteTargetingObjectTypeToString,
  extractSuperSiteTargetingValue,
} from '~/src/dash/api/channels/channels_utils';
import {
  AllowBidsBelowDealFloor_BY_PERCENT,
  AllowBidsBelowDealFloor_BY_VALUE,
  AllowBidsBelowDealFloor_DO_NOT_ALLOW,
  AllowBidsBelowDealFloorType,
  allowBidsBelowDealFloorTypeToString,
  bulkUpdateChannel,
  deleteSite,
  EFallbackAdsMode,
  ESite_HeaderBidderWinnerModel,
  ESuperSiteTargetingType,
  getCampaigns,
  getChannelLabels,
  getSite,
  HeaderBidderDeliveryTypesIndexMap,
  HeaderBidderDeliveryTypesMap,
  IABTesting,
  IBypassDedupConfig,
  IChannelGroup,
  IChannelLabel,
  ICountryGroup,
  IDeviceAwareModel,
  IHeaderBidder,
  IHeaderBidderPriceIncrement,
  ISite,
  SiteActiveActive,
  SiteActiveInactive,
  SiteHeaderBidderDeliveryType,
  SitePriceExtension_false,
  SitePriceExtension_true,
  SitePriceExtensionType,
  SUPER_SITE_TARGETING_TYPE_CUSTOM_4,
  SuperSiteTargetingTypes,
  updateBypassDedupConfig,
  updatePriceIncrements,
  updateSite,
} from '~/src/dash/api/console-api';
import { getCountryGroupsByPublisherID } from '~/src/dash/api/country-group';
import {
  convertECurrencyTypeToString,
  convertECurrencyTypeToSymbol,
  convertStringToECurrencyType,
  CurrencyDisplayedItem,
  CurrencyType,
  CurrencyTypeUSD,
  ECurrencyType,
} from '~/src/dash/api/exchange-rates';
import {
  ISmallBidder,
  ISmallBidderSmartFloors,
  querySmallBidders,
  querySmallBiddersExcludeBidderTypes,
} from '~/src/dash/api/filters/bidders';
import {
  EStartDelay,
  startDelayOverrideIsEmpty,
} from '~/src/dash/api/headerbidders/headerbidders_models';
import {
  DestinationMenuLists,
  DestinationTypeRoute,
  DestinationTypeSite,
  genInvenRouteChannelListFromSelected,
  genInvenRouteRouteListFromSelected,
  getInventoryRoutesByPublisherID,
  IInventoryRoute,
  IInventoryRouteDesinationKey,
} from '~/src/dash/api/inventory_routes';
import {
  generalGetLiveLogs,
  getEndpointRequestLogsQuery,
  getEndpointResponseLogsQuery,
  getLiveStreamWatcherAdBreakQuery,
  getVMAPPlaylistEndpointRequestLogsQuery,
  getVMAPPlaylistEndpointResponseLogsQuery,
} from '~/src/dash/api/live_logs/controller';
import { filterLiveLogs, filterLiveLogsByGarmScoreWrapper } from '~/src/dash/api/live_logs/helpers';
import {
  IEndpointRequestLiveLogs,
  IEndpointResponseUIData,
  ILiveStreamWatcherAdBreakData,
} from '~/src/dash/api/live_logs/models';
import { IParam } from '~/src/dash/api/network';
import { IObject } from '~/src/dash/api/resource-transforms';
import { createUrl, IHttpResponse, restGet } from '~/src/dash/api/rest';
import {
  DEFAULT_BID_SAVER_CONFIG,
  IBidSaverConfig,
  SITE_PARAMS_NOT_EDITABLE_TYPE,
  SITE_PARAMS_REQUIRED_TYPE,
} from '~/src/dash/api/site';
import { EBool } from '~/src/dash/api/types/bool';
import { TimeUnit } from '~/src/dash/api/types/time_unit';
import { IAccordionPanel, MultiAccordion } from '~/src/dash/components/accordion/multi-accordion';
import {
  RenderEndpointScorecardPanel,
  RenderEndpointScorecardPanelHeaders,
} from '~/src/dash/components/accordion/multi-accordion-panel';
import { CopyButton } from '~/src/dash/components/button';
import ConfirmationDialogButton from '~/src/dash/components/confirmation-dialog-button';
import { CurrencyConverter } from '~/src/dash/components/CurrencyConverter';
import { CategoryMultiSelect } from '~/src/dash/components/dropdowns/category-multiselect';
import { BlueBackground } from '~/src/dash/components/editor';
import { EndpointCustomTable } from '~/src/dash/components/endpoint-custom-table';
import { EndpointBuilder } from '~/src/dash/components/endpointBuilder';
import { BetaTooltipIcon } from '~/src/dash/components/icons/beta-icon';
import { IInputRow } from '~/src/dash/components/input-row';
import { IListTableColumn, ISiteRowData } from '~/src/dash/components/list-table';
import { LiveData } from '~/src/dash/components/live-data/live-data';
import { LogEndpointRequestTable } from '~/src/dash/components/logs-endpoint-request-table';
import { LogEndpointResponseTable } from '~/src/dash/components/logs-endpoint-response-table';
import { LiveContextAdBreakTable } from '~/src/dash/components/logs-live-context-ad-break-table';
import { MaterialLabelDropdownMulti } from '~/src/dash/components/material-label-dropdown-multi';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IModelBase } from '~/src/dash/components/model';
import ModelMissingPermission from '~/src/dash/components/model-missing-permission';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { ModelWhiteButton } from '~/src/dash/components/model-white-button';
import { ModelParagraphSubtitle } from '~/src/dash/components/paragraph';
import PillSwitcher from '~/src/dash/components/pill-switcher';
import { SettingsAppBar } from '~/src/dash/components/settings-app-bar';
import { ITab, SettingsTabs } from '~/src/dash/components/settings-tabs';
import { MakeTabProps, TabPanel } from '~/src/dash/components/TabPanel';
import { isValidUrl } from '~/src/dash/components/vast-editor';
import { getEndpointBuilderService } from '~/src/dash/endpoint-builder-configs/site-settings-list';
import {
  borderRadius,
  ButtonV2,
  Col,
  Cols,
  ct,
  Div,
  fontSizing,
  IndependentSelect,
  ISimpleOptionSelect,
  Panel,
  Panels,
  Row,
  Rows,
  spacing,
  spacingV2,
  Text,
  TextInput,
} from '~/src/dash/publicaUI';
import { SESSION_ACTIONS_SET } from '~/src/dash/reducers/session-reducers';
import { IStore } from '~/src/dash/reducers/store';
import {
  getColorTheme,
  getMacrosWiki,
  getPbsAPAC,
  getPbsEU,
  getPbsUS,
  getPbsJP,
  getPbsUSReseller,
  getPbsEUReseller,
  getPbsAPACReseller,
  getPbsJPReseller,
  getResellerTitle,
  getTechnicalDocumentationWiki,
  isRoku,
} from '~/src/dash/resellers/utils/importResellerConfig';
import {
  extractRouteParams,
  getRoutePath,
  navigate,
  navigateToRouteWithQueryParams,
  parseLocation,
  RouteBrandSafetyEdit,
  RouteBrandSafetyList,
  RouteChannelExisting,
  RouteChannelsView,
} from '~/src/dash/router/routes';
import { IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IEndpointParams,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { getRuleTypeChip } from '~/src/dash/utils/brand-safety-chip';
import { publicaColors } from '~/src/dash/utils/colors';
import {
  genCountriesMenuListFromSelectedAndDisable,
  genTargetingCountryGroupListFromSelectedAndDisable,
} from '~/src/dash/utils/countries';
import { formatTime } from '~/src/dash/utils/date';
import { decorate } from '~/src/dash/utils/decorator';
import { deviceEnvironmentsAsIMenu } from '~/src/dash/utils/device-environments';
import { EDeviceTypes, EDeviceTypesToString, EDeviceTypesValues } from '~/src/dash/utils/devices';
import { parseEndpointURL } from '~/src/dash/utils/endpoint-url';
import { EndpointBuilderService } from '~/src/dash/utils/endpointBuilderService';
import { genDemandSourcesOptions } from '~/src/dash/utils/header-bidder-adapters';
import { backgroundColor } from '~/src/dash/utils/material-dashboard-react';
import { CreateMenuList, GetSelectedValuesFromMenuList } from '~/src/dash/utils/menu_list_utils';
import { IMimeType, mimeTypes } from '~/src/dash/utils/mime-types';
import { noopVoid } from '~/src/dash/utils/noop';
import { obfuscateSiteName } from '~/src/dash/utils/obfuscate';
import { importLocalTargetingParamFromJSON } from '~/src/dash/utils/params';
import {
  IPermissionCheck,
  IS_AUTHORIZED,
  notAllowedEmptyIPermissionCheck,
} from '~/src/dash/utils/permission_service';
import { APAC, EUROPE, Regions, USA, JAPAN } from '~/src/dash/utils/regions';
import {
  checkUserInfoMasked,
  hasPermSuperUser,
  hasRoleSuperUser,
  isSuper,
} from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { siteWeightOptions } from '~/src/dash/utils/site-weights';
import {
  isEndpointBuilderDisabled,
  isPhiloFallbackEnabledPublisher,
  isPhiloPublisher,
  isSamsungPublisher,
  isXMLCommentWritePublisher,
} from '~/src/dash/utils/ui';
import { IUserSync, userSyncModels } from '~/src/dash/utils/user-sync';
import { hasErrors, IErrors, validatorFactory } from '~/src/dash/utils/validator';
import { winnerModels } from '~/src/dash/utils/winner-model';
import { ButtonView } from '~/src/dash/views/button-view';
import { ChannelABTestsContainer } from '~/src/dash/views/channels/ChannelABTests/container';
import { H3, HeadingCategorySm } from '~/src/dash/views/component-view';
import { CreativeQualityAssuranceView } from '~/src/dash/views/creative-quality-assurance-view';
import { LoadingView } from '~/src/dash/views/loading-view';
import { RouteSettingsView } from '~/src/dash/views/route/route-settings-view';
import { SingleSelect } from '~/src/dash/views/singleselect-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { AdomainAllowList } from '~/src/dash/views/channels/Channels/adomainAllowList';
import { EndpointShieldView } from '~/src/dash/views/endpoint-shield/EndpointShieldView';
import { PillSwitcherV2 } from '~/src/dash/components/tabs/PillSwitcherV2';
import { MaxUnderFloorType, MaxUnderFloorError } from '~/src/dash/views/common';
import { GarmScoreSelector } from '~/src/dash/components/GarmScoreSelector';
import { PremiumFeaturesSelectionEleaAI } from '~/src/dash/views/publisher-settings-view';
import {
  createInventorySmartFloorConfig,
  genNewInventorySmartFloor,
  genNewInventorySmartFloorConfig,
  getInventorySmartFloorConfigs,
  IInventorySmartFloorConfigUI,
  IInventorySmartFloorPayloadUI,
  inventorySmartFloorConfigCols,
  inventorySmartFloorRecalcKeys,
  updateInventorySmartFloorConfig,
  updateInventorySmartFloorParamsFromConfig,
} from '~/src/dash/apiV2/smartFloors/crud';
import { SiteSmartFloors } from '~/src/dash/views/channels/SmartFloors';
import { DemandSources } from '~/src/dash/globals/demand-sources';

interface IRewriteActiveRow {
  device: string;
  text?: string;
}

interface IGenerateRewriteInputRowsProps {
  stateKey: string;
  activeRows: Array<IRewriteActiveRow>;
  handleChange: (value: any) => void;
  selectTitle: string;
  textfieldTitle: string;
  placeholderText?: string;
  addButtonText?: string;
}

type RewriteInputRowsKey =
  | 'AppStoreURL'
  | 'AppNameOverride'
  | 'AppDomainOverride'
  | 'AppBundleOverride'
  | 'AppIDOverride';

interface IHandleChangeAppOverrideProps {
  rows: IRewriteActiveRow[];
  stateKey: RewriteInputRowsKey;
}

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {}

interface IState extends IBaseState, IModelBase, IEndpointParams {
  AppStoreURL: IDeviceAwareModel;
  AppStoreUrlOverrideIfEmpty: EBool;
  AppBundleOverride: { [key: string]: string };
  AppBundleOverrideIfEmpty: EBool;
  AppIDOverride: { [key: string]: string };
  AppIDOverrideIfEmpty: EBool;
  AppNameOverride: { [key: string]: string };
  AppNameOverrideIfEmpty: EBool;
  AppDomainOverride: { [key: string]: string };
  AppDomainOverrideIfEmpty: EBool;
  AppCatOverride: string;
  AppCatOverrideIfEmpty: EBool;
  SiteDomainOverride: { [key: string]: string };
  SiteDomainOverrideIfEmpty: EBool;
  SiteNameOverride: { [key: string]: string };
  BlockedAdomainInput: string;
  DDMonitoring: boolean;
  EnableHlsTranscoder: EBool;
  endpointBuilderService: EndpointBuilderService;
  EndpointURL: string;
  HeaderBidderCacheMedia: boolean;
  HeaderBidderDedup: boolean;
  HeaderBidderDedupAdomain: boolean;
  HeaderBidderDedupAPSKey: boolean;
  HeaderBidderDedupCategory: boolean;
  HeaderBidderDeliveryType: SiteHeaderBidderDeliveryType;
  AllowVPAID: boolean;
  HeaderBidderEnforceAdomain: boolean;
  HeaderBidderEnforceSlotTargeting: boolean;
  HeaderBidderSingleAuction: boolean;
  HeaderBidderVastVersion: string;
  HeaderBidderGlobalDedup: number;
  HeaderBidderGlobalDedupExpiration: number;
  HeaderBidderWinnerModel: ESite_HeaderBidderWinnerModel;
  HonorSequenceOrder: EBool;
  IABCatCommaSeparated: string;
  IABCatPrefix: string;
  IABCatSuffix: string;
  loading: boolean;
  MaxBitrate: number;
  MinBitrate: number;
  BidAdjustmentFactor: number;
  BidAdjustmentValue: number;
  BidFloor: number;
  CurrencyDisplayed: ECurrencyType;
  RokuProviderChannelIDStr: string;
  DefaultWeight: number;
  RejectNonsecureVAST: EBool;
  EnableXMLCommentWrites: EBool;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
  Timeout: number;
  DebugHeaderBidder: number;
  DebugHeaderBidderEnabledUntil: string;
  debugHeaderBidderEnabledUntilDays: number;
  SamplingPercentageDisabledUntil: string;
  SamplingPercentageRequests: number;
  MimeTypes: string[];
  openLogsView: boolean;
  PriceIncrements: IHeaderBidderPriceIncrement[];
  Region: string;
  rows: IHeaderBidder[];
  SiteName: string;
  sites: ISmallSite[];

  // snackbar
  snackbarError: boolean;
  snackbarMessage: string;
  snackbarWarning: boolean;
  updating: boolean;
  UserSyncProviders: string;
  ClickThroughAdomainRecognitionEnabled: EBool;
  BrandRecognitionEnabled: EBool;
  BrandRecognitionLimit: number;
  BrandRecognitionLimitUnit: TimeUnit;
  MachineLearningForMaxAuctionsEnabled: EBool;
  WebShrinkerCategoryEnabled: EBool;
  ServerSideTrackersEnabled: EBool;

  // Dedup
  AdIDDedup: EBool;
  CreativeIDDedup: EBool;
  CombineCreatives: EBool;
  LanguageDetectionEnabled: EBool;

  // Live Logs Tabs
  liveLogsTabIndex: number;
  requestLiveLogFilter: string;
  responseLiveLogFilter: string;
  vmapRequestLiveLogFilter: string;
  vmapResponseLiveLogFilter: string;
  liveStreamWatcherAdBreakLiveLogFilter: string;
  garmScoreFilter: string;
  endpointsRequestLiveLogs: IEndpointRequestLiveLogs[];
  endpointResponseLiveLogs: IEndpointResponseUIData[];
  vmapEndpointsRequestLiveLogs: IEndpointRequestLiveLogs[];
  vmapEndpointResponseLiveLogs: IEndpointResponseUIData[];
  liveStreamWatcherAdBreakLiveLogs: ILiveStreamWatcherAdBreakData[];

  // Auction split fields
  AuctionSplit: EBool;
  AuctionSplitTimeout: number;

  // Pod Duration Override Fields
  PodDurationOverrideEnabled: EBool;
  PodDurationOverride: number;

  // Channel Labels
  channelLabels: IChannelLabel[];
  ChannelLabelsSelected: IChannelLabel[];

  // Brand safety rules
  channelBrandSafetyRules: IBrandSafetyRule[]; // contains the brand safety rules that targets this channel

  // Channel group
  channelGroups: IChannelGroup[]; // contains all channel groups that include this channel

  errors: IErrors;

  // publica vault dropdown
  demandSourceList: ISelectOption[];
  PublicaVaultExcludedBidderIDs: string;
  PublicaVaultExcludedDemandSources: string;

  // brand-safety permissions
  publisherReadAuth: IPermissionCheck;
  channelReadAuth: IPermissionCheck;
  bidderReadAuth: IPermissionCheck;

  openEndpointParamsCustomizeMenu: boolean;
  endpointParams: IParam[];

  // Overrides
  // content
  ContentChannelOverride: string;
  ContentChannelOverrideIfEmpty: EBool;
  ContentNetworkOverride: string;
  ContentNetworkOverrideIfEmpty: EBool;
  ContentSeriesOverride: string;
  ContentSeriesOverrideIfEmpty: EBool;
  ContentTitleOverride: string;
  ContentTitleOverrideIfEmpty: EBool;
  ContentGenreOverride: string;
  ContentGenreOverrideIfEmpty: EBool;
  ContentDistribNameOverride: string;
  ContentDistribNameOverrideIfEmpty: EBool;
  ContentRatingOverride: string;
  ContentRatingOverrideIfEmpty: EBool;
  ContentCategoryOverride: string;
  ContentCategoryOverrideIfEmpty: EBool;
  ContentProdqualOverride: string;
  ContentProdqualOverrideIfEmpty: EBool;
  ContentProducerNameOverride: string;
  ContentProducerNameOverrideIfEmpty: EBool;
  ContentProducerIDOverride: string;
  ContentProducerIDOverrideIfEmpty: EBool;
  ContentKeywordsOverride: string;
  ContentKeywordsOverrideIfEmpty: EBool;
  ContentLanguageOverride: string;
  ContentLanguageOverrideIfEmpty: EBool;
  ContentIDOverride: string;
  ContentIDOverrideIfEmpty: EBool;
  ContentSeasonOverride: string;
  ContentSeasonOverrideIfEmpty: EBool;
  RemoveContentFromEndpointRequest: EBool;
  RemoveContentChannelFromEndpointRequest: EBool;
  RemoveContentNetworkFromEndpointRequest: EBool;
  RemoveContentSeriesFromEndpointRequest: EBool;
  RemoveContentTitleFromEndpointRequest: EBool;
  RemoveContentGenreFromEndpointRequest: EBool;
  RemoveContentDistribNameFromEndpointRequest: EBool;
  RemoveContentRatingFromEndpointRequest: EBool;
  RemoveContentCategoryFromEndpointRequest: EBool;
  RemoveContentProdqualFromEndpointRequest: EBool;
  RemoveContentProducerNameFromEndpointRequest: EBool;
  RemoveContentProducerIDFromEndpointRequest: EBool;
  RemoveContentKeywordsFromEndpointRequest: EBool;
  RemoveContentLanguageFromEndpointRequest: EBool;
  RemoveContentIDFromEndpointRequest: EBool;
  RemoveContentSeasonFromEndpointRequest: EBool;
  InventoryPartnerDomainOverride: string;
  InventoryPartnerDomainOverrideIfEmpty: EBool;

  // PostBid Overrides
  // content
  ContentDistribNamePostBidOverride: string;
  ContentDistribNamePostBidOverrideIfEmpty: EBool;
  ContentChannelPostBidOverride: string;
  ContentChannelPostBidOverrideIfEmpty: EBool;
  ContentNetworkPostBidOverride: string;
  ContentNetworkPostBidOverrideIfEmpty: EBool;
  ContentSeriesPostBidOverride: string;
  ContentSeriesPostBidOverrideIfEmpty: EBool;
  ContentTitlePostBidOverride: string;
  ContentTitlePostBidOverrideIfEmpty: EBool;
  ContentCategoryPostBidOverride: string;
  ContentCategoryPostBidOverrideIfEmpty: EBool;
  ContentGenrePostBidOverride: string;
  ContentGenrePostBidOverrideIfEmpty: EBool;
  ContentRatingPostBidOverride: string;
  ContentRatingPostBidOverrideIfEmpty: EBool;
  ContentProdqualPostBidOverride: string;
  ContentProdqualPostBidOverrideIfEmpty: EBool;
  ContentProducerNamePostBidOverride: string;
  ContentProducerNamePostBidOverrideIfEmpty: EBool;
  ContentProducerIDPostBidOverride: string;
  ContentProducerIDPostBidOverrideIfEmpty: EBool;
  ContentKeywordsPostBidOverride: string;
  ContentKeywordsPostBidOverrideIfEmpty: EBool;
  ContentLanguagePostBidOverride: string;
  ContentLanguagePostBidOverrideIfEmpty: EBool;

  // device
  AnonymizeDeviceID: EBool;
  // user
  AnonymizeIP: EBool;
  // pmp
  EndpointDealIDPassthroughActive: EBool;
  // Video
  MinAdDurationOverride: number;
  MaxAdDurationOverride: number;
  StartDelayOverride: number;
  ClearDefaultBitrateLimits: EBool;
  Skip: EBool;
  SkipMin: number;
  SkipAfter: number;
  SuperSiteID: number | undefined;
  SuperSiteTargeting: string;
  SuperSiteTargetingType: ESuperSiteTargetingType;
  SuperSiteTargetingConfig: ISuperSiteTargetingObject[];
  SuperSiteTargetingLogicOperator: ESuperSiteTargetingLogicOperator;
  SubSites: ISite[];
  siteList: IMenuList;
  paramList: IMenuList;
  startingTab: number;
  newTab?: number;
  PublicaVaultEnabled: EBool;
  PublicaVaultUseDefault: EBool;
  EnableFallbackAds: EBool;
  FallbackAdsAdditionalAds: number;
  FallBackAdsEnableDurationOfPod: EBool;
  FallbackAdsMode: EFallbackAdsMode;
  BidSaverConfig: IBidSaverConfig;
  // Privacy
  SetCoppaToOne: EBool;
  // AB Testing
  currentlyWritingABTest: boolean;
  triggerTestLaunch: boolean;
  Route?: IInventoryRoute;
  // endpoint request scorecard
  endpointScorecardLevel1Scores: { [key: string]: number };
  endpointScorecardLevel2Scores: { [key: string]: number };
  endpointScorecardLevel3Scores: { [key: string]: number };
  endpointScorecardLevel4Scores: { [key: string]: number };
  endpointScorecardLevel5Scores: { [key: string]: number };
  CountRequestHasAppBundle: number;

  // Inventory Routing
  publisherCountryGroups: ICountryGroup[];
  fetchedPublisherCountryGroups: boolean;

  // bulk update
  isBulkUpdate: boolean; // are we bulk updating
  bulkUpdateChannelIDs: number[]; // IDs of the channels being bulk updated
  fieldsSelectedForBulkUpdate: Map<keyof IState, void>; // state name of the fields selected to be bulk updated
  bulkUpdateReverseFieldDependency: Map<keyof IState, Array<keyof IState>>; // reverse of BulkUpdateFieldDependency, we go from the dependant field to the main one
  openBulkUpdateSavePopup: boolean; // do we open the popup to confirm the changes and save them

  EnablePublicaVPAID: EBool;

  // Measurement
  EnableIASFirstPartyVASTTracking: EBool;
  MeasurementPercentage: number;
  EnableDynamicMeasurementStrategy: EBool;

  // Managed Platform Connection
  ReturnGrossCPMInResponse: EBool;

  // Schain Fields
  EnableAddSchainToBidRequest: EBool;
  SchainASI: string;
  SchainSID: string;
  SchainName: string;
  SchainDomain: string;
  SchainComplete: number;

  // Contextual API calls Enabling
  ComscoreSignalEnabled: number;

  // Deal Floor Overwrites
  // AllowBidsBelowDealFloor:
  // 0 => Do not allow
  // 1 => Allow by value
  // 2 => Allow by percentage
  // BidsBelowDealFloorIsAllowed is not a part of the site struct, but determined by the value of AllowBidsBelowDealFloor
  // if AllowBidsBelowDealFloor === 0 BidsBelowDealFloorIsAllowed = EBool.EBool_False : BidsBelowDealFloorIsAllowed = EBool.EBool_True
  BidsBelowDealFloorIsAllowed: EBool;
  AllowBidsBelowDealFloor: AllowBidsBelowDealFloorType;
  AllowBidsBelowDealFloorValue: number;
  EnableSecondaryRequests: EBool;
  EnableSecondaryRequestPercentage: number;
  EnableSecondaryRequestTimeout: number;
  refreshingLiveLogs: boolean;
  refreshingLiveLogsTimestamp: string;

  // Bypass Dedup Config
  BypassDedupConfig: IBypassDedupConfig[];
  bidderOptions: ISelectOption[];
  houseAdsOptions: ISelectOption[];
  loadingBidders: boolean;
  EnforceAuctionCutoff: EBool;
  bypassDedupStateKey: number;
  deleteBypassModelActive: boolean;

  // Creative Quality Assurance
  EnableCreativeQualityAssurance: EBool;
  CreativeQualityAssuranceAudioBitrate: string;
  CreativeQualityAssuranceCodec: string;
  CreativeQualityAssuranceFrameRate: string;
  CreativeQualityAssuranceSamplingFrequency: string;
  CreativeQualityAssuranceVideoBitrate: string;
  CreativeQualityAssuranceVideoFormat: string;
  CreativeQualityAssuranceVideoResolution: string;
  SitePriceExtension: SitePriceExtensionType;

  // manage rewrite input rows,
  // for now just these 5: AppStoreURL, AppNameOverride, AppDomainOverride, AppBundleOverride, AppIDOverride
  rewiteInputRows: Record<RewriteInputRowsKey, Array<IRewriteActiveRow>>;
  appStoreURLs: Array<string>;

  // Samsung EPG Contextual Data
  EnableEPGMetadata: EBool;
  EnableEPGContentDuration: EBool;
  EnableEPGContentGenre: EBool;
  EnableEPGContentLanguage: EBool;
  EnableEPGContentRating: EBool;
  DisableActivationForNonSuperUser: string;

  // Live Context
  LiveContextStreamID: string;
  LiveContextStreamURL: string;
  LiveContextLookbackMinutes: number;
  smartFloorConfigs: IInventorySmartFloorConfigUI[];
  connectedBidders: ISmallBidderSmartFloors[];
  isSmartFloorActive: boolean;
  hasExistingSmartFloorConfig: boolean;
  selectedBidderIDForSmartFloorsChart: number;
}

// EBoolFieldsName contains all the bulk update fields that are registered as 'EBool'.
// We need this because at runtime there is no such type as EBool, all EBool are JavaScript's number type.
// When we display the value of these fields to the user, we need this to convert them back from number to a 'true' or
// 'false' value.
const EBoolFieldsName: Array<keyof IState> = [
  'BrandRecognitionEnabled',
  'HeaderBidderGlobalDedup',
  'BypassDedupByAdAsSeparation',
  'AdIDDedup',
  'CreativeIDDedup',
  'ClickThroughAdomainRecognitionEnabled',
  'BypassDedupByDurationAsSeparation',
  'BypassDedupIfSurroundedByDedupedAds',
  'LanguageDetectionEnabled',
];

// BulkUpdateFieldDependency defines the dependency between the bulk update checkboxes.
//     | For example 'Max Lookups' is only available if 'Elea AI Recognition' is enabled. If we unselect
//     | 'Elea AI Recognition', then we also need to make sure that 'Max Lookups' is unselected too.
// This is defined as a map of string to a list of string. The key of the map is the 'main field', the one from which
// other fields depends. The list of string contains all the dependant fields, the fields that need to be unchecked if
// the main field gets unchecked.
const BulkUpdateFieldDependency = new Map<keyof IState, string[]>([
  // Elea AI Recognition
  ['BrandRecognitionEnabled', ['BrandRecognitionLimit', 'BrandRecognitionLimitUnit']],
  // Enforce Unique Mediafile
  [
    'HeaderBidderDedup',
    [
      'BypassDedupOptions',
      'BypassDedupByAdAsSeparation',
      'BypassDedupByDurationAsSeparation',
      'BypassDedupIfSurroundedByDedupedAds',
      'HeaderBidderGlobalDedup',
    ],
  ],
  // Enforce Unique Advertiser Domain
  [
    'HeaderBidderDedupAdomain',
    [
      'BypassDedupOptions',
      'BypassDedupByAdAsSeparation',
      'BypassDedupByDurationAsSeparation',
      'BypassDedupIfSurroundedByDedupedAds',
      'HeaderBidderGlobalDedup',
    ],
  ],
  // Enforce Unique IAB Category
  [
    'HeaderBidderDedupCategory',
    [
      'BypassDedupOptions',
      'BypassDedupByAdAsSeparation',
      'BypassDedupByDurationAsSeparation',
      'BypassDedupIfSurroundedByDedupedAds',
      'HeaderBidderGlobalDedup',
    ],
  ],
  // Allow if separated by one ad
  ['BypassDedupByAdAsSeparation', ['BypassDedupAdCount']],
  // Allow if separated by specified duration
  ['BypassDedupByDurationAsSeparation', ['BypassDedupDuration']],
  // Enforce Unique APS Key
  ['HeaderBidderDedupAPSKey', ['HeaderBidderGlobalDedup']],
  // Enforce Unique Ad ID
  ['AdIDDedup', ['HeaderBidderGlobalDedup']],
  // Enforce Unique Creative ID
  ['CreativeIDDedup', ['HeaderBidderGlobalDedup']],
  // Session-Level Deduplication
  ['HeaderBidderGlobalDedup', ['HeaderBidderGlobalDedupExpiration']],
]);

type siteDataType = 'boolean' | 'EBool';

interface ISiteSwitch {
  name: string;
  stateName: keyof IState;
  dataType: siteDataType;
  tooltipText?: string | React.ReactNode;
  isBeta?: boolean | undefined;
}

interface IBypassDedupConfigSwitch {
  name: string;
  dataType: siteDataType;
  tooltipText?: string;
  stateNameBypassDedup: keyof IBypassDedupConfig;
}

const HeaderBidderDeliveryTypes = [
  {
    label: 'CTV',
    value: 'CTV',
  },
  {
    label: 'App',
    value: 'App',
  },
  {
    label: 'Web',
    value: 'Web',
  },
];

const HeaderBidderVastVersions = [
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '4.1',
    value: '4.1',
  },
];

const AdCountNeededToBypassDedup = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
  {
    label: '5',
    value: '5',
  },
];

const DurationsNeededToBypassDedup = [
  {
    label: '15 Seconds',
    value: '15',
  },
  {
    label: '30 Seconds',
    value: '30',
  },
  {
    label: '60 Seconds',
    value: '60',
  },
];

const FallbackAdsModeValues = [
  {
    label: 'Additional Ads',
    value: EFallbackAdsMode.FALLBACK_ADS_MODE_ADDITIONAL_ADS.toString(),
  },
  {
    label: 'Duration of Pod',
    value: EFallbackAdsMode.FALLBACK_ADS_MODE_DURATION_OF_POD.toString(),
  },
  {
    label: 'Duration of Ads',
    value: EFallbackAdsMode.FALLBACK_ADS_MODE_DURATION_OF_ADS.toString(),
  },
];

const CombineCreativesMaxValues = [
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
];

const CombineCreativesPriorityValues = [
  {
    label: '10 (High)',
    value: '10',
  },
  {
    label: '1 (Normal)',
    value: '1',
  },
];

const FallbackAdsNumberOfAdsValues = [
  { label: 'None', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
  { label: '15', value: '15' },
  { label: '16', value: '16' },
  { label: '17', value: '17' },
  { label: '18', value: '18' },
  { label: '19', value: '19' },
  { label: '20', value: '20' },
];

const RegionMap: { [key: string]: string } = {
  Europe: 'eu-west-1',
  USA: 'us-east-1',
  APAC: 'ap-southeast-2',
  Japan: 'ap-northeast-1',
};

const RegionIndexMap: { [key: string]: string } = {
  'eu-west-1': EUROPE,
  'us-east-1': USA,
  'ap-southeast-2': APAC,
  'ap-northeast-1': JAPAN,
};

const PublicaVaultTTLs = [
  {
    label: '15 Minutes',
    id: 15,
  },
  {
    label: '30 Minutes',
    id: 30,
  },
  {
    label: '45 Minutes',
    id: 45,
  },
  {
    label: '1 Hour',
    id: 60,
  },
];

export const AppOverrideKeys = [
  'All',
  'AirTV',
  'Amazon',
  'Apple',
  'ATT',
  'Bravia',
  'Chromecast',
  'Comcast',
  'Dish',
  'Generic',
  'Google',
  'Hisense',
  'Huawei',
  'LG',
  'Nvidia',
  'Panasonic',
  'Philips',
  'Playstation',
  'Plex',
  'Roku',
  'Samsung',
  'Sanyo',
  'Sharp',
  'SkyQ',
  'TCL',
  'TIVO',
  'Vizio',
  'Web',
  'Xbox',
  'Xiaomi',
].sort();

const contentOverrideRowsMap: { [key: string]: string } = {
  DistribName: 'Distributor Name',
  Channel: 'Channel',
  Network: 'Network',
  Series: 'Series',
  Title: 'Title',
  Category: 'Category',
  Genre: 'Genre',
  Rating: 'Rating',
  Prodqual: 'Prodqual',
  ProducerID: 'Producer ID',
  ProducerName: 'Producer Name',
  Keywords: 'Keywords',
  Language: 'Language',
  ID: 'ID',
  Season: 'Season',
};

// Defines the list of params that will NOT be used by the "customize params value" option.
// All parameters with fixed values, which shouldn't be changed by the user, should be inserted here.
const ParamIgnoredByCustomValues = [
  'format',
  'min_ad_duration',
  'max_ad_duration',
  'adserver',
  'site_id',
];

// This function checks if the given parameter value is a macro. It is used by the endpoint params custom value feature
// to detect if the value we are trying to replace is a macro or a user-defined parameter.
// Regex: https://regex101.com/r/loRsMp/1
const isMacroRegex = /^ROKU_.*$|^\[.+\]$|^\{\{.+\}\}$|^%.+%$|^#\{.+\}$|^#e\{.+\}$/m;
function isAMacro(parameterValue: string): boolean {
  return isMacroRegex.test(parameterValue);
}

const validate = validatorFactory({
  AppBundleOverride(val: any): string {
    if (typeof val !== 'object') {
      return 'Invalid app bundle override, please recreate';
    }
    for (const [key, value] of Object.entries(val)) {
      if (!AppOverrideKeys.includes(key)) {
        return 'Invalid key found in app bundle override';
      }
      if (typeof value !== 'string') {
        return 'Please input a valid app bundle override';
      } else {
        if (
          value.includes('\n') ||
          value.includes('\t') ||
          value.includes(',') ||
          value.includes('\r') ||
          value.includes('"') ||
          value.includes("'")
        ) {
          return 'Please ensure that your app bundle override includes no commas, line breaks, tabs, or quotes';
        }
      }
    }
    return '';
  },
  AppNameOverride(val: any): string {
    if (typeof val !== 'object') {
      return 'Invalid app name override, please recreate';
    }
    for (const [key, value] of Object.entries(val)) {
      if (!AppOverrideKeys.includes(key)) {
        return 'Invalid key found in app name override';
      }
      if (typeof value !== 'string') {
        return 'Please input a valid app name override';
      } else {
        if (
          value.includes('\n') ||
          value.includes('\t') ||
          value.includes(',') ||
          value.includes('\r') ||
          value.includes('"') ||
          value.includes("'")
        ) {
          return 'Please ensure that your app bundle override includes no commas, line breaks, tabs, or quotes';
        }
      }
    }
    return '';
  },

  AppStoreURL(val: any): string {
    if (typeof val !== 'object') {
      return 'Invalid app store url, please recreate';
    }
    for (const [key, value] of Object.entries(val)) {
      if (['CreatedAt', 'DeletedAt', 'ID', 'SiteID', 'UpdatedAt'].includes(key)) {
        return '';
      }
      if (!AppOverrideKeys.includes(key)) {
        return 'Invalid key found in app store url';
      }
      if (typeof value !== 'string') {
        return 'Please input a valid app store url';
      }
      if (typeof value === 'string' && value !== '' && !isValidUrl(value)) {
        return 'Please input a valid app store url';
      }
    }
    return '';
  },

  AppDomainOverride(val: any): string {
    if (typeof val !== 'object') {
      return 'Invalid app domain override, please recreate';
    }
    for (const [key, value] of Object.entries(val)) {
      if (!AppOverrideKeys.includes(key)) {
        return 'Invalid key found in app domain override';
      }
      if (typeof value !== 'string') {
        return 'Please input a valid app domain override';
      } else {
        if (
          value.includes('\n') ||
          value.includes('\t') ||
          value.includes(',') ||
          value.includes('\r') ||
          value.includes('"') ||
          value.includes("'")
        ) {
          return 'Please ensure that your app domain override includes no commas, line breaks, tabs, or quotes';
        }
      }
    }
    return '';
  },
  AuctionSplitTimeout(val: any, _key: string, _obj: IObject): string {
    if (_obj.AuctionSplit === EBool.EBool_FALSE) {
      return '';
    }
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer';
    }
    return '';
  },
  HeaderBidderGlobalDedupExpiration(val: any, _key: string, _obj: IObject): string {
    if (_obj.HeaderBidderGlobalDedup === EBool.EBool_FALSE) {
      return '';
    }
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer';
    }
    return '';
  },
  FrequencyLimit(val: any): string {
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer or 0 for default';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer or 0 for default';
    }
    return '';
  },
  FrequencyLimitDuration(val: any): string {
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer or 60 for default';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 1) {
      return 'Please input a positive integer or 60 for default';
    }
    return '';
  },
  MaxAuctionCap(val: any): string {
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer or 0 for default';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer or 0 for default';
    }
    return '';
  },
  MinPodSize(val: any): string {
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer';
    }
    return '';
  },
  MinBitrate(val: any): string {
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer';
    }
    return '';
  },
  MaxBitrate(val: any): string {
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer';
    }
    return '';
  },
  BidFloor(val: any): string {
    if (val === '' || (val !== undefined && isNaN(parseFloat(val)))) {
      return 'Please input a valid decimal';
    }
    const num = parseFloat(val);
    if (val !== undefined && num < 0) {
      return 'Please input a positive value';
    }
    return '';
  },
  BidAdjustmentFactor(val: number): string {
    if (val === undefined || val === null) {
      return '';
    }
    if (val > 2) {
      return 'Bid Adjustment cannot be more than 200%';
    }
    const vString = val.toString();
    if (!!vString && vString.indexOf(',') > -1) {
      return 'Please use . instead of , for decimal';
    } else if (!!vString && isNaN(parseFloat(vString))) {
      return 'Please input a valid decimal';
    }
    return '';
  },
  BidAdjustmentValue(val: number): string {
    // if value is undefined → bypass the check
    if (val === undefined || val === null) {
      return '';
    }
    // check if value is a positive number
    if (val < 0) {
      return 'Bid Adjustment Value cannot be negative';
    }
    // all test passed → OK
    return '';
  },
  PodFloor(val: any): string {
    if (val === '' || (val !== undefined && isNaN(parseFloat(val)))) {
      return 'Please input a valid decimal';
    }
    const num = parseFloat(val);
    if (val !== undefined && num < 0 && num !== -1) {
      return 'Please input a positive value or a value of -1 (default)';
    }
    return '';
  },
  SiteDomainOverride(val: any): string {
    if (typeof val !== 'object') {
      return 'Invalid site domain override, please recreate';
    }
    for (const [key, value] of Object.entries(val)) {
      if (key !== 'Web') {
        return 'Invalid key found in site domain override';
      }
      if (typeof value !== 'string') {
        return 'Please input a valid site domain override';
      } else {
        if (
          value.includes('\n') ||
          value.includes('\t') ||
          value.includes(',') ||
          value.includes('\r') ||
          value.includes('"') ||
          value.includes("'")
        ) {
          return 'Please ensure that your site domain override includes no commas, line breaks, tabs, or quotes';
        }
      }
    }
    return '';
  },
  SiteNameOverride(val: any): string {
    if (typeof val !== 'object') {
      return 'Invalid site domain override, please recreate';
    }
    for (const [key, value] of Object.entries(val)) {
      if (key !== 'Web') {
        return 'Invalid key found in site domain override';
      }
      if (typeof value !== 'string') {
        return 'Please input a valid site domain override';
      } else {
        if (
          value.includes('\n') ||
          value.includes('\t') ||
          value.includes(',') ||
          value.includes('\r') ||
          value.includes('"') ||
          value.includes("'")
        ) {
          return 'Please ensure that your site name override includes no commas, line breaks, tabs, or quotes';
        }
      }
    }
    return '';
  },
  SiteName(val: any): string {
    if (!val) {
      return 'Name cannot be empty';
    } else {
      return '';
    }
  },
  BidSaverConfig(bidSaverConfig: IBidSaverConfig, _key: string, state: IState): string {
    if (EBool.isTrue(state.PublicaVaultEnabled) && bidSaverConfig.TTL <= 0) {
      return 'Publica Vault TTL must be greater than 0';
    }

    if (
      bidSaverConfig.StoreBelowFloorBids === true &&
      bidSaverConfig.MaxUnderFloorValue !== undefined
    ) {
      // check if value is a positive number
      if (bidSaverConfig.MaxUnderFloorValue < 0) {
        return MaxUnderFloorError.Zero;
      }
      if (
        bidSaverConfig.MaxUnderFloorType === MaxUnderFloorType.Percent &&
        bidSaverConfig.MaxUnderFloorValue > 50
      ) {
        return MaxUnderFloorError.Fifty;
      }
    }

    return '';
  },
  SchainASI(val: string, _key: string, state: IState): string {
    if (state.EnableAddSchainToBidRequest === EBool.EBool_TRUE && val === '') {
      return 'Schain ASI must be provided to enable adding schain to bid request';
    }

    return '';
  },
  SchainSID(val: string, _key: string, state: IState): string {
    if (state.EnableAddSchainToBidRequest === EBool.EBool_TRUE && val === '') {
      return 'Schain SID must be provided to enable adding schain to bid request';
    }
    return '';
  },
  MeasurementPercentage(val: number): string {
    if (val === undefined || val === null) {
      return '';
    }
    if (val > 1) {
      return 'Measurement Percentage cannot be more than 100%';
    }
    if (val <= 0) {
      return 'Measurement Percentage cannot be less than or equal to 0%';
    }
    const vString = val.toString();
    if (!!vString && vString.indexOf(',') > -1) {
      return 'Please use . instead of , for decimal';
    } else if (!!vString && isNaN(parseFloat(vString))) {
      return 'Please input a valid decimal';
    }
    return '';
  },
  PodDurationOverride(val: any, _key: string, _obj: IObject): string {
    if (_obj.PodDurationOverrideEnabled === EBool.EBool_FALSE) {
      return '';
    }
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer';
    }
    return '';
  },
  EnableSecondaryRequestPercentage(val: any, _key: string, _obj: IObject): string {
    if (_obj.EnableSecondaryRequests === EBool.EBool_FALSE) {
      return '';
    }
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer';
    }
    if (num !== undefined && num > 100) {
      return 'Please input a positive integer less than or equal to 100';
    }
    return '';
  },
  EnableSecondaryRequestTimeout(val: any, _key: string, _obj: IObject): string {
    if (_obj.EnableSecondaryRequests === EBool.EBool_FALSE) {
      return '';
    }
    if (val === '' || (val !== undefined && !Number.isInteger(Number(val)))) {
      return 'Please input a positive integer';
    }
    const num = parseInt(val, 10);
    if (num !== undefined && num < 0) {
      return 'Please input a positive integer';
    }
    if (num !== undefined && num > 2000) {
      return 'Please input a positive integer less than or equal to 800';
    }
    return '';
  },
});

export const SiteSettingsListView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      notPaper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
      },
      textField: {
        margin: 0,
        minWidth: '400px',
        width: '30%',
      },
      button: {
        marginRight: theme.spacing(1),
      },
      strong: {
        fontWeight: 'bolder',
        fontSize: '1rem',
      },
      drawerPaper: {
        width: '80%',
      },
      clipboard: {
        display: 'block',
        height: '200px',
        width: '800px',
        padding: '9.5px',
        margin: '0 0 10px',
        lineHeight: '1.42857143',
        color: '#99A1AE',
        backgroundColor: '#F5F5F5',
        border: '1px solid #CCC',
        borderRadius: '4px',
        fontFamily: 'Monosten-C',
        fontSize: '13px',
        whiteSpace: 'pre-wrap',
      },
      inputInfoIcon: {
        verticalAlign: 'center',
        width: '1rem',
        color: '#929599',
        paddingTop: 10,
      },
      mainGridItem: {
        marginTop: 24,
        marginBottom: 96,
        width: '100%',
      },
      optionRow: {
        width: 400,
        marginTop: 12,
        marginBottom: 12,
      },
      optionRowWide: {
        width: 465,
        marginTop: 12,
        marginBottom: 12,
      },
      optionRowIndented: {
        width: 340,
        marginLeft: 59,
        marginBottom: 12,
      },
      optionRowWideIndented: {
        width: 400,
        marginLeft: 59,
        marginBottom: 12,
      },
      singleSelectWithToolTip: {
        width: 390,
        display: 'inline-block',
      },
      typographyTitle: {
        marginTop: 15,
        marginBottom: 15,
        fontSize: 14,
        fontWeight: 500,
      },
      typographyNonTitle: {
        fontSize: 12,
        fontWeight: 400,
      },
      // style for the bulk update sidebar
      headingCategoryTitle: {
        fontSize: '21px',
        fontWeight: 500,
        color: '$434343',
        marginBottom: 5,
      },
      insideAccordionText: {
        fontSize: '16px',
        fontWeight: 400,
        color: '$434343',
      },
      headingCategorySubTitle: {
        fontSize: '18px',
        fontWeight: 500,
        color: '$434343',
        marginTop: 10,
      },
      checkbox: {
        transform: 'scale(0.8)',
        padding: 3,
      },
      insideAccordionTextBold: {
        fontSize: '13px',
        fontWeight: 500,
        color: '$434343',
      },
      insideAccordionValue: {
        fontSize: '13px',
        fontWeight: 400,
        color: '$434343',
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    isValidPrice = (price: number): boolean => {
      if (price <= 0) {
        return false;
      }
      const strPrice = String(price);
      const idx = strPrice.indexOf('.');
      if (idx > -1) {
        return strPrice.length - idx - 1 <= 3;
      }
      return true;
    };

    validateInventorySmartFloorConfig = (): Record<string, string> => {
      const { smartFloorConfigs, isSmartFloorActive } = this.state;
      const errors: Record<string, string> = {};

      if (!isSmartFloorActive) {
        return errors;
      }

      smartFloorConfigs.forEach(
        ({ InventorySmartFloors, MinBidFloor, MaxBidFloor, TestIncrement, FallBackBaseFloor }) => {
          if (!this.isValidPrice(MinBidFloor)) {
            errors.MinBidFloor = ct('BiddersErrorInputValidPriceForMinBidFloor');
          } else if (!this.isValidPrice(MaxBidFloor)) {
            errors.MaxBidFloor = ct('BiddersErrorInputValidPriceForMaxBidFloor');
          } else if (!this.isValidPrice(TestIncrement)) {
            errors.TestIncrement = ct('BiddersErrorInputValidPriceForTestIncrementHigh');
          } else if (!this.isValidPrice(FallBackBaseFloor)) {
            errors.FallBackBaseFloor = ct('BiddersErrorInputValidPriceForDefaultControlBidFloor');
          }

          InventorySmartFloors.forEach(
            ({
              ControlBidFloor,
              MaxBidFloor: maxBidFloor,
              MinBidFloor: minBidFloor,
              TestIncrement: testIncrement,
              HeaderbidderID,
            }) => {
              if (!this.isValidPrice(ControlBidFloor)) {
                errors.ControlBidFloor = ct('BiddersErrorInputValidPriceForBaseBidFloorForSiteID', {
                  id: HeaderbidderID,
                });
              } else if (!this.isValidPrice(maxBidFloor)) {
                errors.MaxBidFloor = ct('BiddersErrorInputValidPriceForMaxBidFloorForSiteID', {
                  id: HeaderbidderID,
                });
              } else if (!this.isValidPrice(minBidFloor)) {
                errors.MinBidFloor = ct('BiddersErrorInputValidPriceForMinBidFloorForSiteID', {
                  id: HeaderbidderID,
                });
              } else if (!this.isValidPrice(testIncrement)) {
                errors.TestIncrement = ct('BiddersErrorInputValidPriceForTestIncrementForSiteID', {
                  id: HeaderbidderID,
                });
              } else if (ControlBidFloor > maxBidFloor) {
                errors.TestIncrementCalculation = ct(
                  'BiddersErrorBaseExceedsMaxBidFloorForSiteID',
                  { id: HeaderbidderID },
                );
              } else if (ControlBidFloor < minBidFloor) {
                errors.TestIncrementCalculation = ct(
                  'BiddersErrorBaseIsBelowMinBidFloorForSiteID',
                  { id: HeaderbidderID },
                );
              }
            },
          );
        },
      );

      return errors;
    };

    _updateSite = debounce(() => {
      if (!this.props.session.site) {
        return;
      }
      if (this.state.updating) {
        return;
      }
      const { channel } = parseLocation(this.props.location.pathname);
      const sessionSiteID = (this.props.session.site || { ID: 0 }).ID;
      if (Number(channel) !== sessionSiteID) {
        this.setState({
          snackbarMessage: 'An error has occurred. Please reload.',
          snackbarError: true,
          snackbarWarning: false,
          updating: false,
        });
        return;
      }

      const smartFloorErrors = this.validateInventorySmartFloorConfig();
      for (const err in smartFloorErrors) {
        if (smartFloorErrors[err].length > 0) {
          this.setState({
            snackbarMessage: ct('SnackbarPleaseFixErrorsBeforeSavingItemWithReasons', {
              item: ct('SmartFloors'),
              text: smartFloorErrors[err],
            }),
            snackbarError: true,
            snackbarWarning: false,
          });
          return;
        }
      }

      this.setState(
        {
          updating: true,
        },
        () => {
          const channelLabels = this.getChannelLabelAddList();
          for (const label of channelLabels) {
            label.Sites = [];
          }
          const updateSitePromise = updateSite({
            // NOTE: keep these fields ordered same as on UI in page
            query: {
              publisher_id: this.props.session.publisher.ID,
              site_id: sessionSiteID,
              AppStoreURL: this.state.AppStoreURL,
            },
            body: {
              site: {
                Active: this.state.Active,
                // super user top bar
                HeaderBidderEndpointTimeout: this.state.Timeout,
                DebugHeaderBidder: this.state.DebugHeaderBidder,
                DebugHeaderBidderEnabledUntil: this.state.DebugHeaderBidderEnabledUntil,
                SamplingPercentageDisabledUntil: this.state.SamplingPercentageDisabledUntil,
                SamplingPercentageRequests: this.state.SamplingPercentageRequests,
                // roku only
                RokuProviderChannelIDStr: this.state.RokuProviderChannelIDStr,
                // channel settings
                Name: this.state.SiteName,
                ChannelLabels: channelLabels,
                MinPodSize: this.state.MinPodSize,
                DefaultWeight: this.state.DefaultWeight,
                PodFloor: this.state.PodFloor,
                RejectPodsWithAllHouseAds: this.state.RejectPodsWithAllHouseAds,
                RejectNonsecureVAST: this.state.RejectNonsecureVAST,
                EnableXMLCommentWrites: this.state.EnableXMLCommentWrites,
                Region: RegionMap[this.state.Region],
                HeaderBidderDeliveryType:
                  HeaderBidderDeliveryTypesMap[this.state.HeaderBidderDeliveryType],
                HeaderBidderVastVersion: this.state.HeaderBidderVastVersion as any,
                HeaderBidderMimeTypes: this.state.MimeTypes.join(',') as any,
                HeaderBidderWinnerModel: this.state.HeaderBidderWinnerModel,
                FrequencyLimit: this.state.FrequencyLimit,
                FrequencyLimitDuration: this.state.FrequencyLimitDuration,
                UserSyncProviders: this.state.UserSyncProviders,
                MaxAuctionCap: this.state.MaxAuctionCap,
                BidAdjustmentFactor: Number(this.state.BidAdjustmentFactor),
                BidAdjustmentValue: Number(this.state.BidAdjustmentValue),
                BidFloor: this.state.BidFloor,
                CurrencyDisplayed: this.state.CurrencyDisplayed,
                // options section
                MaxBitrate: this.state.MaxBitrate,
                MinBitrate: this.state.MinBitrate,
                CombineCreatives: this.state.CombineCreatives,
                CombineCreativesMax: this.state.CombineCreativesMax as any,
                CombineCreativesPriority: this.state.CombineCreativesPriority as any,
                EnableLiveContext: this.state.EnableLiveContext,
                LiveContextStreamID: this.state.LiveContextStreamID,
                LiveContextStreamURL: this.state.LiveContextStreamURL,
                LiveContextLookbackMinutes: this.state.LiveContextLookbackMinutes,
                HeaderBidderEnforceAdomain: this.state.HeaderBidderEnforceAdomain,
                HeaderBidderDedup: this.state.HeaderBidderDedup,
                HeaderBidderDedupAdomain: this.state.HeaderBidderDedupAdomain,
                HeaderBidderDedupAPSKey: this.state.HeaderBidderDedupAPSKey,
                HeaderBidderDedupCategory: this.state.HeaderBidderDedupCategory,
                AdIDDedup: this.state.AdIDDedup,
                CreativeIDDedup: this.state.CreativeIDDedup,
                ClickThroughAdomainRecognitionEnabled:
                  this.state.ClickThroughAdomainRecognitionEnabled,
                BrandRecognitionEnabled: this.state.BrandRecognitionEnabled,
                BrandRecognitionLimit: this.state.BrandRecognitionLimit,
                BrandRecognitionLimitUnit: this.state.BrandRecognitionLimitUnit,
                MachineLearningForMaxAuctionsEnabled:
                  this.state.MachineLearningForMaxAuctionsEnabled,
                WebShrinkerCategoryEnabled: this.state.WebShrinkerCategoryEnabled,
                ServerSideTrackersEnabled: this.state.ServerSideTrackersEnabled,
                DDMonitoring: this.state.DDMonitoring,
                EnableHlsTranscoder: this.state.EnableHlsTranscoder,
                HeaderBidderSingleAuction: this.state.HeaderBidderSingleAuction,
                HeaderBidderEnforceSlotTargeting: this.state.HeaderBidderEnforceSlotTargeting,
                HonorSequenceOrder: this.state.HonorSequenceOrder,
                AuctionSplit: this.state.AuctionSplit,
                AuctionSplitTimeout: this.state.AuctionSplitTimeout,
                PodDurationOverrideEnabled: this.state.PodDurationOverrideEnabled,
                PodDurationOverride: this.state.PodDurationOverride,
                HeaderBidderGlobalDedup: this.state.HeaderBidderGlobalDedup,
                HeaderBidderGlobalDedupExpiration: this.state.HeaderBidderGlobalDedupExpiration,
                // endpoint url builder
                EndpointURLParams: JSON.stringify(parseEndpointURL(this.state.EndpointURL)),
                // rewrites/overrides
                AppStoreUrlOverrideIfEmpty: this.state.AppStoreUrlOverrideIfEmpty,
                AppBundleOverride: this.state.AppBundleOverride,
                AppBundleOverrideIfEmpty: this.state.AppBundleOverrideIfEmpty,
                AppIDOverride: this.state.AppIDOverride,
                AppIDOverrideIfEmpty: this.state.AppIDOverrideIfEmpty,
                AppNameOverride: this.state.AppNameOverride,
                AppNameOverrideIfEmpty: this.state.AppNameOverrideIfEmpty,
                AppDomainOverride: this.state.AppDomainOverride,
                AppDomainOverrideIfEmpty: this.state.AppDomainOverrideIfEmpty,
                AppCatOverride: this.state.AppCatOverride,
                AppCatOverrideIfEmpty:
                  this.state.AppCatOverrideIfEmpty === EBool.EBool_UNKNOWN
                    ? EBool.EBool_FALSE
                    : this.state.AppCatOverrideIfEmpty,
                SiteDomainOverride: this.state.SiteDomainOverride,
                SiteDomainOverrideIfEmpty:
                  this.state.SiteDomainOverrideIfEmpty === EBool.EBool_UNKNOWN
                    ? EBool.EBool_FALSE
                    : this.state.SiteDomainOverrideIfEmpty,
                SiteNameOverride: this.state.SiteNameOverride,
                ContentDistribNameOverride: this.state.ContentDistribNameOverride,
                ContentDistribNameOverrideIfEmpty: this.state.ContentDistribNameOverrideIfEmpty,
                ContentChannelOverride: this.state.ContentChannelOverride,
                ContentChannelOverrideIfEmpty: this.state.ContentChannelOverrideIfEmpty,
                ContentNetworkOverride: this.state.ContentNetworkOverride,
                ContentNetworkOverrideIfEmpty: this.state.ContentNetworkOverrideIfEmpty,
                ContentSeriesOverride: this.state.ContentSeriesOverride,
                ContentSeriesOverrideIfEmpty: this.state.ContentSeriesOverrideIfEmpty,
                ContentTitleOverride: this.state.ContentTitleOverride,
                ContentTitleOverrideIfEmpty: this.state.ContentTitleOverrideIfEmpty,
                ContentCategoryOverride: this.state.ContentCategoryOverride,
                ContentCategoryOverrideIfEmpty: this.state.ContentCategoryOverrideIfEmpty,
                ContentGenreOverride: this.state.ContentGenreOverride,
                ContentGenreOverrideIfEmpty: this.state.ContentGenreOverrideIfEmpty,
                ContentRatingOverride: this.state.ContentRatingOverride,
                ContentRatingOverrideIfEmpty: this.state.ContentRatingOverrideIfEmpty,
                ContentProdqualOverride: this.state.ContentProdqualOverride,
                ContentProdqualOverrideIfEmpty: this.state.ContentProdqualOverrideIfEmpty,
                ContentProducerNameOverride: this.state.ContentProducerNameOverride,
                ContentProducerNameOverrideIfEmpty: this.state.ContentProducerNameOverrideIfEmpty,
                ContentProducerIDOverride: this.state.ContentProducerIDOverride,
                ContentProducerIDOverrideIfEmpty: this.state.ContentProducerIDOverrideIfEmpty,
                ContentKeywordsOverride: this.state.ContentKeywordsOverride,
                ContentKeywordsOverrideIfEmpty: this.state.ContentKeywordsOverrideIfEmpty,
                ContentLanguageOverride: this.state.ContentLanguageOverride,
                ContentLanguageOverrideIfEmpty: this.state.ContentLanguageOverrideIfEmpty,
                ContentIDOverride: this.state.ContentIDOverride,
                ContentIDOverrideIfEmpty: this.state.ContentIDOverrideIfEmpty,
                ContentSeasonOverride: this.state.ContentSeasonOverride,
                ContentSeasonOverrideIfEmpty: this.state.ContentSeasonOverrideIfEmpty,
                RemoveContentFromEndpointRequest: this.state.RemoveContentFromEndpointRequest,
                RemoveContentChannelFromEndpointRequest:
                  this.state.RemoveContentChannelFromEndpointRequest,
                RemoveContentNetworkFromEndpointRequest:
                  this.state.RemoveContentNetworkFromEndpointRequest,
                RemoveContentSeriesFromEndpointRequest:
                  this.state.RemoveContentSeriesFromEndpointRequest,
                RemoveContentTitleFromEndpointRequest:
                  this.state.RemoveContentTitleFromEndpointRequest,
                RemoveContentGenreFromEndpointRequest:
                  this.state.RemoveContentGenreFromEndpointRequest,
                RemoveContentDistribNameFromEndpointRequest:
                  this.state.RemoveContentDistribNameFromEndpointRequest,
                RemoveContentRatingFromEndpointRequest:
                  this.state.RemoveContentRatingFromEndpointRequest,
                RemoveContentProdqualFromEndpointRequest:
                  this.state.RemoveContentProdqualFromEndpointRequest,
                RemoveContentProducerNameFromEndpointRequest:
                  this.state.RemoveContentProducerNameFromEndpointRequest,
                RemoveContentProducerIDFromEndpointRequest:
                  this.state.RemoveContentProducerIDFromEndpointRequest,
                RemoveContentKeywordsFromEndpointRequest:
                  this.state.RemoveContentKeywordsFromEndpointRequest,
                RemoveContentLanguageFromEndpointRequest:
                  this.state.RemoveContentLanguageFromEndpointRequest,
                RemoveContentCategoryFromEndpointRequest:
                  this.state.RemoveContentCategoryFromEndpointRequest,
                RemoveContentIDFromEndpointRequest: this.state.RemoveContentIDFromEndpointRequest,
                RemoveContentSeasonFromEndpointRequest:
                  this.state.RemoveContentSeasonFromEndpointRequest,
                AnonymizeDeviceID: this.state.AnonymizeDeviceID,
                AnonymizeIP: this.state.AnonymizeIP,
                EndpointDealIDPassthroughActive: this.state.EndpointDealIDPassthroughActive,
                MinAdDurationOverride: this.state.MinAdDurationOverride,
                MaxAdDurationOverride: this.state.MaxAdDurationOverride,
                StartDelayOverride: startDelayOverrideIsEmpty(this.state.StartDelayOverride)
                  ? EStartDelay.StartDelay_UnknownNotSet
                  : this.state.StartDelayOverride,
                ClearDefaultBitrateLimits: this.state.ClearDefaultBitrateLimits,
                Skip: this.state.Skip,
                SkipMin: this.state.SkipMin,
                SkipAfter: this.state.SkipAfter,
                InventoryPartnerDomainOverride: this.state.InventoryPartnerDomainOverride,
                InventoryPartnerDomainOverrideIfEmpty:
                  this.state.InventoryPartnerDomainOverrideIfEmpty === EBool.EBool_UNKNOWN
                    ? EBool.EBool_FALSE
                    : this.state.InventoryPartnerDomainOverrideIfEmpty,
                // content postbid overrides
                ContentDistribNamePostBidOverride: this.state.ContentDistribNamePostBidOverride,
                ContentDistribNamePostBidOverrideIfEmpty:
                  this.state.ContentDistribNamePostBidOverrideIfEmpty,
                ContentChannelPostBidOverride: this.state.ContentChannelPostBidOverride,
                ContentChannelPostBidOverrideIfEmpty:
                  this.state.ContentChannelPostBidOverrideIfEmpty,
                ContentNetworkPostBidOverride: this.state.ContentNetworkPostBidOverride,
                ContentNetworkPostBidOverrideIfEmpty:
                  this.state.ContentNetworkPostBidOverrideIfEmpty,
                ContentSeriesPostBidOverride: this.state.ContentSeriesPostBidOverride,
                ContentSeriesPostBidOverrideIfEmpty: this.state.ContentSeriesPostBidOverrideIfEmpty,
                ContentTitlePostBidOverride: this.state.ContentTitlePostBidOverride,
                ContentTitlePostBidOverrideIfEmpty: this.state.ContentTitlePostBidOverrideIfEmpty,
                ContentCategoryPostBidOverride: this.state.ContentCategoryPostBidOverride,
                ContentCategoryPostBidOverrideIfEmpty:
                  this.state.ContentCategoryPostBidOverrideIfEmpty,
                ContentGenrePostBidOverride: this.state.ContentGenrePostBidOverride,
                ContentGenrePostBidOverrideIfEmpty: this.state.ContentGenrePostBidOverrideIfEmpty,
                ContentRatingPostBidOverride: this.state.ContentRatingPostBidOverride,
                ContentRatingPostBidOverrideIfEmpty: this.state.ContentRatingPostBidOverrideIfEmpty,
                ContentProdqualPostBidOverride: this.state.ContentProdqualPostBidOverride,
                ContentProdqualPostBidOverrideIfEmpty:
                  this.state.ContentProdqualPostBidOverrideIfEmpty,
                ContentProducerNamePostBidOverride: this.state.ContentProducerNamePostBidOverride,
                ContentProducerNamePostBidOverrideIfEmpty:
                  this.state.ContentProducerNamePostBidOverrideIfEmpty,
                ContentProducerIDPostBidOverride: this.state.ContentProducerIDPostBidOverride,
                ContentProducerIDPostBidOverrideIfEmpty:
                  this.state.ContentProducerIDPostBidOverrideIfEmpty,
                ContentKeywordsPostBidOverride: this.state.ContentKeywordsPostBidOverride,
                ContentKeywordsPostBidOverrideIfEmpty:
                  this.state.ContentKeywordsPostBidOverrideIfEmpty,
                ContentLanguagePostBidOverride: this.state.ContentLanguagePostBidOverride,
                ContentLanguagePostBidOverrideIfEmpty:
                  this.state.ContentLanguagePostBidOverrideIfEmpty,
                SuperSiteID: this.state.SuperSiteID,
                SuperSiteTargeting: this.state.SuperSiteTargeting,
                SuperSiteTargetingType: this.state.SuperSiteTargetingType,
                SuperSiteTargetingConfig: this.state.SuperSiteTargetingConfig,
                SuperSiteTargetingLogicOperator: this.state.SuperSiteTargetingLogicOperator,
                SetCoppaToOne: this.state.SetCoppaToOne,
                PublicaVaultEnabled: this.state.PublicaVaultEnabled,
                PublicaVaultUseDefault: this.state.PublicaVaultUseDefault,
                PublicaVaultConfig:
                  this.state.PublicaVaultEnabled === EBool.EBool_TRUE
                    ? this.state.BidSaverConfig
                    : { TTL: 0 },
                PublicaVaultExcludedBidderIDs: this.state.PublicaVaultExcludedBidderIDs,
                PublicaVaultExcludedDemandSources: this.state.PublicaVaultExcludedDemandSources,
                EnablePublicaVPAID: this.state.EnablePublicaVPAID,
                EnableFallbackAds: this.state.EnableFallbackAds,
                FallbackAdsAdditionalAds: this.state.FallbackAdsAdditionalAds,
                FallBackAdsEnableDurationOfPod: this.state.FallBackAdsEnableDurationOfPod,
                FallbackAdsMode: this.state.FallbackAdsMode,
                EnableIASFirstPartyVASTTracking: this.state.EnableIASFirstPartyVASTTracking,
                MeasurementPercentage: Number(this.state.MeasurementPercentage),
                EnableDynamicMeasurementStrategy: this.state.EnableDynamicMeasurementStrategy,
                ReturnGrossCPMInResponse: this.state.ReturnGrossCPMInResponse,
                EnableAddSchainToBidRequest: this.state.EnableAddSchainToBidRequest,
                SchainASI: this.state.SchainASI,
                SchainSID: this.state.SchainSID,
                SchainName: this.state.SchainName,
                SchainDomain: this.state.SchainDomain,
                SchainComplete: this.state.SchainComplete,
                ComscoreSignalEnabled: this.state.ComscoreSignalEnabled,
                AllowBidsBelowDealFloor: this.state.AllowBidsBelowDealFloor,
                AllowBidsBelowDealFloorValue: this.state.AllowBidsBelowDealFloorValue,
                LanguageDetectionEnabled: this.state.LanguageDetectionEnabled,
                EnableSecondaryRequests: this.state.EnableSecondaryRequests,
                EnableSecondaryRequestPercentage: this.state.EnableSecondaryRequestPercentage,
                EnableSecondaryRequestTimeout: this.state.EnableSecondaryRequestTimeout,
                EnforceAuctionCutoff: this.state.EnforceAuctionCutoff,
                EnableCreativeQualityAssurance: this.state.EnableCreativeQualityAssurance,
                CreativeQualityAssuranceAudioBitrate:
                  this.state.CreativeQualityAssuranceAudioBitrate,
                CreativeQualityAssuranceCodec: this.state.CreativeQualityAssuranceCodec,
                CreativeQualityAssuranceFrameRate: this.state.CreativeQualityAssuranceFrameRate,
                CreativeQualityAssuranceSamplingFrequency:
                  this.state.CreativeQualityAssuranceSamplingFrequency,
                CreativeQualityAssuranceVideoBitrate:
                  this.state.CreativeQualityAssuranceVideoBitrate,
                CreativeQualityAssuranceVideoFormat: this.state.CreativeQualityAssuranceVideoFormat,
                CreativeQualityAssuranceVideoResolution:
                  this.state.CreativeQualityAssuranceVideoResolution,
                SitePriceExtension: this.state.SitePriceExtension,
                EnableEPGMetadata: this.state.EnableEPGMetadata,
                EnableEPGContentDuration: this.state.EnableEPGContentDuration,
                EnableEPGContentGenre: this.state.EnableEPGContentGenre,
                EnableEPGContentLanguage: this.state.EnableEPGContentLanguage,
                EnableEPGContentRating: this.state.EnableEPGContentRating,
                DisableActivationForNonSuperUser: this.state.DisableActivationForNonSuperUser,
              } as Partial<ISite>,
            },
          });
          const updatePriceIncrementsPromise = updatePriceIncrements({
            query: {
              publisher_id: this.props.session.publisher.ID,
              site_uuid: (this.props.session.site || { UUID: '' }).UUID,
              priceincrements: this.state.PriceIncrements,
            },
          });
          const updateBypassDedupConfigPromise = updateBypassDedupConfig({
            query: {
              publisher_id: this.props.session.publisher.ID,
              site_id: this.props.session.site?.ID || 0,
              bypass_dedup_configs: this.state.BypassDedupConfig,
            },
          });

          const promises = [
            updateSitePromise,
            updatePriceIncrementsPromise,
            updateBypassDedupConfigPromise,
          ];

          const shouldCreateSmartFloors =
            !this.state.hasExistingSmartFloorConfig &&
            this.state.isSmartFloorActive &&
            !isEmpty(this.state.smartFloorConfigs[0]?.InventorySmartFloors);

          if (this.state.Active === SiteActiveActive) {
            if (shouldCreateSmartFloors) {
              const createInventorySmartFloorConfigPromise = createInventorySmartFloorConfig(
                this.props.session.publisher.ID,
                String(this.props.session.site?.ID ?? 0),
                this.state.smartFloorConfigs[0],
              );
              promises.push(createInventorySmartFloorConfigPromise);
            } else if (this.state.hasExistingSmartFloorConfig) {
              const updateInventorySmartFloorConfigPromise = updateInventorySmartFloorConfig(
                this.props.session.publisher.ID,
                String(this.props.session.site?.ID ?? 0),
                this.state.smartFloorConfigs[0],
              );
              promises.push(updateInventorySmartFloorConfigPromise);
            }
          }

          Promise.all(promises)
            .then((resp) => {
              this.getChannelLabels();
              const savedSmartFloorConfig =
                shouldCreateSmartFloors || this.state.hasExistingSmartFloorConfig
                  ? (resp[3] as IInventorySmartFloorConfigUI | null | undefined)
                  : undefined;
              if (savedSmartFloorConfig) {
                const bidderIDToName: { [id: number]: string } = {};
                this.state.connectedBidders.forEach((b) => {
                  bidderIDToName[parseInt(b.ID, 10)] = b.Name;
                });
                const enrichedConfig: IInventorySmartFloorConfigUI = {
                  ...savedSmartFloorConfig,
                  shouldAllowSortingTable: true,
                  InventorySmartFloors: savedSmartFloorConfig.InventorySmartFloors.map((sf) => ({
                    ...sf,
                    BidderName: bidderIDToName[sf.HeaderbidderID] ?? sf.BidderName ?? '',
                  })),
                };
                this.setState({
                  smartFloorConfigs: [enrichedConfig],
                  hasExistingSmartFloorConfig: true,
                });
              }
              this.setState({
                snackbarMessage: 'Successfully updated channel settings.',
                snackbarError: false,
                snackbarWarning: false,
                updating: false,
                PriceIncrements: resp[1] as IHeaderBidderPriceIncrement[],
              });
              if (this.props.session.site) {
                const smallSite = {
                  ...this.props.session.site,
                  Active: Number(this.props.session.site.Active),
                } as ISmallSite;
                this.refreshModels(smallSite);
              }
            })
            .catch(() => {
              this.setState({
                snackbarMessage: 'Updating channel setting failed, please try again later.',
                snackbarError: true,
                snackbarWarning: false,
                updating: false,
              });
            });
        },
      );
    });

    state = {
      Active: SiteActiveActive,
      AdBreakType: '',
      AdServer: '',
      AppStoreURL: {} as IDeviceAwareModel,
      AppStoreUrlOverrideIfEmpty: EBool.EBool_TRUE,
      AppBundleOverride: {} as { [key: string]: string },
      AppBundleOverrideIfEmpty: EBool.EBool_FALSE,
      AppIDOverride: {} as { [key: string]: string },
      AppIDOverrideIfEmpty: EBool.EBool_FALSE,
      AppNameOverride: {} as { [key: string]: string },
      AppNameOverrideIfEmpty: EBool.EBool_FALSE,
      AppDomainOverride: {} as { [key: string]: string },
      AppDomainOverrideIfEmpty: EBool.EBool_FALSE,
      AppCatOverride: '',
      AppCatOverrideIfEmpty: EBool.EBool_FALSE,
      SiteDomainOverride: {} as { [key: string]: string },
      SiteDomainOverrideIfEmpty: EBool.EBool_FALSE,
      SiteNameOverride: {} as { [key: string]: string },
      BidAdjustmentFactor: 1,
      BidAdjustmentValue: 0,
      BidFloor: 0,
      CurrencyDisplayed: ECurrencyType.CURRENCY_TYPE_USD,
      BlockedAdomainInput: '',
      campaigns: [],
      DDMonitoring: false,
      defaultPriceIncrement: JSON.stringify(
        [
          { min: 5.0, max: 20.0, increment: 0.25 },
          { min: 20.0, max: 54.0, increment: 0.5 },
        ],
        null,
        2,
      ),
      DefaultWeight: 1,
      EnableHlsTranscoder: EBool.EBool_FALSE,
      endpointBuilderService: getEndpointBuilderService((): string => {
        if (this && this.props && this.props.session && this.props.session.site) {
          return this.props.session.site.ID.toString();
        }
        return '';
      }),
      EndpointMap: {},
      EndpointURL: '',
      readAuthorization: IS_AUTHORIZED(['read_channel'], this.props.user.user),
      writeAuthorization: IS_AUTHORIZED(['write_channel'], this.props.user.user),
      HeaderBidderCacheMedia: false,
      HeaderBidderDedup: false,
      HeaderBidderDedupAPSKey: false,
      HeaderBidderDedupAdomain: false,
      HeaderBidderDedupCategory: false,
      HeaderBidderDeliveryType: 'CTV',
      AllowVPAID: false,
      HeaderBidderEnforceAdomain: false,
      HeaderBidderEnforceSlotTargeting: false,
      HeaderBidderSingleAuction: false,
      HeaderBidderVastVersion: '2',
      HeaderBidderGlobalDedup: 0,
      HeaderBidderGlobalDedupExpiration: 0,
      HeaderBidderWinnerModel: ESite_HeaderBidderWinnerModel.Site_HB_WINNER_MODEL_UNKNOWN,
      HonorSequenceOrder: EBool.EBool_FALSE,
      IABCatCommaSeparated: '',
      IABCatPrefix: '',
      IABCatSuffix: '',
      RokuProviderChannelIDStr: '',
      ID: '0',
      IntegrationType: '',
      loading: true,
      MaxAdDuration: '',
      MaxAuctionCap: 0,
      MaxBitrate: 0,
      MinBitrate: 0,
      MimeTypes: ['video/mp4', 'video/H264'],
      MinAdDuration: '',
      MinPodSize: 1,
      openLogsView: false,
      Params: [],
      PodDuration: [],
      PodFloor: '-1',
      PriceIncrements: [] as IHeaderBidderPriceIncrement[],
      BypassDedupConfig: [] as IBypassDedupConfig[],
      Region: '',
      RejectPodsWithAllHouseAds: false,
      RejectNonsecureVAST: EBool.EBool_FALSE,
      EnableXMLCommentWrites: EBool.EBool_FALSE,
      rows: [] as IHeaderBidder[],
      SiteName: '',
      sites: [] as ISmallSite[],
      // snackbar
      snackbarError: false,
      snackbarMessage: '',
      snackbarWarning: false,
      Type: '',
      updating: false,
      UserSyncProviders: '',
      UserSyncURL: '',
      Timeout: 0,
      DebugHeaderBidder: 0,
      DebugHeaderBidderEnabledUntil: '',
      debugHeaderBidderEnabledUntilDays: 0,
      SamplingPercentageDisabledUntil: moment.utc(new Date()).format('YYYY-MM-DDTHH:mm:ssZ'),
      SamplingPercentageRequests: 1,
      FrequencyLimit: 0,
      FrequencyLimitDuration: 60,

      // Dedup
      AdIDDedup: EBool.EBool_FALSE,
      CreativeIDDedup: EBool.EBool_FALSE,

      CombineCreatives: EBool.EBool_FALSE,
      CombineCreativesMax: '2',
      CombineCreativesPriority: '1',
      EnableLiveContext: EBool.EBool_FALSE,
      LiveContextStreamID: '',
      LiveContextStreamURL: '',
      LiveContextLookbackMinutes: 2,
      ClickThroughAdomainRecognitionEnabled: EBool.EBool_FALSE,
      BrandRecognitionEnabled: EBool.EBool_FALSE,
      BrandRecognitionLimit: 0,
      BrandRecognitionLimitUnit: TimeUnit.TimeUnit_UNKNOWN,
      MachineLearningForMaxAuctionsEnabled: EBool.EBool_FALSE,
      WebShrinkerCategoryEnabled: EBool.EBool_FALSE,
      ServerSideTrackersEnabled: EBool.EBool_FALSE,
      LanguageDetectionEnabled: EBool.EBool_FALSE,

      // Auction Split
      AuctionSplit: EBool.EBool_FALSE,
      AuctionSplitTimeout: 200,

      PodDurationOverrideEnabled: EBool.EBool_FALSE,
      PodDurationOverride: 0,

      channelLabels: [],
      ChannelLabelsSelected: [],

      channelBrandSafetyRules: [] as IBrandSafetyRule[],
      channelGroups: [] as IChannelGroup[],

      // publica vault dropdowns
      demandSourceList: [] as ISelectOption[],

      errors: {} as IErrors,

      // brand-safety permissions
      publisherReadAuth:
        notAllowedEmptyIPermissionCheck /* todo uncomment to release global targeting - IS_AUTHORIZED(['read_publisher_brandsafety_rule'], this.props.user.user)*/,
      channelReadAuth: IS_AUTHORIZED(['read_channel_brandsafety_rule'], this.props.user.user),
      bidderReadAuth:
        notAllowedEmptyIPermissionCheck /* todo uncomment to release bidder(group) targeting - IS_AUTHORIZED(['read_bidder_brandsafety_rule'], this.props.user.user)*/,

      openEndpointParamsCustomizeMenu: false,
      endpointParams: [] as IParam[],

      // livelogs
      liveLogsTabIndex: 0,
      requestLiveLogFilter: '',
      responseLiveLogFilter: '',
      vmapRequestLiveLogFilter: '',
      vmapResponseLiveLogFilter: '',
      liveStreamWatcherAdBreakLiveLogFilter: '',
      garmScoreFilter: '',
      endpointsRequestLiveLogs: [] as IEndpointRequestLiveLogs[],
      endpointResponseLiveLogs: [] as IEndpointResponseUIData[],
      vmapEndpointsRequestLiveLogs: [] as IEndpointRequestLiveLogs[],
      vmapEndpointResponseLiveLogs: [] as IEndpointResponseUIData[],
      liveStreamWatcherAdBreakLiveLogs: [] as ILiveStreamWatcherAdBreakData[],

      // Content Overrides
      ContentDistribNameOverride: '',
      ContentDistribNameOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentChannelOverride: '',
      ContentChannelOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentNetworkOverride: '',
      ContentNetworkOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentSeriesOverride: '',
      ContentSeriesOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentTitleOverride: '',
      ContentTitleOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentCategoryOverride: '',
      ContentCategoryOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentGenreOverride: '',
      ContentGenreOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentRatingOverride: '',
      ContentRatingOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentProdqualOverride: '',
      ContentProdqualOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentProducerIDOverride: '',
      ContentProducerIDOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentProducerNameOverride: '',
      ContentProducerNameOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentKeywordsOverride: '',
      ContentKeywordsOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentLanguageOverride: '',
      ContentLanguageOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentIDOverride: '',
      ContentIDOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentSeasonOverride: '',
      ContentSeasonOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      RemoveContentFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentChannelFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentNetworkFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentSeriesFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentTitleFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentGenreFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentDistribNameFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentRatingFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentProdqualFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentProducerIDFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentProducerNameFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentKeywordsFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentLanguageFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentCategoryFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentIDFromEndpointRequest: EBool.EBool_FALSE as EBool,
      RemoveContentSeasonFromEndpointRequest: EBool.EBool_FALSE as EBool,
      AnonymizeDeviceID: EBool.EBool_FALSE as EBool,
      AnonymizeIP: EBool.EBool_FALSE as EBool,
      EndpointDealIDPassthroughActive: EBool.EBool_FALSE as EBool,
      MinAdDurationOverride: 0,
      MaxAdDurationOverride: 0,
      StartDelayOverride: EStartDelay.StartDelay_UnknownNotSet,
      ClearDefaultBitrateLimits: EBool.EBool_FALSE as EBool,
      Skip: EBool.EBool_FALSE as EBool,
      SkipMin: 0,
      SkipAfter: 0,
      InventoryPartnerDomainOverride: '',
      InventoryPartnerDomainOverrideIfEmpty: EBool.EBool_FALSE,
      // Content PostBid Overrides
      ContentDistribNamePostBidOverride: '',
      ContentDistribNamePostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentChannelPostBidOverride: '',
      ContentChannelPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentNetworkPostBidOverride: '',
      ContentNetworkPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentSeriesPostBidOverride: '',
      ContentSeriesPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentTitlePostBidOverride: '',
      ContentTitlePostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentCategoryPostBidOverride: '',
      ContentCategoryPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentGenrePostBidOverride: '',
      ContentGenrePostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentIDPostBidOverride: '',
      ContentIDPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentRatingPostBidOverride: '',
      ContentRatingPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentProdqualPostBidOverride: '',
      ContentProdqualPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentProducerIDPostBidOverride: '',
      ContentProducerIDPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentProducerNamePostBidOverride: '',
      ContentProducerNamePostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentKeywordsPostBidOverride: '',
      ContentKeywordsPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentLanguagePostBidOverride: '',
      ContentLanguagePostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      ContentSeasonPostBidOverride: '',
      ContentSeasonPostBidOverrideIfEmpty: EBool.EBool_FALSE as EBool,
      SuperSiteID: undefined,
      SuperSiteTargeting: '',
      SuperSiteTargetingType: SUPER_SITE_TARGETING_TYPE_CUSTOM_4,
      SuperSiteTargetingConfig: [] as ISuperSiteTargetingObject[],
      SuperSiteTargetingLogicOperator:
        ESuperSiteTargetingLogicOperator.AND as ESuperSiteTargetingLogicOperator,
      SubSites: [] as ISite[],
      siteList: {} as IMenuList,
      paramList: {} as IMenuList,
      startingTab: 0,
      newTab: undefined,
      SetCoppaToOne: EBool.EBool_FALSE as EBool,
      abTests: [] as IABTesting[],
      currentlyWritingABTest: false,
      triggerTestLaunch: false,
      PublicaVaultEnabled: EBool.EBool_FALSE as EBool,
      PublicaVaultUseDefault: EBool.EBool_TRUE as EBool,
      PublicaVaultExcludedBidderIDs: '',
      PublicaVaultExcludedDemandSources: '',
      BidSaverConfig: Object.assign({}, DEFAULT_BID_SAVER_CONFIG),
      Route: {} as IInventoryRoute,
      EnableFallbackAds: EBool.EBool_FALSE as EBool,
      FallbackAdsAdditionalAds: 0,
      EnableSecondaryRequests: EBool.EBool_FALSE as EBool,
      EnableSecondaryRequestPercentage: 100,
      EnableSecondaryRequestTimeout: 0,
      FallBackAdsEnableDurationOfPod: EBool.EBool_FALSE as EBool,
      FallbackAdsMode: EFallbackAdsMode.FALLBACK_ADS_MODE_UNKNOWN,

      // endpoint request scorecard
      endpointScorecardLevel1Scores: {
        CountRequestHasAppBundle: 0,
        CountRequestHasAppBundleOrSitePage: 0,
        CountRequestHasPodDurationOrSlotCount: 0,
        paramsLeft: 2,
        percentCompleted: 0,
        percentLeft: 30,
      },
      endpointScorecardLevel2Scores: {
        CountRequestHasIP: 0,
        CountRequestHasUserAgent: 0,
        CountRequestHasMaxAdDuration: 0,
        CountRequestHasMinAdDuration: 0,
        paramsLeft: 4,
        percentCompleted: 0,
        percentLeft: 25,
      },
      endpointScorecardLevel3Scores: {
        CountRequestHasAppStoreUrl: 0,
        CountRequestHasAppName: 0,
        CountRequestHasAppDomain: 0,
        CountRequestHasContentCategory: 0,
        CountRequestHasContentChannel: 0,
        paramsLeft: 4,
        percentCompleted: 0,
        percentLeft: 20,
      },
      endpointScorecardLevel4Scores: {
        CountRequestHasContentGenre: 0,
        CountRequestHasContentRating: 0,
        paramsLeft: 2,
        percentCompleted: 0,
        percentLeft: 15,
      },
      endpointScorecardLevel5Scores: {
        CountRequestHasContentTitle: 0,
        CountRequestHasContentID: 0,
        CountRequestHasContentNetwork: 0,
        paramsLeft: 3,
        percentCompleted: 0,
        percentLeft: 10,
      },
      CountRequestHasAppBundle: 0,
      // Inventory Routes
      publisherCountryGroups: [] as ICountryGroup[],
      fetchedPublisherCountryGroups: false,

      // bulk update
      isBulkUpdate: false,
      bulkUpdateChannelIDs: [],
      fieldsSelectedForBulkUpdate: new Map<string, void>(),
      bulkUpdateReverseFieldDependency: new Map<string, string[]>(),
      openBulkUpdateSavePopup: false,

      EnablePublicaVPAID: EBool.EBool_FALSE,

      // Measurement
      EnableIASFirstPartyVASTTracking: EBool.EBool_FALSE,
      MeasurementPercentage: 1,
      EnableDynamicMeasurementStrategy: EBool.EBool_FALSE,

      // Managed Platform Connection
      ReturnGrossCPMInResponse: EBool.EBool_TRUE,

      // Schain Fields
      EnableAddSchainToBidRequest: EBool.EBool_FALSE,
      SchainASI: '',
      SchainSID: '',
      SchainName: '',
      SchainDomain: '',
      SchainComplete: 0,

      // Contextual API calls Enabling
      ComscoreSignalEnabled: 0,

      // Deal Floor Overwrites
      BidsBelowDealFloorIsAllowed: EBool.EBool_FALSE,
      AllowBidsBelowDealFloor: AllowBidsBelowDealFloor_DO_NOT_ALLOW,
      AllowBidsBelowDealFloorValue: 0,
      refreshingLiveLogs: false,
      refreshingLiveLogsTimestamp: '',

      // Inventory Route tab
      inventoryRoutesForPublisher: [] as IInventoryRoute[],

      // Bypass Dedup Config
      bidderOptions: [] as ISelectOption[],
      houseAdsOptions: [] as ISelectOption[],
      loadingBidders: true,
      EnforceAuctionCutoff: EBool.EBool_FALSE,
      bypassDedupStateKey: 0,
      deleteBypassModelActive: false,

      // Creative Quality Assurance
      EnableCreativeQualityAssurance: EBool.EBool_FALSE,
      CreativeQualityAssuranceAudioBitrate: '',
      CreativeQualityAssuranceCodec: '',
      CreativeQualityAssuranceFrameRate: '',
      CreativeQualityAssuranceSamplingFrequency: '',
      CreativeQualityAssuranceVideoBitrate: '',
      CreativeQualityAssuranceVideoFormat: '',
      CreativeQualityAssuranceVideoResolution: '',

      SitePriceExtension: SitePriceExtension_false,

      // control the current rendered input rows of each section
      rewiteInputRows: {} as Record<RewriteInputRowsKey, Array<IRewriteActiveRow>>,
      appStoreURLs: isRoku() ? ['Roku'] : [...AppOverrideKeys].sort(),

      EnableEPGMetadata: EBool.EBool_FALSE,
      EnableEPGContentDuration: EBool.EBool_FALSE,
      EnableEPGContentGenre: EBool.EBool_FALSE,
      EnableEPGContentLanguage: EBool.EBool_FALSE,
      EnableEPGContentRating: EBool.EBool_FALSE,
      DisableActivationForNonSuperUser: '',
      smartFloorConfigs: [] as IInventorySmartFloorConfigUI[],
      connectedBidders: [] as ISmallBidderSmartFloors[],
      isSmartFloorActive: false,
      hasExistingSmartFloorConfig: false,
      selectedBidderIDForSmartFloorsChart: 0,
    } as IState;

    trackEvent = (eventTitle: ChannelEventTypes): void => {
      const is_super_user = hasRoleSuperUser(this.props.user.user);
      track(
        eventTitle,
        {
          is_super_user,
        },
        this.props.user.user,
      );
    };

    componentDidMount() {
      this.getSites();
      this.getHeaderBidders();
      this.getCampaigns();
    }

    fetchInventorySmartFloorConfigs = (): void => {
      const publisherID = this.props.session.publisher.ID;
      const siteID = this.props.session.site?.ID ?? 0;

      const biddersPromise = querySmallBiddersExcludeBidderTypes(
        publisherID,
        {
          publisher_id: publisherID,
          site_ids: siteID.toString(),
        },
        [DemandSources.publica, DemandSources.publicaCampaign],
      );

      const smartFloorsPromise = getInventorySmartFloorConfigs(
        publisherID,
        siteID.toString(),
        true,
      );

      Promise.all([biddersPromise, smartFloorsPromise])
        .then(([biddersResult, smartFloorConfigs]) => {
          const activeBidders = biddersResult.HeaderBidders.filter((b) => EBool.isTrue(b.Active));

          // build a bidderID -> name map so we can enrich InventorySmartFloors from the backend
          // (backend only stores HeaderbidderID, not BidderName)
          const bidderIDToName: { [id: number]: string } = {};
          activeBidders.forEach((b) => {
            bidderIDToName[parseInt(b.ID, 10)] = b.Name;
          });

          if (smartFloorConfigs && smartFloorConfigs.length > 0) {
            // enrich existing InventorySmartFloors with BidderName
            const enrichedConfigs = smartFloorConfigs.map((config) => ({
              ...config,
              InventorySmartFloors: config.InventorySmartFloors.map((sf) => ({
                ...sf,
                BidderName: bidderIDToName[sf.HeaderbidderID] ?? sf.BidderName ?? '',
              })),
            }));

            const hasExistingSmartFloorConfig =
              EBool.isTrue(this.props.session.publisher.InventorySmartFloorsEnabled) &&
              !isEmpty(enrichedConfigs[0]);

            const isSmartFloorActive =
              hasExistingSmartFloorConfig &&
              enrichedConfigs[0].Active &&
              enrichedConfigs[0].InventorySmartFloors?.some((sf) => sf.Active);

            this.setState({
              connectedBidders: activeBidders,
              smartFloorConfigs: enrichedConfigs,
              hasExistingSmartFloorConfig,
              isSmartFloorActive: isSmartFloorActive ?? false,
            });
          } else {
            this.setState({
              connectedBidders: activeBidders,
              smartFloorConfigs: [genNewInventorySmartFloorConfig(siteID)],
              hasExistingSmartFloorConfig: false,
              isSmartFloorActive: false,
            });
          }
        })
        .catch((err: Error): void => {
          console.error(err);
          this.setState({
            connectedBidders: [],
            smartFloorConfigs: [],
            hasExistingSmartFloorConfig: false,
            isSmartFloorActive: false,
          });
        });
    };

    getHeaderBidders = () => {
      const publisherID = this.props.session.publisher.ID;
      querySmallBidders(publisherID, {
        publisher_id: publisherID,
        site_ids: '',
      }).then(
        (result) => {
          const bidders: ISmallBidder[] = result.HeaderBidders;
          const options: ISelectOption[] = [];
          for (const bidder of bidders) {
            options.push({
              id: bidder.ID,
              label: bidder.Name,
            });
          }
          this.setState({
            bidders,
            bidderOptions: options,
            loadingBidders: false,
          });
        },
        (err) => {
          console.error(err);
          this.setState({
            bidders: [],
            snackbarMessage: 'Unable to retrieve header bidders.',
            snackbarError: true,
          });
        },
      );
    };

    getCampaigns = (): void => {
      getCampaigns({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      })
        .then((campaigns: IAdserverCampaign[]) => {
          const houseCampaigns = campaigns.filter((campaign) => campaign.CampaignType === '2');
          const options: ISelectOption[] = [];
          for (const campaign of houseCampaigns) {
            options.push({
              id: campaign.ID,
              label: campaign.Name,
            });
          }
          this.setState({
            houseAdsOptions: options,
            campaigns: houseCampaigns,
          });
        })
        .catch(() => {
          this.setState({
            campaigns: [],
            snackbarError: true,
            snackbarMessage: 'Error loading line items',
          });
        });
    };

    getSites = () => {
      getSmallSites(this.props.session.publisher.ID, 'uuid,super_site_id')
        .then((response: any[]) => {
          const [smallSites, err] = response;
          if (err) {
            throw new Error();
          }
          const sites: ISmallSite[] = smallSites || [];
          this.setState({
            sites,
          });
        })
        .catch(() => {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'Error loading sites',
          });
          return;
        });
    };

    parseJSONObjectSafely = (str: string) => {
      if (str === '') {
        return {};
      }

      try {
        return JSON.parse(str);
      } catch (e) {
        console.warn('Error while parsing JSON: ', e);
        return {};
      }
    };

    // loadSiteInfo loads the data for a single channel.
    loadSiteInfo = () => {
      // need to use =>, so this can be correctly referred to the correct context
      const loc = parseLocation(this.props.location.pathname);
      const selectedSite = this.state.sites.filter(
        (s: ISmallSite) => s.ID.toString() === loc.channel,
      )[0] as ISmallSite;
      if (selectedSite) {
        this.selectSite(selectedSite);
      }
      this.getChannelLabels();
      this.getChannelGroups(this.getChannelBrandSafetyRules);
      getInventoryRoutesByPublisherID(this.props.session.publisher.ID).then((inventoryRoutes) => {
        this.setState({
          inventoryRoutesForPublisher: inventoryRoutes,
        });
      });
      // redirect to mapping tab
      if (this.props.location.search === '?tab=mapping') {
        this.setState({
          startingTab: isEndpointBuilderDisabled(this.props.session.publisher) ? 3 : 4,
        });
      }
    };

    // initBulkUpdating checks if we are bulk updating channels. If we are, it initializes the state for it.
    initBulkUpdating(): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
        // transform page URL into URLSearchParams object; easier for extracting params
        const queryString = this.props.location.search;
        const urlParams = new URLSearchParams(queryString);

        // check if the "bulk_edit_ids" URL parameter exists
        if (!urlParams.has('bulk_edit_ids')) {
          // we are not bulk updating channels, stop here
          this.setState({ isBulkUpdate: false }, () => {
            resolve(false);
          });
          return;
        }

        // extract the value of the "bulk_edit_ids" parameter
        const bulkUpdateParameterString = urlParams.get('bulk_edit_ids') as string; // ex: "19291,15209"
        const bulkUpdateIDsAsString = bulkUpdateParameterString.split(','); // ex: ["19291", "15209"]
        const bulkUpdateChannelIDs = bulkUpdateIDsAsString.map((idStr: string) =>
          parseInt(idStr, 10),
        ); // ex: [19291, 15209]

        // make the reverse map of BulkUpdateFieldDependency, meaning we go from the dependant field to the main one
        const bulkUpdateReverseFieldDependency = new Map<keyof IState, Array<keyof IState>>();
        BulkUpdateFieldDependency.forEach((value, key) => {
          value.forEach((val) => {
            // try to get entry in the reverse map
            const mapEntry = bulkUpdateReverseFieldDependency.get(val);
            if (mapEntry !== undefined) {
              // value exists
              mapEntry.push(key);
            } else {
              // value doesn't exists
              bulkUpdateReverseFieldDependency.set(val, [key]);
            }
          });
        });

        // update state and resolve promise
        this.setState(
          {
            bulkUpdateChannelIDs,
            isBulkUpdate: true,
            bulkUpdateReverseFieldDependency,
          },
          () => {
            resolve(true); // we are bulk updating channels
          },
        );
      });
    }

    // initSingleEditing is called to initialize the state when editing a single channel.
    initSingleEditing(): void {
      this.trackEvent('Channel Settings - View Channel');
      this.loadSiteInfo();
      this.getCountryGroupsByPublisherIDWrapper();
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>) {
      const loc = parseLocation(this.props.location.pathname);
      const prevLoc = parseLocation(prevProps.location.pathname);
      if (loc.channel !== prevLoc.channel) {
        window.location.reload();
      }

      if (isEqual(prevState.sites, this.state.sites)) {
        return;
      }

      // check if we're currently bulk-updating channels, and initialize it if needed
      this.initBulkUpdating().then((isBulkUpdating: boolean) => {
        if (isBulkUpdating) {
          this.setState({ loading: false }); // we are bulk-updating channels
        } else {
          this.initSingleEditing(); // we are editing a single channel
        }
      });

      this.generateDemandSourceList();
    }

    generateSiteAndParamLists() {
      // generate site list
      const siteList: IMenuList = {};
      this.state.sites.forEach((site: ISmallSite) => {
        // don't add itself OR sites that are sub sites
        if (site.ID.toString() !== this.state.ID || site.SuperSiteID) {
          const siteName = checkUserInfoMasked(this.props.user.user)
            ? `demo_site_${site.ID}`
            : site.Name;
          siteList[site.ID] = {
            title: siteName,
            selected: site.ID === this.state.SuperSiteID,
            ID: site.ID.toString(),
          };
        }
      });
      // generate param list
      const paramList: IMenuList = {};
      for (const item of SuperSiteTargetingTypes) {
        paramList[item.id] = {
          title: item.title,
          selected: item.id === this.state.SuperSiteTargetingType,
          ID: item.id.toString(),
        };
      }

      this.setState({
        siteList,
        paramList,
      });
    }

    // gets the channel groups from the API, set them in state, and then call the callback
    getChannelGroups(callback?: () => void) {
      getChannelGroupsPromise({
        publisherID: this.props.session.publisher.ID,
      }).then(({ channelGroups }: { channelGroups: IChannelGroup[] }) => {
        const channelID = (this.props.session.site || { ID: 'undefined' }).ID;
        // filter channel groups to only keep the one that targets this channel
        const filteredChannelGroups = [] as IChannelGroup[];
        channelGroups.forEach((cg: IChannelGroup) => {
          for (let i = 0; i < cg.SitesInfo.length; i++) {
            // for each channel targeted by the channel group
            if (cg.SitesInfo[i].ID === channelID) {
              filteredChannelGroups.push(cg);
              break;
            }
          }
        });
        this.setState(
          {
            channelGroups: filteredChannelGroups,
          },
          callback,
        );
      });
    }

    componentWillMount() {
      // define endpoint-builder refresh handler - called to refresh component when changes are done within the service
      this.state.endpointBuilderService.setServiceRefreshHandler(() => {
        this.setState({ endpointBuilderService: this.state.endpointBuilderService });
      });
      // define endpoint-builder endpoint change handler - called when endpoint value changes
      this.state.endpointBuilderService.setEndpointChangeHandler((newEndpoint: string) => {
        newEndpoint = this.handleCustomParams(newEndpoint); // replace param values by user-defined ones
        this.setState({ EndpointURL: newEndpoint });
      });
    }

    getHeaderBidderDeliveryTypes() {
      const types = cloneDeep(HeaderBidderDeliveryTypes);
      const isSuperUser = hasRoleSuperUser(this.props.user.user);
      if (isSuperUser || this.props.user.publisher.NativeVastEnabled === EBool.EBool_TRUE) {
        types.push({
          label: 'Native Vast',
          value: 'NativeVast',
        });
      }
      return types;
    }

    isUserInfoMasked = (): boolean => {
      return checkUserInfoMasked(this.props.user.user);
    };

    // determines if the current user can write and returns permissions
    getWriteChannelAuthorization = (): IPermissionCheck => {
      return IS_AUTHORIZED(['write_channel'], this.props.user.user);
    };

    // Handle the user defined param values (done via the "Customize Params Value" UI button).
    // This function should be called one time when we load the endpoint from the API, and when the endpoint-builder
    // changes the URL.
    // Since this function is setting the new custom params in state, if the next operation you do might use them or call
    // this function again, please use the callback argument. The callback function receives the new endpoint as
    // a parameter.
    handleCustomParams = (endpoint: string, callback?: (endpoint: string) => void): string => {
      const customParams = [...this.state.endpointParams]; // clone state object

      // parse the endpoint string into a URL object; encode the '#' as it's is not URL-safe
      const url = new URL(endpoint.replace(/#/g, '%23'));
      const urlSearchParams = url.searchParams;

      // add param from the endpoint URL to the custom param list, if they are new
      for (const urlParamPair of urlSearchParams.entries()) {
        this.addParamInCustomParams(customParams, urlParamPair);
      }

      // delete params in the custom param list that are not in the endpoint URL
      for (let i = customParams.length - 1; i >= 0; i--) {
        if (!urlSearchParams.has(customParams[i].name)) {
          customParams.splice(i, 1); // param not in URL; remove element under index i
        }
      }

      // if the custom value is still a macro (not changed by the user), refresh its value with the one in the endpoint
      // We need to refresh the value because if the user change the "Trafficked In" option, then the macros change.
      for (let i = 0; i < customParams.length; i++) {
        const urlValue = urlSearchParams.get(customParams[i].name);
        if (urlValue !== null && isAMacro(customParams[i].value)) {
          customParams[i].value = urlValue; // value is macro, replace with URL value
        }
      }

      // insert the custom values in the endpoint URL
      for (const urlParamPair of urlSearchParams.entries()) {
        const urlParamName = urlParamPair[0];
        const customParam = customParams.find((cp: IParam) => cp.name === urlParamName);
        if (customParam) {
          urlSearchParams.set(urlParamName, customParam.value); // found custom param; replace the value
        }
      }

      // save new custom params into the state
      customParams.sort((a: IParam, b: IParam) => (a.name < b.name ? -1 : 1)); // sort parameter name alphabetically

      // serialize the URL object back into a string
      url.search = urlSearchParams.toString(); // save the updated params in the URL object
      endpoint = decodeURI(
        url
          .toString()
          .replace(/\+/g, ' ') // don't insert '+' instead of ' '; done automatically by the library
          .replace(/%23/g, '#'),
      ); // decode the '#', we encoded it as it is not URL-safe

      // set the new custom params in state, and call the callback function if provided
      this.setState(
        {
          endpointParams: customParams,
        },
        () => {
          if (callback) {
            callback(endpoint);
          } // call callback function with endpoint
        },
      );

      return endpoint;
    };

    // Add the given param in the list of custom param, if not ignored or already in it.
    // The customParamList parameter will be modified without being returned, it's passed as reference.
    addParamInCustomParams = (customParamList: IParam[], urlParamPair: string[]) => {
      const urlParamName = urlParamPair[0];
      const urlParamValue = urlParamPair[1];

      // if the URL parameter is in the ignored param list, then do nothing
      if (
        ParamIgnoredByCustomValues.findIndex((paramName: string) => paramName === urlParamName) > -1
      ) {
        return; // found URL param in ignored param list, do nothing
      }

      // if the URL parameter is already in the custom value list, then do nothing
      if (
        customParamList.findIndex((customParam: IParam) => customParam.name === urlParamName) > -1
      ) {
        return; // found URL param in custom value list, nothing to do
      }

      // add the URL parameter into the custom param list
      customParamList.push({ name: urlParamName, value: urlParamValue });
    };

    validateForm = (): string => {
      const errors = validate(this.state);
      if (hasErrors(errors)) {
        console.warn("Can't save channel:", errors);
        this.setState({
          errors,
        });
        return (
          'Errors: ' +
          Object.values(errors)
            .filter((val: string) => val.length > 0)
            .join(', ')
        );
      }
      this.setState({
        errors: {} as IErrors,
      });
      return '';
    };

    // loads all the rules that targets this channel from the API
    getChannelBrandSafetyRules() {
      // if rules are defined in the session, load them before doing the query to the API
      if (this.props.session !== undefined && this.props.session.brandSafetyRules !== undefined) {
        this.setState({
          channelBrandSafetyRules: this.filterRulesForChannel(
            this.applyPermissionsToRules(this.props.session.brandSafetyRules),
          ),
        });
      }
      // get the rules from the API
      this.getBrandSafetyRulesFromAPI();
    }

    // get the rules list from the console API
    getBrandSafetyRulesFromAPI() {
      // build request URL
      const reqURL = createUrl('/brandsafetyrules', this.props.session.publisher.ID);
      // make the request
      restGet<IBrandSafetyRule[]>(reqURL, {})
        .then((val: IHttpResponse<IBrandSafetyRule[]>) => {
          const apiRules = val.parsedBody as IBrandSafetyRule[];
          // OK
          this.setState({
            channelBrandSafetyRules: this.filterRulesForChannel(
              this.applyPermissionsToRules(apiRules),
            ),
          });
          this.props.session.brandSafetyRules = apiRules; // update session variable with refreshed list
        })
        .catch(() => {
          // error
          this.setState({
            channelBrandSafetyRules: [] as IBrandSafetyRule[],
            snackbarError: true,
            snackbarWarning: false,
            snackbarMessage: 'Error while getting the list of rules from the API.',
          });
        });
    }

    // filter the rules based on the user's read
    applyPermissionsToRules(rules: IBrandSafetyRule[]): IBrandSafetyRule[] {
      const filteredRules = [] as IBrandSafetyRule[];

      for (const rule of rules) {
        // handle global
        if (
          rule.RuleTargetingType === BrandSafetyRuleTargetingTypeGlobal &&
          this.state.publisherReadAuth.isAuthorized
        ) {
          filteredRules.push(rule);
          continue;
        }
        // handle channel
        if (
          (rule.RuleTargetingType === BrandSafetyRuleTargetingTypeChannel ||
            rule.RuleTargetingType === BrandSafetyRuleTargetingTypeChannelGroup) &&
          this.state.channelReadAuth.isAuthorized
        ) {
          filteredRules.push(rule);
          continue;
        }
        // handle bidder
        if (
          (rule.RuleTargetingType === BrandSafetyRuleTargetingTypeBidder ||
            rule.RuleTargetingType === BrandSafetyRuleTargetingTypeBidderGroup) &&
          this.state.bidderReadAuth.isAuthorized
        ) {
          filteredRules.push(rule);
        }
      }

      return filteredRules;
    }

    // filters the rule list to keep only the rules that target this site
    filterRulesForChannel(rules: IBrandSafetyRule[]) {
      const channelID = Number(this.props.session.site ? this.props.session.site.ID : '0');
      const channelRules = [] as IBrandSafetyRule[];
      for (const rule of rules) {
        // for each rule

        // global rule match → all global rules targets this channel
        if (rule.RuleTargetingType === BrandSafetyRuleTargetingTypeGlobal) {
          channelRules.push(rule);
          continue;
        }

        // check rule targeting
        for (let i = 0; i < rule.TargetedObjects.length; i++) {
          // for each rule's targeting object

          // channel level match → if this rule targets this channel
          if (
            rule.TargetedObjects[i].TargetingType === BrandSafetyRuleTargetingTypeChannel &&
            rule.TargetedObjects[i].TargetID === channelID
          ) {
            channelRules.push(rule);
            break;
          }

          // channel-group match → if this rule targets a channel group which include this channel
          if (rule.TargetedObjects[i].TargetingType === BrandSafetyRuleTargetingTypeChannelGroup) {
            const channelGroup = this.getChannelGroupFromID(rule.TargetedObjects[i].TargetID);
            if (channelGroup !== undefined && this.channelIDIsInGroup(channelID, channelGroup)) {
              channelRules.push(rule);
              break;
            }
          }
        }
      }

      return channelRules;
    }

    // gets a channel group by its ID
    getChannelGroupFromID(channelGroupID: number): IChannelGroup | undefined {
      for (let i = 0; i < this.state.channelGroups.length; i++) {
        if (Number(this.state.channelGroups[i].ID) === channelGroupID) {
          return this.state.channelGroups[i];
        }
      }
      return undefined;
    }

    // checks if the given channel ID is in the channel groups
    channelIDIsInGroup(channelID: number, channelGroup: IChannelGroup): boolean {
      for (let i = 0; i < channelGroup.SitesInfo.length; i++) {
        if (Number(channelGroup.SitesInfo[i].ID) === channelID) {
          return true; // channel found in group
        }
      }
      return false; // channel not found in group
    }

    getChannelLabelAddList = (): Array<{
      ID: string;
      Name: string;
      Sites: ISite[];
      SiteIDs: string[];
    }> => {
      return Object.values(this.state.ChannelLabelsSelected);
    };

    getChannelLabels() {
      getChannelLabels({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      }).then(({ channel_labels }: { channel_labels: IChannelLabel[] }) => {
        this.setState({
          channelLabels: channel_labels,
        });
      });
    }

    // getFieldValueFromName returns the values from one of the form fields given its state name.
    getFieldValueFromName(fieldName: keyof IState): any {
      // exception for 'BypassDedupOptions', which is stored in the state as 'BypassMediafileDedup', 'BypassAdomainDedup' or
      // 'BypassIabCatDedup'
      if (fieldName === 'BypassDedupOptions') {
        const values: string[] = [];
        if (this.state.BypassMediafileDedup === EBool.EBool_TRUE) {
          values.push('mediafile');
        }
        if (this.state.BypassAdomainDedup === EBool.EBool_TRUE) {
          values.push('adomain');
        }
        if (this.state.BypassIabCatDedup === EBool.EBool_TRUE) {
          values.push('IAB');
        }
        return values.join(', ');
      }

      // find the value in the state
      for (const [stateKey, stateValue] of Object.entries(this.state)) {
        if (stateKey === fieldName) {
          return stateValue;
        }
      }

      // no value found in the state
      return undefined;
    }

    buildNewSmartFloorConfigs = (
      configIdx: number, // will always be the first index for now
      key: inventorySmartFloorConfigCols,
      value: boolean | number | string,
      bidderID: number,
      emptyOutSmartFloors: boolean,
      shouldUpdateSmartFloorParams: boolean,
    ): IInventorySmartFloorConfigUI[] => {
      const smartFloorConfigs = [...this.state.smartFloorConfigs];
      const smartFloorConfig = cloneDeep(smartFloorConfigs[configIdx]);
      smartFloorConfig.shouldAllowSortingTable = true; // always true exept for BaseBidFloor
      let smartFloors = [...smartFloorConfig.InventorySmartFloors];

      switch (key) {
        case 'FallBackBaseFloor': {
          smartFloorConfig.FallBackBaseFloor = value as number;
          smartFloors = smartFloors.map((sf) => {
            if (sf.ControlBidFloor <= 0 || sf.isUsingFallbackFloor) {
              return { ...sf, ControlBidFloor: 0 };
            }
            return sf;
          });
          break;
        }
        case 'ControlBidFloor':
          smartFloors = smartFloors.map((sf) => {
            if (sf.HeaderbidderID === bidderID || bidderID === -1) {
              sf.ControlBidFloor = value as number;
              sf.isUsingFallbackFloor = false;
            }
            return sf;
          });
          smartFloorConfig.shouldAllowSortingTable = false;
          break;
        case 'IsABTestEnabled':
          smartFloorConfig.IsABTestEnabled = value as boolean;
          smartFloorConfig.ControlTrafficPercentage = smartFloorConfig.IsABTestEnabled ? 50.0 : 5.0;
          break;
        case 'IsTestIncrementPercentage':
          smartFloorConfig.IsTestIncrementPercentage = value as boolean;
          break;
        case 'IsBidFloorPercentage':
          smartFloorConfig.IsBidFloorPercentage = value as boolean;
          break;
        case 'TestIncrement':
          smartFloorConfig.TestIncrement = value as number;
          break;
        case 'MaxBidFloor':
          smartFloorConfig.MaxBidFloor = value as number;
          break;
        case 'MinBidFloor':
          smartFloorConfig.MinBidFloor = value as number;
          break;
        case 'ExcludedHeaderbidderIDs':
          smartFloorConfig.ExcludedHeaderbidderIDs = value as string;
          break;
        default:
          break;
      }

      smartFloorConfig.InventorySmartFloors = smartFloors;
      if (inventorySmartFloorRecalcKeys.has(key)) {
        smartFloors = this.genSmartFloorsFromChannel(
          smartFloorConfig,
          emptyOutSmartFloors,
          shouldUpdateSmartFloorParams,
        );
      }

      smartFloorConfig.InventorySmartFloors = smartFloors;
      smartFloorConfig.Active = !emptyOutSmartFloors;
      smartFloorConfigs[configIdx] = smartFloorConfig;

      return smartFloorConfigs;
    };

    genSmartFloorsFromChannel = (
      currSmartFloorConfig: IInventorySmartFloorConfigUI,
      emptyOutSmartFloors: boolean,
      configWasUpdated: boolean,
    ): IInventorySmartFloorPayloadUI[] => {
      if (emptyOutSmartFloors) {
        return [] as IInventorySmartFloorPayloadUI[];
      }

      const bidders: ISmallBidderSmartFloors[] = this.state.connectedBidders;
      const siteID = this.props.session.site?.ID ?? 0;
      const publisherID = parseInt(this.props.session.publisher.ID, 10);
      const channelBidFloor = this.state.BidFloor;
      const currSmartFloors = currSmartFloorConfig.InventorySmartFloors;
      let allSmartFloors = [] as IInventorySmartFloorPayloadUI[];

      // build a map of headerbidderID -> existing smart floor so we can detect new bidders
      const bidderIDToSmartFloor: { [bidderID: number]: IInventorySmartFloorPayloadUI } = {};

      // update existing smart floors and add them to the final list
      currSmartFloors.forEach((sf) => {
        const updatedSmartFloor = updateInventorySmartFloorParamsFromConfig(
          currSmartFloorConfig,
          sf.ControlBidFloor,
          sf,
          configWasUpdated,
        );
        bidderIDToSmartFloor[sf.HeaderbidderID] = updatedSmartFloor;
        allSmartFloors.push(updatedSmartFloor);
      });

      // create new smart floors for any connected bidder not already in the map
      bidders.forEach((bidder) => {
        const bidderID = parseInt(bidder.ID, 10);
        if (!(bidderID in bidderIDToSmartFloor)) {
          let bidFloorToUse = bidder.BidFloor ?? 0;
          if (EBool.isTrue(bidder.HonorChannelFloor) && channelBidFloor > 0) {
            bidFloorToUse = channelBidFloor;
          }

          const newSmartFloor = genNewInventorySmartFloor(
            bidderID,
            bidder.Name,
            siteID,
            publisherID,
            bidFloorToUse,
            currSmartFloorConfig,
          );
          allSmartFloors.push(newSmartFloor);
        }
      });
      allSmartFloors = this.handleRemoveSmartFloorsFromExcludedHeaderbidderIDs(
        currSmartFloorConfig.ExcludedHeaderbidderIDs,
        allSmartFloors,
      );
      return allSmartFloors;
    };

    handleChangeSmartFloorConfig = (
      configIdx: number, // will always be the first index for now
      key: inventorySmartFloorConfigCols,
      value: boolean | number | string,
      bidderID: number,
      emptyOutSmartFloors: boolean,
      shouldUpdateSmartFloorParams: boolean,
    ): void => {
      switch (key) {
        // this key only updates what to be displayed in the Live graph, and doesn't affect the smart floor config
        // TODO: add this back in when we have a way to display the chart
        case 'isBidderIDSelected':
          if (bidderID !== undefined && bidderID !== 0) {
            let selectedBidderIDForSmartFloorsChart = 0;
            this.state.smartFloorConfigs[configIdx]?.InventorySmartFloors?.forEach((sf) => {
              if (sf.HeaderbidderID === bidderID) {
                selectedBidderIDForSmartFloorsChart = sf.HeaderbidderID;
              }
            });

            this.setState({
              selectedBidderIDForSmartFloorsChart,
            });
            return;
          }
          break;

        // all other keys will create a new smart floor config
        default: {
          this.setState({
            smartFloorConfigs: this.buildNewSmartFloorConfigs(
              configIdx,
              key,
              value,
              bidderID,
              emptyOutSmartFloors,
              shouldUpdateSmartFloorParams,
            ),
          });
        }
      }
    };

    handleRemoveSmartFloorsFromExcludedHeaderbidderIDs(
      excludedHeaderbidderIDs: string,
      smartFloors: IInventorySmartFloorPayloadUI[],
    ): IInventorySmartFloorPayloadUI[] {
      const excludedHeaderbidderIDsArray = excludedHeaderbidderIDs
        .split(',')
        .map((id) => parseInt(id, 10));
      return smartFloors.filter((sf) => !excludedHeaderbidderIDsArray.includes(sf.HeaderbidderID));
    }
    // transformValueToDisplayableValue transforms the given value into a string we can display to the user.
    // This requires the field state name as well, to help identify the underlying type.
    // Used by bulk update to display the field value in the right summary bar.
    transformValueToDisplayableValue(rawValue: any, fieldStateName: keyof IState): string {
      // if the field is a EBool, where 2 = active 1 = inactive, convert them into readable strings
      if (EBoolFieldsName.includes(fieldStateName)) {
        return EBool.toBool(rawValue).toString(); // convert EBool to boolean then to string
      }

      // if the field is TimeUnit, then gets its value as a displayable string
      if (fieldStateName === 'BrandRecognitionLimitUnit') {
        return TimeUnit.toString(rawValue);
      }

      return rawValue.toString();
    }

    // generate dropdown demand source list for Publica Vault
    generateDemandSourceList = (): void => {
      const demandSourceList = genDemandSourcesOptions(
        this.props.session.publisher,
        [],
        '',
        hasRoleSuperUser(this.props.user.user),
      );
      this.setState({
        demandSourceList,
      });
    };

    refreshModels(smallSite: ISmallSite) {
      getSite({
        query: {
          publisher_id: this.props.session.publisher.ID,
          site_id: smallSite.ID,
        },
      }).then(
        (site: ISite) => {
          // Solution until root issue transforming overrides to strings is found: force parsing of overrides here (HB-3190)
          if (typeof site.AppBundleOverride === 'string') {
            site.AppBundleOverride = this.parseJSONObjectSafely(site.AppBundleOverride);
          }
          if (typeof site.AppIDOverride === 'string') {
            site.AppIDOverride = this.parseJSONObjectSafely(site.AppIDOverride) as {
              [key: string]: string;
            };
          }
          if (typeof site.AppNameOverride === 'string') {
            site.AppNameOverride = this.parseJSONObjectSafely(site.AppNameOverride);
          }
          if (typeof site.AppDomainOverride === 'string') {
            site.AppDomainOverride = this.parseJSONObjectSafely(site.AppDomainOverride);
          }
          if (typeof site.SiteDomainOverride === 'string') {
            site.SiteDomainOverride = this.parseJSONObjectSafely(site.SiteDomainOverride);
          }
          if (typeof site.SiteNameOverride === 'string') {
            site.SiteNameOverride = this.parseJSONObjectSafely(site.SiteNameOverride);
          }

          if (this.props.session.site) {
            this.getLiveLogs(site.LiveContextStreamID);

            this.props.dispatch(
              SESSION_ACTIONS_SET({
                site,
              }),
            );
          }

          setTimeout(() => {
            this.setState(
              {
                ID: site.ID.toString(),
                Active: site.Active,
                Timeout: site.HeaderBidderEndpointTimeout,
                DebugHeaderBidder: site.DebugHeaderBidder,
                DebugHeaderBidderEnabledUntil: site.DebugHeaderBidderEnabledUntil,
                SamplingPercentageDisabledUntil: site.SamplingPercentageDisabledUntil,
                SamplingPercentageRequests: site.SamplingPercentageRequests,
                RokuProviderChannelIDStr: site.RokuProviderChannelIDStr,
                loading: false,
                SiteName: site.Name,
                HeaderBidderDeliveryType:
                  HeaderBidderDeliveryTypesIndexMap[site.HeaderBidderDeliveryType],
                AllowVPAID: site.HeaderBidderMimeTypes.includes('application/javascript'),
                HeaderBidderVastVersion: '' + site.HeaderBidderVastVersion,
                Region: RegionIndexMap[site.Region],
                AppStoreURL: site.AppStoreURL,
                AppStoreUrlOverrideIfEmpty: site.AppStoreUrlOverrideIfEmpty,
                AppBundleOverride: site.AppBundleOverride,
                AppBundleOverrideIfEmpty: site.AppBundleOverrideIfEmpty,
                AppIDOverride: site.AppIDOverride,
                AppIDOverrideIfEmpty: site.AppIDOverrideIfEmpty,
                AppNameOverride: site.AppNameOverride,
                AppNameOverrideIfEmpty: site.AppNameOverrideIfEmpty,
                AppDomainOverride: site.AppDomainOverride,
                AppDomainOverrideIfEmpty: site.AppDomainOverrideIfEmpty,
                AppCatOverride: site.AppCatOverride,
                AppCatOverrideIfEmpty: site.AppCatOverrideIfEmpty,
                SiteDomainOverride: site.SiteDomainOverride,
                SiteDomainOverrideIfEmpty: site.SiteDomainOverrideIfEmpty,
                SiteNameOverride: site.SiteNameOverride,
                PriceIncrements: site.HeaderBidderPriceIncrements,
                MimeTypes:
                  site.HeaderBidderMimeTypes.length === 0
                    ? ['video/mp4', 'video/H264']
                    : site.HeaderBidderMimeTypes,
                EnableHlsTranscoder: site.EnableHlsTranscoder,
                HeaderBidderSingleAuction: site.HeaderBidderSingleAuction,
                HeaderBidderDedup: site.HeaderBidderDedup,
                HeaderBidderCacheMedia: site.HeaderBidderCacheMedia,
                HeaderBidderDedupAdomain: site.HeaderBidderDedupAdomain,
                HeaderBidderDedupAPSKey: site.HeaderBidderDedupAPSKey,
                HeaderBidderWinnerModel: site.HeaderBidderWinnerModel,
                HeaderBidderDedupCategory: site.HeaderBidderDedupCategory,
                HeaderBidderEnforceAdomain: site.HeaderBidderEnforceAdomain,
                HeaderBidderEnforceSlotTargeting: site.HeaderBidderEnforceSlotTargeting,
                HeaderBidderGlobalDedup: site.HeaderBidderGlobalDedup,
                HeaderBidderGlobalDedupExpiration: site.HeaderBidderGlobalDedupExpiration || 300,
                HonorSequenceOrder: site.HonorSequenceOrder,
                UserSyncProviders: site.UserSyncProviders,
                DDMonitoring: site.DDMonitoring,
                MaxBitrate: site.MaxBitrate,
                MinBitrate: site.MinBitrate,
                BidAdjustmentFactor: site.BidAdjustmentFactor,
                BidAdjustmentValue: site.BidAdjustmentValue,
                BidFloor: site.BidFloor,
                CurrencyDisplayed: site.CurrencyDisplayed,
                MaxAuctionCap: site.MaxAuctionCap,
                PodFloor: site.PodFloor,
                MinPodSize: site.MinPodSize,
                DefaultWeight: site.DefaultWeight,
                RejectPodsWithAllHouseAds: site.RejectPodsWithAllHouseAds,
                RejectNonsecureVAST: site.RejectNonsecureVAST,
                EnableXMLCommentWrites: site.EnableXMLCommentWrites,
                AdIDDedup: site.AdIDDedup,
                CreativeIDDedup: site.CreativeIDDedup,
                CombineCreatives: site.CombineCreatives,
                CombineCreativesMax: '' + site.CombineCreativesMax,
                CombineCreativesPriority: '' + site.CombineCreativesPriority,
                EnableLiveContext: site.EnableLiveContext,
                LiveContextStreamID: site.LiveContextStreamID,
                LiveContextStreamURL: site.LiveContextStreamURL,
                LiveContextLookbackMinutes: site.LiveContextLookbackMinutes,
                ClickThroughAdomainRecognitionEnabled: site.ClickThroughAdomainRecognitionEnabled,
                BrandRecognitionEnabled: site.BrandRecognitionEnabled,
                BrandRecognitionLimit: site.BrandRecognitionLimit || 0,
                BrandRecognitionLimitUnit:
                  site.BrandRecognitionLimitUnit || TimeUnit.TimeUnit_UNKNOWN,
                MachineLearningForMaxAuctionsEnabled: site.MachineLearningForMaxAuctionsEnabled,
                WebShrinkerCategoryEnabled: site.WebShrinkerCategoryEnabled,
                ServerSideTrackersEnabled: site.ServerSideTrackersEnabled,
                FrequencyLimit: site.FrequencyLimit,
                FrequencyLimitDuration: site.FrequencyLimitDuration,
                AuctionSplit: site.AuctionSplit,
                AuctionSplitTimeout: site.AuctionSplitTimeout,
                PodDurationOverrideEnabled: site.PodDurationOverrideEnabled,
                PodDurationOverride: site.PodDurationOverride,
                ChannelLabelsSelected: site.ChannelLabels,
                ContentDistribNameOverride: site.ContentDistribNameOverride,
                ContentDistribNameOverrideIfEmpty: site.ContentDistribNameOverrideIfEmpty,
                ContentChannelOverride: site.ContentChannelOverride,
                ContentChannelOverrideIfEmpty: site.ContentChannelOverrideIfEmpty,
                ContentNetworkOverride: site.ContentNetworkOverride,
                ContentNetworkOverrideIfEmpty: site.ContentNetworkOverrideIfEmpty,
                ContentSeriesOverride: site.ContentSeriesOverride,
                ContentSeriesOverrideIfEmpty: site.ContentSeriesOverrideIfEmpty,
                ContentTitleOverride: site.ContentTitleOverride,
                ContentTitleOverrideIfEmpty: site.ContentTitleOverrideIfEmpty,
                ContentCategoryOverride: site.ContentCategoryOverride,
                ContentCategoryOverrideIfEmpty: site.ContentCategoryOverrideIfEmpty,
                ContentGenreOverride: site.ContentGenreOverride,
                ContentGenreOverrideIfEmpty: site.ContentGenreOverrideIfEmpty,
                ContentRatingOverride: site.ContentRatingOverride,
                ContentRatingOverrideIfEmpty: site.ContentRatingOverrideIfEmpty,
                ContentProdqualOverride: site.ContentProdqualOverride,
                ContentProdqualOverrideIfEmpty: site.ContentProdqualOverrideIfEmpty,
                ContentProducerIDOverride: site.ContentProducerIDOverride,
                ContentProducerIDOverrideIfEmpty: site.ContentProducerIDOverrideIfEmpty,
                ContentProducerNameOverride: site.ContentProducerNameOverride,
                ContentProducerNameOverrideIfEmpty: site.ContentProducerNameOverrideIfEmpty,
                ContentKeywordsOverride: site.ContentKeywordsOverride,
                ContentKeywordsOverrideIfEmpty: site.ContentKeywordsOverrideIfEmpty,
                ContentLanguageOverride: site.ContentLanguageOverride,
                ContentLanguageOverrideIfEmpty: site.ContentLanguageOverrideIfEmpty,
                ContentIDOverride: site.ContentIDOverride,
                ContentIDOverrideIfEmpty: site.ContentIDOverrideIfEmpty,
                ContentSeasonOverride: site.ContentSeasonOverride,
                ContentSeasonOverrideIfEmpty: site.ContentSeasonOverrideIfEmpty,
                RemoveContentFromEndpointRequest: site.RemoveContentFromEndpointRequest,
                RemoveContentChannelFromEndpointRequest:
                  site.RemoveContentChannelFromEndpointRequest,
                RemoveContentNetworkFromEndpointRequest:
                  site.RemoveContentNetworkFromEndpointRequest,
                RemoveContentSeriesFromEndpointRequest: site.RemoveContentSeriesFromEndpointRequest,
                RemoveContentTitleFromEndpointRequest: site.RemoveContentTitleFromEndpointRequest,
                RemoveContentGenreFromEndpointRequest: site.RemoveContentGenreFromEndpointRequest,
                RemoveContentDistribNameFromEndpointRequest:
                  site.RemoveContentDistribNameFromEndpointRequest,
                RemoveContentRatingFromEndpointRequest: site.RemoveContentRatingFromEndpointRequest,
                RemoveContentProdqualFromEndpointRequest:
                  site.RemoveContentProdqualFromEndpointRequest,
                RemoveContentProducerIDFromEndpointRequest:
                  site.RemoveContentProducerIDFromEndpointRequest,
                RemoveContentProducerNameFromEndpointRequest:
                  site.RemoveContentProducerNameFromEndpointRequest,
                RemoveContentKeywordsFromEndpointRequest:
                  site.RemoveContentKeywordsFromEndpointRequest,
                RemoveContentLanguageFromEndpointRequest:
                  site.RemoveContentLanguageFromEndpointRequest,
                RemoveContentIDFromEndpointRequest: site.RemoveContentIDFromEndpointRequest,
                RemoveContentSeasonFromEndpointRequest: site.RemoveContentSeasonFromEndpointRequest,
                ContentDistribNamePostBidOverride: site.ContentDistribNamePostBidOverride,
                ContentDistribNamePostBidOverrideIfEmpty:
                  site.ContentDistribNamePostBidOverrideIfEmpty,
                ContentChannelPostBidOverride: site.ContentChannelPostBidOverride,
                ContentChannelPostBidOverrideIfEmpty: site.ContentChannelPostBidOverrideIfEmpty,
                ContentNetworkPostBidOverride: site.ContentNetworkPostBidOverride,
                ContentNetworkPostBidOverrideIfEmpty: site.ContentNetworkPostBidOverrideIfEmpty,
                ContentSeriesPostBidOverride: site.ContentSeriesPostBidOverride,
                ContentSeriesPostBidOverrideIfEmpty: site.ContentSeriesPostBidOverrideIfEmpty,
                ContentTitlePostBidOverride: site.ContentTitlePostBidOverride,
                ContentTitlePostBidOverrideIfEmpty: site.ContentTitlePostBidOverrideIfEmpty,
                ContentCategoryPostBidOverride: site.ContentCategoryPostBidOverride,
                ContentCategoryPostBidOverrideIfEmpty: site.ContentCategoryPostBidOverrideIfEmpty,
                ContentGenrePostBidOverride: site.ContentGenrePostBidOverride,
                ContentGenrePostBidOverrideIfEmpty: site.ContentGenrePostBidOverrideIfEmpty,
                ContentRatingPostBidOverride: site.ContentRatingPostBidOverride,
                ContentRatingPostBidOverrideIfEmpty: site.ContentRatingPostBidOverrideIfEmpty,
                ContentProdqualPostBidOverride: site.ContentProdqualPostBidOverride,
                ContentProdqualPostBidOverrideIfEmpty: site.ContentProdqualPostBidOverrideIfEmpty,
                ContentProducerIDPostBidOverride: site.ContentProducerIDPostBidOverride,
                ContentProducerIDPostBidOverrideIfEmpty:
                  site.ContentProducerIDPostBidOverrideIfEmpty,
                ContentProducerNamePostBidOverride: site.ContentProducerNamePostBidOverride,
                ContentProducerNamePostBidOverrideIfEmpty:
                  site.ContentProducerNamePostBidOverrideIfEmpty,
                ContentKeywordsPostBidOverride: site.ContentKeywordsPostBidOverride,
                ContentKeywordsPostBidOverrideIfEmpty: site.ContentKeywordsPostBidOverrideIfEmpty,
                ContentLanguagePostBidOverride: site.ContentLanguagePostBidOverride,
                ContentLanguagePostBidOverrideIfEmpty: site.ContentLanguagePostBidOverrideIfEmpty,
                RemoveContentCategoryFromEndpointRequest:
                  site.RemoveContentCategoryFromEndpointRequest,
                AnonymizeDeviceID: site.AnonymizeDeviceID,
                AnonymizeIP: site.AnonymizeIP,
                EndpointDealIDPassthroughActive: site.EndpointDealIDPassthroughActive,
                MinAdDurationOverride: site.MinAdDurationOverride,
                MaxAdDurationOverride: site.MaxAdDurationOverride,
                StartDelayOverride: site.StartDelayOverride,
                ClearDefaultBitrateLimits: site.ClearDefaultBitrateLimits,
                Skip: site.Skip,
                SkipMin: site.SkipMin,
                SkipAfter: site.SkipAfter,
                SuperSiteID: site.SuperSiteID,
                SuperSiteTargeting: site.SuperSiteTargeting,
                SuperSiteTargetingType: site.SuperSiteTargetingType,
                SuperSiteTargetingConfig: Array.isArray(site.SuperSiteTargetingConfig)
                  ? site.SuperSiteTargetingConfig
                  : [],
                SuperSiteTargetingLogicOperator: site.SuperSiteTargetingLogicOperator,
                SubSites: site.SubSites,
                SetCoppaToOne: site.SetCoppaToOne,
                abTests: site.abTests,
                PublicaVaultEnabled: site.PublicaVaultEnabled,
                PublicaVaultUseDefault: site.PublicaVaultUseDefault,
                PublicaVaultExcludedBidderIDs: site.PublicaVaultExcludedBidderIDs,
                PublicaVaultExcludedDemandSources: site.PublicaVaultExcludedDemandSources,
                EnableFallbackAds: site.EnableFallbackAds,
                FallbackAdsMode: site.FallbackAdsMode,
                FallbackAdsAdditionalAds: site.FallbackAdsAdditionalAds,
                FallBackAdsEnableDurationOfPod: site.FallBackAdsEnableDurationOfPod,
                BidSaverConfig:
                  site.BidSaverConfig && site.BidSaverConfig.TTL
                    ? site.BidSaverConfig
                    : Object.assign({}, DEFAULT_BID_SAVER_CONFIG),
                Route:
                  site.Route === undefined || site.Route.ID === undefined ? undefined : site.Route,
                demandSourceList: genDemandSourcesOptions(
                  this.props.session.publisher,
                  [],
                  '',
                  hasRoleSuperUser(this.props.user.user),
                ),
                EnablePublicaVPAID: site.EnablePublicaVPAID,
                EnableIASFirstPartyVASTTracking: site.EnableIASFirstPartyVASTTracking,
                MeasurementPercentage: site.MeasurementPercentage,
                EnableDynamicMeasurementStrategy: site.EnableDynamicMeasurementStrategy,
                ReturnGrossCPMInResponse: site.ReturnGrossCPMInResponse,
                EnableAddSchainToBidRequest: site.EnableAddSchainToBidRequest,
                SchainASI: site.SchainASI,
                SchainSID: site.SchainSID,
                SchainName: site.SchainName,
                SchainDomain: site.SchainDomain,
                SchainComplete: site.SchainComplete,
                ComscoreSignalEnabled: site.ComscoreSignalEnabled,
                BidsBelowDealFloorIsAllowed:
                  site.AllowBidsBelowDealFloor !== AllowBidsBelowDealFloor_DO_NOT_ALLOW
                    ? EBool.EBool_TRUE
                    : EBool.EBool_FALSE,
                AllowBidsBelowDealFloor: site.AllowBidsBelowDealFloor,
                AllowBidsBelowDealFloorValue: site.AllowBidsBelowDealFloorValue,
                LanguageDetectionEnabled: site.LanguageDetectionEnabled,
                EnableSecondaryRequests: site.EnableSecondaryRequests,
                EnableSecondaryRequestPercentage: site.EnableSecondaryRequestPercentage,
                EnableSecondaryRequestTimeout: site.EnableSecondaryRequestTimeout,
                BypassDedupConfig: Array.isArray(site.BypassDedupConfig)
                  ? site.BypassDedupConfig
                  : [],
                EnforceAuctionCutoff: site.EnforceAuctionCutoff,
                EnableCreativeQualityAssurance: site.EnableCreativeQualityAssurance,
                CreativeQualityAssuranceAudioBitrate: site.CreativeQualityAssuranceAudioBitrate,
                CreativeQualityAssuranceCodec: site.CreativeQualityAssuranceCodec,
                CreativeQualityAssuranceFrameRate: site.CreativeQualityAssuranceFrameRate,
                CreativeQualityAssuranceSamplingFrequency:
                  site.CreativeQualityAssuranceSamplingFrequency,
                CreativeQualityAssuranceVideoBitrate: site.CreativeQualityAssuranceVideoBitrate,
                CreativeQualityAssuranceVideoFormat: site.CreativeQualityAssuranceVideoFormat,
                CreativeQualityAssuranceVideoResolution:
                  site.CreativeQualityAssuranceVideoResolution,
                SitePriceExtension: site.SitePriceExtension,
                InventoryPartnerDomainOverride: site.InventoryPartnerDomainOverride,
                InventoryPartnerDomainOverrideIfEmpty: site.InventoryPartnerDomainOverrideIfEmpty,
                rewiteInputRows: {
                  AppStoreURL: this.state.appStoreURLs
                    .filter((url: string) => site.AppStoreURL[url])
                    .map((url: string) => ({ device: url, text: site.AppStoreURL[url] })),
                  AppNameOverride: this.state.appStoreURLs
                    .filter((url: string) => site.AppNameOverride[url])
                    .map((url: string) => ({ device: url, text: site.AppNameOverride[url] })),
                  AppDomainOverride: this.state.appStoreURLs
                    .filter((url: string) => site.AppDomainOverride[url])
                    .map((url: string) => ({ device: url, text: site.AppDomainOverride[url] })),
                  AppBundleOverride: this.state.appStoreURLs
                    .filter((url: string) => site.AppBundleOverride[url])
                    .map((url: string) => ({ device: url, text: site.AppBundleOverride[url] })),
                  AppIDOverride: this.state.appStoreURLs
                    .filter((url: string) => site.AppIDOverride[url])
                    .map((url: string) => ({ device: url, text: site.AppIDOverride[url] })),
                },
                EnableEPGMetadata: site.EnableEPGMetadata,
                EnableEPGContentDuration: site.EnableEPGContentDuration,
                EnableEPGContentGenre: site.EnableEPGContentGenre,
                EnableEPGContentLanguage: site.EnableEPGContentLanguage,
                EnableEPGContentRating: site.EnableEPGContentRating,
                DisableActivationForNonSuperUser: site.DisableActivationForNonSuperUser,
              },
              () => {
                // make endpoint from params

                let endpoint;
                const isReseller =
                  this.props.session.publisher.IsResellerPublisher === EBool.EBool_TRUE;

                if (this.state.Region === USA) {
                  endpoint = (isReseller ? getPbsUSReseller() : getPbsUS()) + '/v1/s2s-hb';
                } else if (this.state.Region === EUROPE) {
                  endpoint = (isReseller ? getPbsEUReseller() : getPbsEU()) + '/v1/s2s-hb';
                } else if (this.state.Region === APAC) {
                  endpoint = (isReseller ? getPbsAPACReseller() : getPbsAPAC()) + '/v1/s2s-hb';
                } else if (this.state.Region === JAPAN) {
                  endpoint = (isReseller ? getPbsJPReseller() : getPbsJP()) + '/v1/s2s-hb';
                }

                if (endpoint) {
                  if (site.EndpointURLParams !== '') {
                    // params are already defined, reconstruct endpoint
                    endpoint += '?';
                    const params = JSON.parse(site.EndpointURLParams);
                    endpoint += Object.keys(params)
                      .map((name: string) => name + '=' + params[name])
                      .join('&');
                  }

                  // set the initial endpoint for this existing endpoint builder
                  this.handleCustomParams(endpoint, (newEndpoint: string) => {
                    // after we updated the custom prams in the state, set the current endpoint in endpoint builder
                    this.state.endpointBuilderService.setEndpoint(newEndpoint);
                    this.state.endpointBuilderService.refresh();
                  });
                }

                this.generateSiteAndParamLists();

                // fetch inventory smart floor configs
                if (EBool.isTrue(this.props.session.publisher.InventorySmartFloorsEnabled)) {
                  this.fetchInventorySmartFloorConfigs();
                }

                if (site.EndpointRequestScore.CountEndpointRequests) {
                  this.calculateLevelScores(site.EndpointRequestScore);
                }
              },
            );
          }, 1000);
        },
        () => {
          this.setState({
            loading: false,
          });
        },
      );
    }

    getLiveLogs = (lvcStreamID?: string): void => {
      if (!this.props.session.site) {
        return;
      }
      this.setState(
        {
          refreshingLiveLogs: true,
        },
        () => {
          const site = this.props.session.site;
          if (!lvcStreamID) {
            lvcStreamID = this.state.LiveContextStreamID as string;
          }

          // Endpoint Request
          const endpointRequestQuery = getEndpointRequestLogsQuery((site || { UUID: '' }).UUID);
          generalGetLiveLogs<IEndpointRequestLiveLogs[]>(
            endpointRequestQuery,
            this.props.session.publisher.ID,
            this.props.user.user.Username,
          ).then(([data, err]) => {
            if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
              this.setState({
                endpointsRequestLiveLogs: data,
                refreshingLiveLogsTimestamp: formatTime(
                  moment(),
                  this.props.user.publisher.Timezone,
                ),
              });
            }
            if (err !== undefined) {
              console.error(err);
            }
            this.setState({
              refreshingLiveLogs: false,
            });
          });

          // Endpoint Response
          const endpointResponseQuery = getEndpointResponseLogsQuery((site || { UUID: '' }).UUID);
          generalGetLiveLogs<IEndpointResponseUIData[]>(
            endpointResponseQuery,
            this.props.session.publisher.ID,
            this.props.user.user.Username,
          ).then(([data, err]) => {
            if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
              this.setState({
                endpointResponseLiveLogs: data,
              });
            }
            if (err !== undefined) {
              console.error(err);
            }
          });

          // VMAP Endpoint Request
          const vmapEndpointRequestQuery = getVMAPPlaylistEndpointRequestLogsQuery(
            (site || { UUID: '' }).UUID,
          );
          generalGetLiveLogs<IEndpointRequestLiveLogs[]>(
            vmapEndpointRequestQuery,
            this.props.session.publisher.ID,
            this.props.user.user.Username,
          ).then(([data, err]) => {
            if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
              this.setState({
                vmapEndpointsRequestLiveLogs: data,
              });
            }
            if (err !== undefined) {
              console.error(err);
            }
          });

          // VMAP Endpoint Response
          const vmapEndpointResponseQuery = getVMAPPlaylistEndpointResponseLogsQuery(
            (site || { UUID: '' }).UUID,
          );
          generalGetLiveLogs<IEndpointResponseUIData[]>(
            vmapEndpointResponseQuery,
            this.props.session.publisher.ID,
            this.props.user.user.Username,
          ).then(([data, err]) => {
            if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
              this.setState({
                vmapEndpointResponseLiveLogs: data,
              });
            }
            if (err !== undefined) {
              console.error(err);
            }
          });

          // Live Context Ad Break
          if (isSuper(this.props.user.user)) {
            const liveStreamWatcherAdBreakLiveLogQuery =
              getLiveStreamWatcherAdBreakQuery(lvcStreamID);
            void generalGetLiveLogs<ILiveStreamWatcherAdBreakData[]>(
              liveStreamWatcherAdBreakLiveLogQuery,
              this.props.session.publisher.ID,
              this.props.user.user.Username,
            ).then(([data, err]) => {
              if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
                this.setState({
                  liveStreamWatcherAdBreakLiveLogs: data,
                });
              }
              if (err !== undefined) {
                console.error(err);
              }
            });
          }
        },
      );
    };

    updateSite = () => {
      if (!this.state.isBulkUpdate) {
        // bulk update is disabled; normal saving
        this.trackEvent('Channel Settings - Save Channel');
        const errors = this.validateForm();
        if (errors !== '') {
          this.setState({
            snackbarMessage:
              'Updating Channel Settings failed. Please fix the errors and try again.\n' + errors,
            snackbarError: true,
            snackbarWarning: false,
          });
          return;
        }
        this._updateSite();
      } else {
        // bulk update is enabled; open the bulk update popup
        this.setState({
          openBulkUpdateSavePopup: true,
        });
      }
    };

    handleChangeChannelLabelList = (list: IChannelLabel[]) => {
      this.setState({
        ChannelLabelsSelected: list,
      });
    };

    selectSite = (smallSite: ISmallSite | undefined) => {
      if (smallSite === undefined) {
        return;
      }
      const site = {
        ...smallSite,
        Active: smallSite.Active === 2 ? SiteActiveActive : SiteActiveInactive,
      } as ISite;
      this.props.dispatch(
        SESSION_ACTIONS_SET({
          site,
        }),
      );
      this.refreshModels(smallSite);
    };

    navigateToChannelList = () => {
      navigate(RouteChannelsView, extractRouteParams(this.props), {
        p: this.props.session.publisher.ID,
      });
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
        snackbarWarning: false,
      });
    };

    addPriceIncrement = () => {
      if (!this.props.session.site) {
        return;
      }

      let priceIncrement = this.state.PriceIncrements;
      if (!priceIncrement) {
        priceIncrement = [];
      }
      priceIncrement.push({
        Min: '0',
        Max: '1',
        Increment: '0.25',
      });
      this.setState({
        PriceIncrements: priceIncrement,
      });
    };

    // Handle changes in the search dropdown
    handlePublicaVaultDemandSourceExclusionItemAccept = (ids: Set<string>): void => {
      if (ids.size > 0) {
        this.setState({
          PublicaVaultExcludedDemandSources: Array.from(ids).join(','),
        });
      }
    };

    // Handle changes in the search dropdown
    handlePublicaVaultBiddersExclusionItemAccept = (ids: Set<string>): void => {
      if (ids.size > 0) {
        this.setState({
          PublicaVaultExcludedBidderIDs: Array.from(ids).join(','),
        });
      }
    };

    // Handle changes in the search dropdown
    handlePublicaVaultTTLItemAccept = (ids: Set<number>): void => {
      if (ids.size > 0) {
        const newPublicaVaultConfig = this.state.BidSaverConfig;
        newPublicaVaultConfig.TTL = Array.from(ids)[0];
        this.setState({
          BidSaverConfig: newPublicaVaultConfig,
        });
      }
    };

    // Handle changes in the search dropdown
    handleBypassBiddersItemAccept = (ids: Set<string>, index: number): void => {
      if (ids.size > 0) {
        const BypassDedupConfig = this.state.BypassDedupConfig;
        BypassDedupConfig[index].BidderIDs = Array.from(ids).join(',');
        this.setState({
          BypassDedupConfig,
        });
      }
    };

    // Handle changes in the search dropdown
    handleBypassHouseAdsItemAccept = (ids: Set<string>, index: number): void => {
      if (ids.size > 0) {
        const BypassDedupConfig = this.state.BypassDedupConfig;
        BypassDedupConfig[index].HouseAdIDs = Array.from(ids).join(',');
        this.setState({
          BypassDedupConfig,
        });
      }
    };

    // Handle changes in the search dropdown
    handleBypassDeduplicationItemAccept = (ids: Set<string>, index: number): void => {
      if (ids.size > 0) {
        const bypassDedupConfig = this.state.BypassDedupConfig;
        bypassDedupConfig[index].BypassMediafileDedup = ids.has('BypassMediafileDedup')
          ? EBool.EBool_TRUE
          : EBool.EBool_FALSE;
        bypassDedupConfig[index].BypassAdomainDedup = ids.has('BypassAdomainDedup')
          ? EBool.EBool_TRUE
          : EBool.EBool_FALSE;
        bypassDedupConfig[index].BypassIABCatDedup = ids.has('BypassIABCatDedup')
          ? EBool.EBool_TRUE
          : EBool.EBool_FALSE;
        this.setState({
          BypassDedupConfig: bypassDedupConfig,
        });
      }
    };

    addBypassDedupConfig = (): void => {
      if (!this.props.session.site) {
        return;
      }

      let BypassDedupConfig = this.state.BypassDedupConfig;
      if (!BypassDedupConfig) {
        BypassDedupConfig = [];
      }
      BypassDedupConfig.push({
        BypassMediafileDedup: EBool.EBool_FALSE,
        BypassAdomainDedup: EBool.EBool_FALSE,
        BypassIABCatDedup: EBool.EBool_FALSE,
        BypassDedupByAdAsSeparation: EBool.EBool_FALSE,
        BypassDedupAdCount: 1,
        BypassDedupByDurationAsSeparation: EBool.EBool_FALSE,
        BypassDedupDuration: 15,
        BypassDedupIfSurroundedByDedupedAds: EBool.EBool_FALSE,
        BidderIDs: '',
        HouseAdIDs: '',
        BidderOptions: this.state.bidderOptions,
        HouseAdsOptions: this.state.houseAdsOptions,
        IsBypassAdomainFieldsOpen: EBool.EBool_FALSE,
        IsAdomainExactMatch: EBool.EBool_TRUE,
        Adomain: [],
        AdomainUserEntry: '',
        AdomainStrings: '',
      });

      this.setState({
        BypassDedupConfig,
      });
    };

    handleChangePriceIncrement = (index: number) => {
      return ({ target }: React.ChangeEvent<HTMLInputElement>): void => {
        (this.state.PriceIncrements[index] as Record<string, string>)[target.name] = target.value;
        this.setState({
          PriceIncrements: this.state.PriceIncrements,
        });
      };
    };

    removePriceIncrement = (index: number) => {
      return () => {
        if (this.state.PriceIncrements && index < this.state.PriceIncrements.length) {
          this.state.PriceIncrements.splice(index, 1);
          this.setState({
            PriceIncrements: this.state.PriceIncrements,
          });
        }
      };
    };

    removeBypassDedupConfig = (index: number) => {
      const BypassDedupConfig = this.state.BypassDedupConfig;
      if (BypassDedupConfig && index < BypassDedupConfig.length) {
        BypassDedupConfig.splice(index, 1);
        this.setState({
          BypassDedupConfig,
          bypassDedupStateKey: this.state.bypassDedupStateKey + 1,
        });
      }
    };

    getSubSiteSettingsRoute = (id: number): string => {
      return getRoutePath(RouteChannelExisting, extractRouteParams(this.props), {
        ch: id.toString(),
      });
    };

    handleChange = (elem: React.ChangeEvent<HTMLInputElement>, isPercentage?: boolean) => {
      const { name, value } = elem.target;
      let newValue = value;

      if (isPercentage) {
        const floatValue = parseFloat(value);
        newValue = Number.isNaN(floatValue) ? '' : (floatValue / 100).toString();
        if (value[value.length - 1] === '.') {
          newValue += '.';
        }
      }

      if (hasErrors(this.state.errors)) {
        this.setState({
          errors: validate(this.state),
        });
      }

      const immutableUpdate = set({}, name, { $set: newValue });
      const newState = update(this.state, immutableUpdate);
      this.setState(newState);
    };

    handleChangeDebugDays = (elem: React.ChangeEvent<HTMLInputElement>): undefined => {
      if (elem.target.value === '') {
        this.setState({
          debugHeaderBidderEnabledUntilDays: 0,
        });
      } else {
        const debugHeaderBidderEnabledUntilDays = parseInt(elem.target.value, 10);
        if (
          Number.isNaN(debugHeaderBidderEnabledUntilDays) ||
          debugHeaderBidderEnabledUntilDays > 8
        ) {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'debug days must be between 0 and 8',
          });
        } else {
          this.setState({
            debugHeaderBidderEnabledUntilDays,
            DebugHeaderBidderEnabledUntil:
              debugHeaderBidderEnabledUntilDays !== 0
                ? moment(
                    moment.utc(new Date()).add(debugHeaderBidderEnabledUntilDays, 'day'),
                  ).format('YYYY-MM-DDTHH:mm:ssZ')
                : '',
          });
        }
      }
    };

    handleChangeSamplingDays = (elem: React.ChangeEvent<HTMLInputElement>): undefined => {
      if (elem.target.value === '') {
        this.setState({
          samplingPercentageDisabledUntilDays: 0,
          SamplingPercentageDisabledUntil: '',
        });
      } else {
        const samplingPercentageDisabledUntilDays = parseInt(elem.target.value, 10);
        if (
          Number.isNaN(samplingPercentageDisabledUntilDays) ||
          samplingPercentageDisabledUntilDays > 8
        ) {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'debug days must be between 0 and 8',
          });
        } else {
          this.setState({
            samplingPercentageDisabledUntilDays,
            SamplingPercentageDisabledUntil:
              samplingPercentageDisabledUntilDays !== 0
                ? moment(
                    moment.utc(new Date()).add(samplingPercentageDisabledUntilDays, 'day'),
                  ).format('YYYY-MM-DDTHH:mm:ssZ')
                : moment(moment.utc(new Date())).format('YYYY-MM-DDTHH:mm:ssZ'),
          });
        }
      }
    };

    handleChangeBidFloorAndBidFloorCurrency = (bidFloor: number, currency: CurrencyType) => {
      this.setState({
        BidFloor: bidFloor === undefined ? 0 : bidFloor,
        CurrencyDisplayed: convertStringToECurrencyType(currency),
      });
    };

    handleChangeEBool = (name: string) => {
      // @ts-ignore
      const currStatus = this.state[name];
      if (currStatus !== undefined) {
        this.setState({
          [name]: EBool.reverse(currStatus),
        });
      }
    };

    handleChange1ContentValue = (contentFieldIfEmpty: string, removeContentField: string) => {
      return ({ target }: React.ChangeEvent<HTMLInputElement>) => {
        if (hasErrors(this.state.errors)) {
          this.setState({
            errors: validate(this.state),
          });
        }

        this.setState({
          [target.name]: target.value,
          [contentFieldIfEmpty]:
            target.value === '' ? EBool.EBool_FALSE : (this.state as any)[contentFieldIfEmpty],
          [removeContentField]:
            target.value !== '' ? EBool.EBool_FALSE : (this.state as any)[removeContentField],
        });
      };
    };

    handleChange2EBoolContentFieldIfEmpty = (
      contentFieldIfEmpty: string,
      removeContentField: string,
    ) => {
      const currStatusContentFieldIfEmpty = (this.state as any)[contentFieldIfEmpty];
      const currStatusRemoveContentField = (this.state as any)[removeContentField];
      if (
        currStatusContentFieldIfEmpty !== undefined &&
        currStatusRemoveContentField !== undefined
      ) {
        this.setState({
          [contentFieldIfEmpty]: EBool.reverse(currStatusContentFieldIfEmpty),
          [removeContentField]:
            currStatusRemoveContentField === EBool.EBool_TRUE
              ? EBool.reverse(currStatusRemoveContentField)
              : currStatusRemoveContentField,
        });
      }
    };

    handleChange3EBoolRemoveContent = (
      contentFieldIfEmpty: string,
      removeContentField: string,
      contentField: string,
    ) => {
      const currStatusContentFieldIfEmpty = (this.state as any)[contentFieldIfEmpty];
      const currStatusRemoveContentField = (this.state as any)[removeContentField];
      if (
        currStatusContentFieldIfEmpty !== undefined &&
        currStatusRemoveContentField !== undefined
      ) {
        this.setState({
          [contentField]:
            currStatusRemoveContentField === EBool.EBool_FALSE
              ? ''
              : (this.state as any)[contentField].slice(),
          [contentFieldIfEmpty]:
            currStatusContentFieldIfEmpty === EBool.EBool_TRUE
              ? EBool.reverse(currStatusContentFieldIfEmpty)
              : currStatusContentFieldIfEmpty,
          [removeContentField]: EBool.reverse(currStatusRemoveContentField),
        });
      }
    };

    handleChangeRejectPodsWithAllHouseAds = (_: any, value: boolean) => {
      this.setState({
        RejectPodsWithAllHouseAds: value,
      });
    };

    handleChangeSelect = (name: string, value: string | string[] | number) => {
      this.setState({
        [name]: value,
      });
    };

    // update EndpointURL when Region is toggled
    handleChangeRegionSelect = (_: any, value: string) => {
      const isReseller = this.props.session.publisher.IsResellerPublisher === EBool.EBool_TRUE;

      if (this.state.EndpointURL && value === EUROPE) {
        if (
          this.state.EndpointURL.includes('pbs.') ||
          this.state.EndpointURL.includes('pbs-us-r0.')
        ) {
          this.setState((prevState) => {
            const newDomain = isReseller ? 'pbs-eu-r0' : 'pbs-eu';
            return {
              Region: EUROPE,
              EndpointURL: prevState.EndpointURL.replace(/pbs(-us-r0)?\./, `${newDomain}.`),
            };
          });
        } else if (
          this.state.EndpointURL.includes('pbs-au') ||
          this.state.EndpointURL.includes('pbs-jp')
        ) {
          this.setState((prevState) => {
            const newDomain = isReseller ? 'pbs-eu-r0' : 'pbs-eu';
            return {
              Region: EUROPE,
              EndpointURL: prevState.EndpointURL.replace(/pbs-(au|jp)(-r0)?\./, `${newDomain}.`),
            };
          });
        }
      } else if (this.state.EndpointURL && value === USA) {
        if (
          this.state.EndpointURL.includes('pbs-eu') ||
          this.state.EndpointURL.includes('pbs-au') ||
          this.state.EndpointURL.includes('pbs-jp')
        ) {
          this.setState((prevState) => {
            const newDomain = isReseller ? 'pbs-us-r0' : 'pbs';
            return {
              Region: USA,
              EndpointURL: prevState.EndpointURL.replace(/pbs-(eu|au|jp)(-r0)?\./, `${newDomain}.`),
            };
          });
        }
      } else if (this.state.EndpointURL && value === APAC) {
        if (
          this.state.EndpointURL.includes('pbs.') ||
          this.state.EndpointURL.includes('pbs-us-r0.')
        ) {
          this.setState((prevState) => {
            const newDomain = isReseller ? 'pbs-au-r0' : 'pbs-au';
            return {
              Region: APAC,
              EndpointURL: prevState.EndpointURL.replace(/pbs(-us-r0)?\./, `${newDomain}.`),
            };
          });
        } else if (
          this.state.EndpointURL.includes('pbs-eu') ||
          this.state.EndpointURL.includes('pbs-jp')
        ) {
          this.setState((prevState) => {
            const newDomain = isReseller ? 'pbs-au-r0' : 'pbs-au';
            return {
              Region: APAC,
              EndpointURL: prevState.EndpointURL.replace(/pbs-(eu|jp)(-r0)?\./, `${newDomain}.`),
            };
          });
        }
      } else if (this.state.EndpointURL && value === JAPAN) {
        if (
          this.state.EndpointURL.includes('pbs.') ||
          this.state.EndpointURL.includes('pbs-us-r0.')
        ) {
          this.setState((prevState) => {
            const newDomain = isReseller ? 'pbs-jp-r0' : 'pbs-jp';
            return {
              Region: JAPAN,
              EndpointURL: prevState.EndpointURL.replace(/pbs(-us-r0)?\./, `${newDomain}.`),
            };
          });
        } else if (
          this.state.EndpointURL.includes('pbs-eu') ||
          this.state.EndpointURL.includes('pbs-au')
        ) {
          this.setState((prevState) => {
            const newDomain = isReseller ? 'pbs-jp-r0' : 'pbs-jp';
            return {
              Region: JAPAN,
              EndpointURL: prevState.EndpointURL.replace(/pbs-(eu|au)(-r0)?\./, `${newDomain}.`),
            };
          });
        }
      }
    };

    handleCheckboxChange = (elem: React.ChangeEvent<HTMLInputElement>): void => {
      const { name: path, checked } = elem.target;

      const immutableUpdate = set({}, path, { $set: checked });
      const newState = update(this.state, immutableUpdate);
      this.setState(newState);
    };

    // updates the delivery type and
    // updates mime types based on the new selected delivery type
    handleChangeDeliveryType = (newDeliveryType: string) => {
      this.setState({
        HeaderBidderDeliveryType: newDeliveryType,
        MimeTypes: ['video/mp4', 'video/H264'],
        AllowVPAID: false,
      });
    };

    handleChangeMimeType = (newMimeTypes: string[]) => {
      const isImageSelected = newMimeTypes.some((mime) => mime.startsWith('image/'));
      if (!newMimeTypes.includes('video/mp4') && !isImageSelected) {
        newMimeTypes.unshift('video/mp4');
      }
      this.setState({
        MimeTypes: newMimeTypes,
      });
    };

    getMimeTypes = (deliveryType: string): IMimeType[] => {
      let typ = deliveryType;
      if (typ === 'Web') {
        if (this.state.AllowVPAID) {
          typ = 'WebVPAID';
        }
      }
      return mimeTypes[typ];
    };

    handleChangeDefaultWeight = (value: string) => {
      const weightNumber = parseInt(value, 10);
      this.setState({
        DefaultWeight: weightNumber,
      });
    };

    handleChangeAppStoreURLOverride = ({ rows, stateKey }: IHandleChangeAppOverrideProps) => {
      if (!this.props.session.site) return;
      const result: any = {};
      rows.forEach((row) => {
        result[row.device] = row.text;
      });
      const updatedData = Object.assign({}, this.state[stateKey]);
      AppOverrideKeys.forEach((device: string) => {
        if (result[device]) {
          updatedData[device] = result[device];
        } else {
          updatedData[device] = '';
        }
      });
      this.setState({
        [stateKey]: updatedData,
        rewiteInputRows: {
          ...this.state.rewiteInputRows,
          [stateKey]: rows,
        },
      });
    };

    handleChangeAppOverride = ({ rows, stateKey }: IHandleChangeAppOverrideProps) => {
      if (!this.props.session.site) return;

      const updatedData = {} as { [key: string]: string };

      rows.forEach((row: IRewriteActiveRow) => {
        updatedData[row.device] = row.text || '';
      });

      this.setState({
        [stateKey]: updatedData,
        rewiteInputRows: {
          ...this.state.rewiteInputRows,
          [stateKey]: rows,
        },
      });
    };

    deleteCurrentSite = (): void => {
      if (this.state.updating) {
        this.setState({
          snackbarMessage: 'Cannot delete site while site is updating',
          snackbarError: true,
          snackbarWarning: false,
        });
      }
      const site = this.props.session.site;
      if (!site) {
        this.navigateToChannelList();
        return;
      }

      this.setState(
        {
          loading: true,
        },
        () => {
          deleteSite({
            query: {
              publisher_id: this.props.session.publisher.ID,
              site_id: site.ID,
            },
          })
            .then(
              () => {
                this.state.sites.forEach((item, index) => {
                  if (item.UUID === site.UUID) {
                    this.state.sites.splice(index, 1);
                  }
                });

                this.setState({
                  snackbarMessage: 'Site deleted',
                  loading: false,
                  sites: this.state.sites,
                });
              },
              (err: Error) => {
                this.setState({
                  snackbarMessage: `Failed to delete site: ` + err.toString(),
                  snackbarError: true,
                  snackbarWarning: false,
                  loading: false,
                });
              },
            )
            .then(() => {
              // if delete was successful, navigate to full channel list after two seconds
              if (!this.state.snackbarError) {
                setTimeout(this.navigateToChannelList, 2000);
              }
            });
        },
      );
    };

    handleNameChange = (name: string): void => {
      this.setState({
        SiteName: name,
      });
    };

    handleChangeSwitch = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      // if bulk update is active and the field has dependant, then recheck the fields dependencies
      if (this.state.isBulkUpdate && BulkUpdateFieldDependency.has(target.name)) {
        this.handleBulkUpdateCheckboxFieldDependency(target.checked, target.name);
      }
      // Handle "Debug Mode" switch
      if (target.name === 'Debug') {
        this.setState({
          DebugHeaderBidder: this.state.DebugHeaderBidder === 1 ? 2 : 1, // Switch Debug value
        });
      } else if (target.name === 'AllowVPAID') {
        if (target.checked) {
          const mimeTypes = this.state.MimeTypes;
          if (!mimeTypes.includes('application/javascript')) {
            // add application/javascript to mimetypes
            mimeTypes.push('application/javascript');
          }
          this.setState({
            AllowVPAID: true,
            MimeTypes: mimeTypes,
          });
        } else {
          this.setState({
            AllowVPAID: false,
            MimeTypes: this.state.MimeTypes.filter((mimeType: string): boolean => {
              // remove application/javascript from mimetypes
              return mimeType !== 'application/javascript';
            }),
          });
        }
      } else if (target.name === 'BidsBelowDealFloorIsAllowed') {
        if (target.checked) {
          this.setState({
            BidsBelowDealFloorIsAllowed: EBool.EBool_TRUE,
            AllowBidsBelowDealFloor: AllowBidsBelowDealFloor_BY_VALUE,
          });
        } else {
          this.setState({
            BidsBelowDealFloorIsAllowed: EBool.EBool_FALSE,
            AllowBidsBelowDealFloor: AllowBidsBelowDealFloor_DO_NOT_ALLOW,
          });
        }
      } else if (target.name === 'SitePriceExtension') {
        if (target.checked) {
          this.setState({
            SitePriceExtension: SitePriceExtension_true,
          });
        } else {
          this.setState({
            SitePriceExtension: SitePriceExtension_false,
          });
        }
      } else if (target.id === 'boolean') {
        this.setState({
          [target.name]: target.checked,
        });
      } else if (target.id === 'EBool') {
        if (
          target.name === 'PublicaVaultEnabled' &&
          EBool.isTrue(this.state.PublicaVaultEnabled) &&
          !target.checked
        ) {
          // clear Demand Source List when switching Publica Vault off
          this.generateDemandSourceList();
        }
        if (
          target.name === 'EnableIASFirstPartyVASTTracking' &&
          target.checked === true &&
          !this.props.session.publisher.IASAnID
        ) {
          target.checked = false;
          this.setState({
            snackbarWarning: true,
            snackbarError: false,
            snackbarMessage:
              'Please talk to your account manager to enable first party measurement tools.',
          });
        }

        if (
          target.name === 'EnableIASFirstPartyVASTTracking' &&
          target.checked === true &&
          this.props.session.publisher.EnableIASFirstPartyVASTTracking === EBool.EBool_FALSE
        ) {
          target.checked = false;
          this.setState({
            snackbarWarning: true,
            snackbarError: false,
            snackbarMessage: 'Please enable Measurement inside of the publisher settings.',
          });
        }

        this.setState({
          [target.name]: EBool.fromBool(target.checked),
        });
      }
    };

    handleChangeActive = () => {
      // super users can always toggle active and anyone can always deactivate a site
      const Active = this.state.Active === SiteActiveActive ? SiteActiveInactive : SiteActiveActive;
      if (
        hasRoleSuperUser(this.props.user.user) ||
        this.state.DisableActivationForNonSuperUser === null ||
        this.state.DisableActivationForNonSuperUser === '' ||
        this.state.Active === SiteActiveActive
      ) {
        this.setState({
          Active,
        });
        return;
      }

      // if activation has been disabled by DeactivateUnprofitableSites in the last 2 weeks, don't allow pub to activate
      if (
        this.state.Active === SiteActiveInactive &&
        this.state.DisableActivationForNonSuperUser !== ''
      ) {
        const disableActivationForNonSuperUser = moment.utc(
          this.state.DisableActivationForNonSuperUser,
        );
        if (disableActivationForNonSuperUser.isAfter(moment.now())) {
          this.setState({
            snackbarError: true,
            snackbarMessage: ct('DisableActivationForNonSuperUser'),
          });
        } else {
          this.setState({
            Active,
          });
        }
      }
    };

    handleChangeCreativeQualityAssurance = (name: string, value: string) => {
      this.setState({
        [name]: value,
      });
    };

    getSiteDomainOverrideRow(device: string) {
      return {
        renderType: 'Textfield',
        title1: device,
        field1: 'SiteDomainOverride',
        value1: this.state.SiteDomainOverride[device],
        handleChange1: ({ target }: React.ChangeEvent<HTMLInputElement>) => {
          this.state.SiteDomainOverride[device] = target.value;
          this.setState({
            SiteDomainOverride: this.state.SiteDomainOverride,
          });
        },
        isActiveValue1: () => this.state.SiteDomainOverride[device] || '' !== '',
        getActiveTag1: (active: boolean) => (active ? device : ''),
        placeholderText: 'Enter Site Domain Override value here',
      } as IInputRow;
    }

    getSiteNameOverrideRow(device: string) {
      return {
        renderType: 'Textfield',
        title1: device,
        field1: 'SiteNameOverride',
        value1: this.state.SiteNameOverride[device],
        handleChange1: ({ target }: React.ChangeEvent<HTMLInputElement>) => {
          this.state.SiteNameOverride[device] = target.value;
          this.setState({
            SiteNameOverride: this.state.SiteNameOverride,
          });
        },
        isActiveValue1: () => this.state.SiteNameOverride[device] || '' !== '',
        getActiveTag1: (active: boolean) => (active ? device : ''),
        placeholderText: 'Enter Site Name Override value here',
      } as IInputRow;
    }

    getAppCatOverrideRow() {
      return {
        renderType: 'Textfield',
        title1: 'Override',
        field1: 'AppCatOverride',
        value1: this.state.AppCatOverride,
        handleChange1: ({ target }: React.ChangeEvent<HTMLInputElement>) => {
          this.state.AppCatOverride = target.value;
          this.setState({
            AppCatOverride: this.state.AppCatOverride,
          });
        },
        isActiveValue1: () => this.state.AppCatOverride || '' !== '',
        getActiveTag1: (active: boolean) => (active ? 'Active' : ''),
        placeholderText: 'Enter App Cat Override value here',
      } as IInputRow;
    }

    getInventoryPartnerDomainOverrideRow() {
      return {
        renderType: 'Textfield',
        title1: 'Override',
        field1: 'InventoryPartnerDomainOverride',
        value1: this.state.InventoryPartnerDomainOverride,
        handleChange1: ({ target }: React.ChangeEvent<HTMLInputElement>) => {
          this.state.InventoryPartnerDomainOverride = target.value;
          this.setState({
            InventoryPartnerDomainOverride: this.state.InventoryPartnerDomainOverride,
          });
        },
        isActiveValue1: () => this.state.InventoryPartnerDomainOverride || '' !== '',
        getActiveTag1: (active: boolean) => (active ? 'Active' : ''),
        placeholderText: 'Enter Inventory Partner Domain Override value here',
      } as IInputRow;
    }

    generateDeviceOverridePanel = (): IAccordionPanel => {
      const AnonymizeDeviceIDRow = {
        renderType: 'CheckboxAndInfo',
        title1: 'Anonymize Device ID',
        field1: 'AnonymizeDeviceID',
        value1: this.state.AnonymizeDeviceID,
        handleChange1: () => this.handleChangeEBool('AnonymizeDeviceID'),
        isActiveValue1: () => this.state.AnonymizeDeviceID === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? 'Anonymize Device ID' : ''),
      } as IInputRow;
      return {
        title: 'Device',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [AnonymizeDeviceIDRow],
      } as IAccordionPanel;
    };

    toggleSkip = () => {
      this.setState({ Skip: EBool.reverse(this.state.Skip) });
    };

    generateVideoPanel = (): IAccordionPanel => {
      const MinAdDurationOverrideRow = {
        renderType: 'NumberTextfield',
        title1: 'Min Ad Duration Override ',
        field1: 'MinAdDurationOverride',
        value1: this.state.MinAdDurationOverride,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.MinAdDurationOverride !== 0,
        getActiveTag1: (active: boolean) => (active ? 'Min Ad Duration' : ''),
        placeholderText: 'In seconds',
        disabled1: false,
      } as IInputRow;
      const MaxAdDurationOverrideRow = {
        renderType: 'NumberTextfield',
        title1: 'Max Ad Duration Override',
        field1: 'MaxAdDurationOverride',
        value1: this.state.MaxAdDurationOverride,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.MaxAdDurationOverride !== 0,
        getActiveTag1: (active: boolean) => (active ? 'Max Ad Duration' : ''),
        placeholderText: 'In seconds',
        disabled1: false,
      } as IInputRow;
      const StartDelayOverrideRow = {
        renderType: 'NumberTextfield',
        title1: 'Start Delay Override',
        field1: 'StartDelayOverride',
        value1:
          this.state.StartDelayOverride === EStartDelay.StartDelay_UnknownNotSet
            ? undefined
            : this.state.StartDelayOverride,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () =>
          !startDelayOverrideIsEmpty(this.state.StartDelayOverride) &&
          this.state.StartDelayOverride !== EStartDelay.StartDelay_UnknownNotSet,
        getActiveTag1: (active: boolean) => (active ? 'Start Delay Override' : ''),
        tooltipText: 'Refer to Section 5.12 of the oRTB Spec for acceptable values.',
        disabled1: false,
      } as IInputRow;
      const ClearMaxMinBitrateRow = {
        renderType: 'CheckboxAndInfo',
        title1: 'Clear default max/min bitrate',
        field1: 'ClearDefaultBitrateLimits',
        value1: this.state.ClearDefaultBitrateLimits,
        handleChange1: () => this.handleChangeEBool('ClearDefaultBitrateLimits'),
        isActiveValue1: () => this.state.ClearDefaultBitrateLimits === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? 'Clear Bitrate' : ''),
        tooltipText:
          'Use this option to only pass a min and max bitrate if its sent in the endpoint request.',
      } as IInputRow;
      const SkipRow = {
        renderType: 'SimpleSwitch',
        title1: 'Skip',
        field1: 'Skip',
        value1: this.state.Skip === EBool.EBool_TRUE,
        handleChange1: this.toggleSkip,
        isActiveValue1: () => this.state.Skip === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? 'Skip' : ''),
      } as IInputRow;
      const SkipMinRow = {
        renderType: 'NumberTextfield',
        title1: 'Skip Min',
        field1: 'SkipMin',
        value1: this.state.SkipMin,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.SkipMin !== 0,
        getActiveTag1: (active: boolean) => (active ? 'Skip Min' : ''),
        disabled1: this.state.Skip !== EBool.EBool_TRUE,
        tooltipText:
          'Videos of total duration greater than this number of seconds can be skippable; only applicable if the ad is skippable.',
        placeholderText: 'In seconds',
      } as IInputRow;
      const SkipAfterRow = {
        renderType: 'NumberTextfield',
        title1: 'Skip After',
        field1: 'SkipAfter',
        value1: this.state.SkipAfter,
        maxWidth: 90,
        handleChange1: this.handleChange,
        isActiveValue1: () => this.state.SkipAfter !== 0,
        getActiveTag1: (active: boolean) => (active ? 'Skip After' : ''),
        disabled1: this.state.Skip !== EBool.EBool_TRUE,
        tooltipText:
          'Number of seconds a video must play before skipping is enabled; only applicable if the ad is skippable.',
        placeholderText: 'In seconds',
      } as IInputRow;
      return {
        title: 'Video',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [
          MinAdDurationOverrideRow,
          MaxAdDurationOverrideRow,
          StartDelayOverrideRow,
          ClearMaxMinBitrateRow,
          SkipRow,
          SkipMinRow,
          SkipAfterRow,
        ],
      } as IAccordionPanel;
    };

    generatePMPPanel = (): IAccordionPanel => {
      const EndpointDealIDPassthroughActiveRow = {
        renderType: 'CheckboxAndInfo',
        title1: 'Deal ID passthrough from Endpoint',
        field1: 'EndpointDealIDPassthroughActive',
        value1: this.state.EndpointDealIDPassthroughActive,
        handleChange1: () => this.handleChangeEBool('EndpointDealIDPassthroughActive'),
        isActiveValue1: () => this.state.EndpointDealIDPassthroughActive === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? 'Endpoint Deal ID' : ''),
        tooltipText:
          'If enabled, deal IDs passed through the endpoint request will be added to the bid request',
      } as IInputRow;

      return {
        title: 'PMP',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [EndpointDealIDPassthroughActiveRow],
      } as IAccordionPanel;
    };

    generateUserPanel = (): IAccordionPanel => {
      const AnonymizeIPRow = {
        renderType: 'CheckboxAndInfo',
        title1: 'Anonymize IP',
        field1: 'AnonymizeIP',
        value1: this.state.AnonymizeIP,
        handleChange1: () => this.handleChangeEBool('AnonymizeIP'),
        isActiveValue1: () => this.state.AnonymizeIP === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? 'Anonymize IP' : ''),
      } as IInputRow;
      const SetCoppaToOneRow = {
        renderType: 'SimpleSwitch',
        title1: 'Set Coppa to 1',
        field1: 'SetCoppaToOne',
        value1: this.state.SetCoppaToOne === EBool.EBool_TRUE,
        handleChange1: () => this.handleChangeEBool('SetCoppaToOne'),
        isActiveValue1: () => this.state.SetCoppaToOne === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? 'Set Coppa to 1' : ''),
      } as IInputRow;
      return {
        title: 'User',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [AnonymizeIPRow, SetCoppaToOneRow],
      } as IAccordionPanel;
    };

    generateContentPanel = (): IAccordionPanel => {
      const isSuperUser = hasRoleSuperUser(this.props.user.user);
      const enableExtendedRewrites =
        this.props.session.publisher.EnableExtendedRewrites === EBool.EBool_TRUE;
      // CONTENT PANEL AND ROWS
      const RemoveContentFromEndpointRequestRow = {
        renderType: 'SimpleSwitch',
        title1: 'Remove entire content object from endpoint request',
        field1: 'RemoveContentFromEndpointRequest',
        value1: this.state.RemoveContentFromEndpointRequest === EBool.EBool_TRUE,
        handleChange1: () => this.handleChangeEBool('RemoveContentFromEndpointRequest'),
        isActiveValue1: () => this.state.RemoveContentFromEndpointRequest === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? 'Remove Content' : ''),
      } as IInputRow;

      const contentOverrideRows = Object.keys(contentOverrideRowsMap).map((contentItem: string) => {
        const contentTitle = `Content ${contentOverrideRowsMap[contentItem]} Override`;
        const contentField = `Content${contentItem}Override`;
        const contentFieldIfEmpty = `Content${contentItem}OverrideIfEmpty`;
        const removeContentField = `RemoveContent${contentItem}FromEndpointRequest`;
        return {
          renderType: 'TextfieldAndDoubleSwitch',
          title1: contentTitle,
          field1: contentField,
          value1: (this.state as any)[contentField],
          handleChange1: this.handleChange1ContentValue(contentFieldIfEmpty, removeContentField),
          isActiveValue1: () =>
            ((this.state as any)[contentField] !== '' ||
              (this.state as any)[removeContentField] === EBool.EBool_TRUE) &&
            this.state.RemoveContentFromEndpointRequest === EBool.EBool_FALSE,
          getActiveTag1: (active: boolean) =>
            active ? `Content ${contentOverrideRowsMap[contentItem]}` : '',

          title2: 'Add value only if obj. empty in endpoint request',
          value2: (this.state as any)[contentFieldIfEmpty],
          handleChange2: () =>
            this.handleChange2EBoolContentFieldIfEmpty(contentFieldIfEmpty, removeContentField),

          title3: `Remove ${contentOverrideRowsMap[contentItem].toLowerCase()} from request`,
          value3: (this.state as any)[removeContentField],
          handleChange3: () =>
            this.handleChange3EBoolRemoveContent(
              contentFieldIfEmpty,
              removeContentField,
              contentField,
            ),

          placeholderText: `Enter ${contentTitle} value here`,
          disabled1: this.state.RemoveContentFromEndpointRequest === EBool.EBool_TRUE,
        } as IInputRow;
      });

      const removeContentRows = Object.keys(contentOverrideRowsMap).map((contentItem: string) => {
        const removeContentField = `RemoveContent${contentItem}FromEndpointRequest`;
        return {
          renderType: 'SimpleSwitch',
          title1: `Remove ${contentOverrideRowsMap[contentItem].toLowerCase()} from request`,
          field1: removeContentField,
          value1: (this.state as any)[removeContentField] === EBool.EBool_TRUE,
          handleChange1: () => this.handleChangeEBool(removeContentField),
          isActiveValue1: () => (this.state as any)[removeContentField] === EBool.EBool_TRUE,
          getActiveTag1: (active: boolean) =>
            active ? `Remove ${contentOverrideRowsMap[contentItem]}` : '',
        } as IInputRow;
      });
      return {
        title: !enableExtendedRewrites && isSuperUser ? 'Content *' : 'Content',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows:
          this.props.session.publisher.EnableExtendedRewrites === EBool.EBool_TRUE || isSuperUser
            ? [RemoveContentFromEndpointRequestRow, ...contentOverrideRows]
            : [RemoveContentFromEndpointRequestRow, ...removeContentRows],
      } as IAccordionPanel;
    };

    // content postbid panel
    generateContentPostBidPanel = (): IAccordionPanel => {
      // CONTENT PANEL AND ROWS
      const contentPostBidOverrideRows = Object.keys(contentOverrideRowsMap).map(
        (contentItem: string) => {
          const contentTitle = `Content ${contentOverrideRowsMap[contentItem]} PostBid Override`;
          const contentField = `Content${contentItem}PostBidOverride`;
          const contentFieldIfEmpty = `Content${contentItem}PostBidOverrideIfEmpty`;
          return {
            renderType: 'TextfieldAndSwitch',
            title1: contentTitle,
            field1: contentField,
            value1: (this.state as any)[contentField],
            handleChange1: this.handleChange,
            isActiveValue1: () => (this.state as any)[contentField] !== '',
            getActiveTag1: (active: boolean) => (active ? `Content ${contentItem}` : ''),

            title2: 'Add value only if obj. empty in endpoint request',
            value2: (this.state as any)[contentFieldIfEmpty],
            handleChange2: () => this.handleChangeEBool(contentFieldIfEmpty),

            placeholderText: `Enter ${contentTitle} value here`,
          } as IInputRow;
        },
      );
      return {
        title: 'Content',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        disableActiveTags: true,
        rows: [...contentPostBidOverrideRows],
      } as IAccordionPanel;
    };

    generateSchainPanel = (): IAccordionPanel => {
      // SOURCE PANEL AND ROWS
      const AddSchainToBidRequestRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add schain to bid request',
        field1: 'EnableAddSchainToBidRequest',
        value1: this.state.EnableAddSchainToBidRequest === EBool.EBool_TRUE,
        defaultValue1: false,
        handleChange1: () => this.handleChangeEBool('EnableAddSchainToBidRequest'),
        isActiveValue1: () => this.state.EnableAddSchainToBidRequest === EBool.EBool_TRUE,
        getActiveTag1: (active: boolean) => (active ? 'Add Schain' : ''),
      } as IInputRow;
      const SchainCompleteRow = {
        renderType: 'SimpleSingleSelect',
        enableSmallRow: true,
        simpleSelectItems: [
          { key: 0, text: '0' },
          { key: 1, text: '1' },
        ],
        title1: 'Complete *',
        field1: 'SchainComplete',
        value1: this.state.SchainComplete,
        defaultValue1: 0,
        handleChange1: (elem) => this.handleChange(elem, false),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        disabled1: false,
      } as IInputRow;
      const SchainASIRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'ASI',
        field1: 'SchainASI',
        value1: this.state.SchainASI,
        defaultValue1: '',
        maxWidth: 400,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const SchainSIDRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'SID',
        field1: 'SchainSID',
        value1: this.state.SchainSID,
        defaultValue1: '',
        maxWidth: 400,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const SchainNameRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Name',
        field1: 'SchainName',
        value1: this.state.SchainName,
        defaultValue1: '',
        maxWidth: 400,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const SchainDomainRow = {
        renderType: 'Textfield',
        enableSmallRow: true,
        title1: 'Domain',
        field1: 'SchainDomain',
        value1: this.state.SchainDomain,
        defaultValue1: '',
        maxWidth: 400,
        handleChange1: this.handleChange,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;

      let schainRows = [AddSchainToBidRequestRow];
      if (this.state.EnableAddSchainToBidRequest === EBool.EBool_TRUE) {
        if (hasRoleSuperUser(this.props.user.user)) {
          schainRows.push(SchainCompleteRow);
        }
        schainRows = schainRows.concat([
          SchainASIRow,
          SchainSIDRow,
          SchainNameRow,
          SchainDomainRow,
        ]);
      }
      return {
        title: 'Supply Chain',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: schainRows,
      } as IAccordionPanel;
    };

    // ############################## GO TO FUNCTIONS ##############################

    gotoCreativeURLs = () => {
      if (!this.state.ID) {
        return;
      }
      navigateToRouteWithQueryParams(
        RouteBrandSafetyList,
        { site_id: this.state.ID },
        extractRouteParams(this.props),
      );
    };

    generateRewriteInputRows = ({
      stateKey,
      activeRows = [],
      handleChange,
      selectTitle,
      textfieldTitle,
      placeholderText = '',
      addButtonText = '+ Add',
    }: IGenerateRewriteInputRowsProps): IInputRow[] => {
      const activeItems: string[] = activeRows.map((row: IRewriteActiveRow) => row.device);
      const inactiveItems = this.state.appStoreURLs.filter(
        (device: string) => !activeItems.includes(device),
      );

      const handleSelect = ({ e, idx }: { e: React.ChangeEvent<HTMLLIElement>; idx: number }) => {
        const newRows = [...activeRows];
        newRows[idx].device = String(e.target?.value);
        handleChange({ rows: newRows, stateKey });
      };

      const handleTextFieldChange = ({ value, idx }: { value: string; idx: number }) => {
        const newRows = [...activeRows];
        newRows[idx].text = value;
        handleChange({ rows: newRows, stateKey });
      };

      const handleAdd = () => {
        handleChange({ rows: [...activeRows, { device: inactiveItems[0], text: '' }], stateKey });
      };

      const handleRemove = (idx: number) => {
        const newRows = [...activeRows];
        newRows.splice(idx, 1);
        handleChange({ rows: newRows, stateKey });
      };

      const inputRows = activeRows.map((row: IRewriteActiveRow, idx: number) => {
        const { device, text } = row;
        const title = device === 'Xbox' ? 'Microsoft or Xbox' : device;
        const items = [device, ...inactiveItems];
        return {
          renderType: 'SelectTextfieldRemove',
          idx,
          // SELECT
          title1: selectTitle,
          simpleSelectItems: items,
          value1: device,
          handleChange1: handleSelect,
          // TEXTFIELD
          title2: textfieldTitle,
          value2: text,
          placeholderText,
          handleChange2: handleTextFieldChange,
          // REMOVE BUTTON
          handleClick1: handleRemove,
          // OPTIONAL
          isActiveValue1: () => !!device && device !== '',
          getActiveTag1: (active: boolean) => (active ? title : ''),
        } as IInputRow;
      });

      // +ADD button
      inputRows.push({
        renderType: 'AddRowModelSecondaryButton',
        title1: addButtonText,
        handleClick1: handleAdd,
        disabled1: inactiveItems.length === 0,
        // Props below are mandatory for IInputRow
        // but are not applicable to this component
        isActiveValue1: () => false,
        getActiveTag1: (active: boolean) => (active ? '' : ''),
      } as IInputRow);

      return inputRows;
    };

    renderChannelLevelRewrite = () => {
      const { classes, session, user } = this.props;
      const isSuperUser = hasRoleSuperUser(user.user);
      const enableExtendedRewrites = session.publisher.EnableExtendedRewrites === EBool.EBool_TRUE;
      // Site related rewrite
      const siteRewrite = ['Web'];

      const AppStoreURLOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add value only if obj. empty in bid request',
        singleLineSwitchText: true,
        value1: this.state.AppStoreUrlOverrideIfEmpty === EBool.EBool_TRUE,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        handleChange1: () => this.handleChangeEBool('AppStoreUrlOverrideIfEmpty'),
      } as IInputRow;

      const AppStoreURLRows = this.generateRewriteInputRows({
        stateKey: 'AppStoreURL',
        activeRows: this.state.rewiteInputRows.AppStoreURL,
        handleChange: this.handleChangeAppStoreURLOverride,
        selectTitle: 'Device',
        textfieldTitle: 'App Store URL',
        placeholderText: 'Enter Store URL',
      });

      const AppStoreURLPanel = {
        title: enableExtendedRewrites ? 'App Store URL' : 'App Store URL *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [...AppStoreURLRows, AppStoreURLOverrideToggleRow],
      };

      // APP PANEL AND ROWS
      const AppBundleOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add value only if obj. empty in bid request',
        singleLineSwitchText: true,
        value1: this.state.AppBundleOverrideIfEmpty === EBool.EBool_TRUE,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        handleChange1: () => this.handleChangeEBool('AppBundleOverrideIfEmpty'),
      } as IInputRow;

      const SiteDomainOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add value only if obj. empty in bid request',
        value1: this.state.SiteDomainOverrideIfEmpty === EBool.EBool_TRUE,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        handleChange1: () => this.handleChangeEBool('SiteDomainOverrideIfEmpty'),
      } as IInputRow;

      const AppNameOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add value only if obj. empty in bid request',
        singleLineSwitchText: true,
        value1: this.state.AppNameOverrideIfEmpty === EBool.EBool_TRUE,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        handleChange1: () => this.handleChangeEBool('AppNameOverrideIfEmpty'),
      } as IInputRow;

      const AppDomainOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add value only if obj. empty in bid request',
        singleLineSwitchText: true,
        value1: this.state.AppDomainOverrideIfEmpty === EBool.EBool_TRUE,
        errors1: this.state.errors.AppDomainOverrideIfEmpty,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        handleChange1: () => this.handleChangeEBool('AppDomainOverrideIfEmpty'),
      } as IInputRow;

      const AppCatOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add value only if obj. empty in bid request',
        value1: this.state.AppCatOverrideIfEmpty === EBool.EBool_TRUE,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        handleChange1: () => this.handleChangeEBool('AppCatOverrideIfEmpty'),
      } as IInputRow;

      const AppNameOverrideRows = this.generateRewriteInputRows({
        stateKey: 'AppNameOverride',
        activeRows: this.state.rewiteInputRows.AppNameOverride,
        handleChange: this.handleChangeAppOverride,
        selectTitle: 'Device',
        textfieldTitle: 'App Name Override',
        placeholderText: 'Enter App Name Override Value',
      });

      const AppNameOverridePanel = {
        title: enableExtendedRewrites ? 'App Name Override' : 'App Name Override *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [...AppNameOverrideRows, AppNameOverrideToggleRow],
        optionalError: this.state.errors.AppNameOverride,
      } as IAccordionPanel;

      const AppDomainOverrideRows = this.generateRewriteInputRows({
        stateKey: 'AppDomainOverride',
        activeRows: this.state.rewiteInputRows.AppDomainOverride,
        handleChange: this.handleChangeAppOverride,
        selectTitle: 'Device',
        textfieldTitle: 'App Domain Override',
        placeholderText: 'Enter App Domain Override Value',
      });

      const AppDomainOverridePanel = {
        title: 'App Domain Override *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [...AppDomainOverrideRows, AppDomainOverrideToggleRow],
        optionalError: this.state.errors.AppDomainOverride,
      } as IAccordionPanel;

      const AppBundleOverrideRows = this.generateRewriteInputRows({
        stateKey: 'AppBundleOverride',
        activeRows: this.state.rewiteInputRows.AppBundleOverride,
        handleChange: this.handleChangeAppOverride,
        selectTitle: 'Device',
        textfieldTitle: 'App Bundle Override',
        placeholderText: 'Enter App Bundle Override Value',
      });

      const AppBundleOverridePanel = {
        title: enableExtendedRewrites ? 'App Bundle Override' : 'App Bundle Override *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [...AppBundleOverrideRows, AppBundleOverrideToggleRow],
        optionalError: this.state.errors.AppBundleOverride,
      } as IAccordionPanel;

      const AppIDOverrideRows = this.generateRewriteInputRows({
        stateKey: 'AppIDOverride',
        activeRows: this.state.rewiteInputRows.AppIDOverride,
        handleChange: this.handleChangeAppOverride,
        selectTitle: 'Device',
        textfieldTitle: 'App ID Override',
        placeholderText: 'Enter App ID Override Value',
      });

      const AppIDOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add value only if obj. empty in bid request',
        singleLineSwitchText: true,
        value1: this.state.AppIDOverrideIfEmpty === EBool.EBool_TRUE,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        handleChange1: () => this.handleChangeEBool('AppIDOverrideIfEmpty'),
      } as IInputRow;

      const AppIDOverridePanel = {
        title: enableExtendedRewrites ? 'App ID Override' : 'App ID Override *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [...AppIDOverrideRows, AppIDOverrideToggleRow],
        optionalError: this.state.errors.AppIDOverride,
      } as IAccordionPanel;

      const AppCatOverridePanel = {
        title: enableExtendedRewrites ? 'App Cat Override' : 'App Cat Override *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [AppCatOverrideToggleRow, this.getAppCatOverrideRow()],
      } as IAccordionPanel;

      const SiteDomainOverridePanel = {
        title: 'Site Domain Override *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [
          SiteDomainOverrideToggleRow,
          ...siteRewrite.map((device: string): IInputRow => this.getSiteDomainOverrideRow(device)),
        ],
        optionalError: this.state.errors.SiteDomainOverride,
      };

      const SiteNameOverridePanel = {
        title: enableExtendedRewrites ? 'Site Name Override' : 'Site Name Override *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: siteRewrite.map((device: string): IInputRow => this.getSiteNameOverrideRow(device)),
        optionalError: this.state.errors.SiteNameOverride,
      };

      const InventoryPartnerDomainOverrideToggleRow = {
        renderType: 'SimpleSwitch',
        title1: 'Add value only if obj. empty in bid request',
        value1: this.state.InventoryPartnerDomainOverrideIfEmpty === EBool.EBool_TRUE,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
        handleChange1: () => this.handleChangeEBool('InventoryPartnerDomainOverrideIfEmpty'),
      } as IInputRow;

      const InventoryPartnerDomainOverridePanel = {
        title: enableExtendedRewrites
          ? 'Inventory Partner Domain Override'
          : 'Inventory Partner Domain Override *',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        rows: [
          InventoryPartnerDomainOverrideToggleRow,
          this.getInventoryPartnerDomainOverrideRow(),
        ],
      } as IAccordionPanel;

      const contentPanel = this.generateContentPanel();
      const devicePanel = this.generateDeviceOverridePanel();
      const pmpPanel = this.generatePMPPanel();
      const userPanel = this.generateUserPanel();
      const videoPanel = this.generateVideoPanel();
      const contentPostBidPanel = [this.generateContentPostBidPanel()];
      const schainPanel = this.generateSchainPanel();

      /* If a user is a Super User the following is shown:
     AppStoreURLPanel, AppNameOverridePanel, AppDomainOverridePanel,
     AppBundleOverridePanel, AppIDOverridePanel, AppCatOverridePanel, SiteDomainOverridePanel,
     SiteNameOverridePanel, contentPanel, devicePanel, pmpPanel, userPanel,
     videoPanel, schainPanel]*/

      /* If a user is NOT a Super User then everything listed above is shown except the following:
     AppDomainOverridePanel, SiteDomainOverridePanel */

      let panels =
        isSuperUser || hasPermSuperUser(session.publisher.ID, user.user.PermissionRole.id)
          ? [
              AppStoreURLPanel,
              AppNameOverridePanel,
              AppDomainOverridePanel,
              AppBundleOverridePanel,
              AppIDOverridePanel,
              AppCatOverridePanel,
              SiteDomainOverridePanel,
              SiteNameOverridePanel,
              contentPanel,
              devicePanel,
              pmpPanel,
              userPanel,
              videoPanel,
              schainPanel,
              InventoryPartnerDomainOverridePanel,
            ]
          : [
              AppStoreURLPanel,
              AppNameOverridePanel,
              AppBundleOverridePanel,
              AppIDOverridePanel,
              AppCatOverridePanel,
              SiteNameOverridePanel,
              contentPanel,
              devicePanel,
              pmpPanel,
              userPanel,
              videoPanel,
              schainPanel,
              InventoryPartnerDomainOverridePanel,
            ];
      if (!enableExtendedRewrites && !isSuperUser) {
        // remove app and site rewrites
        panels = [
          contentPanel,
          devicePanel,
          pmpPanel,
          userPanel,
          videoPanel,
          schainPanel,
          InventoryPartnerDomainOverridePanel,
        ];
      }

      return (
        <Grid className={classes.mainGridItem}>
          <Grid className={classes.notPaper}>
            <Grid item style={{ marginBottom: 8 }}>
              <Grid container direction='column'>
                {/* Header */}
                <Grid item>
                  <HeadingCategorySm>Channel Level Rewrite</HeadingCategorySm>
                </Grid>
                <Grid item>
                  <Typography className={classes.headingCategorySubtitle}>
                    Set which ORTB objects below should be rewritten, altered or removed from
                    requests before reaching this channel
                  </Typography>
                </Grid>
                <MultiAccordion
                  title='ORTB Objects'
                  panels={panels}
                  disableEdit={!this.state.writeAuthorization.isAuthorized}
                />
              </Grid>
            </Grid>
            {(isSuperUser ||
              this.props.session.publisher.EnableExtendedRewritesPostBid === EBool.EBool_TRUE) && (
              <Grid item style={{ marginBottom: 8 }}>
                <Grid container direction='column'>
                  {/* Header */}
                  <Grid item>
                    <HeadingCategorySm>Channel Level PostBid Rewrite</HeadingCategorySm>
                  </Grid>
                  <Grid item>
                    <Typography className={classes.headingCategorySubtitle}>
                      Set which ORTB objects below should be rewritten or altered from requests post
                      bid
                    </Typography>
                  </Grid>
                  <MultiAccordion
                    title='ORTB Objects'
                    panels={contentPostBidPanel}
                    disableEdit={!this.state.writeAuthorization.isAuthorized}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      );
    };

    renderAppBar = () => {
      // get variables from the state
      const { ID, SiteName, updating, Active, isBulkUpdate, fieldsSelectedForBulkUpdate } =
        this.state;

      const totalCompletionPercent =
        this.state.endpointScorecardLevel1Scores.percentCompleted +
        this.state.endpointScorecardLevel2Scores.percentCompleted +
        this.state.endpointScorecardLevel3Scores.percentCompleted +
        this.state.endpointScorecardLevel4Scores.percentCompleted +
        this.state.endpointScorecardLevel5Scores.percentCompleted;
      return (
        <Grid item>
          <SettingsAppBar
            name={this.isUserInfoMasked() ? `demo_site_${ID}` : SiteName}
            isActive={Active === SiteActiveActive}
            hasWriteRights={this.getWriteChannelAuthorization().isAuthorized}
            isUpdating={updating}
            handleClose={this.navigateToChannelList}
            handleDelete={this.deleteCurrentSite}
            handleChangeActive={this.handleChangeActive}
            handleSave={this.updateSite}
            handleNameChange={this.handleNameChange}
            changeTabView={this.updateTab}
            isChannelBulkUpdate={isBulkUpdate}
            isChannel={true}
            disableSave={isBulkUpdate && fieldsSelectedForBulkUpdate.size === 0}
            endpointScorecard={{
              totalCompletionPercent,
            }}
            resourceID={this.state.ID}
            relative
          />
        </Grid>
      );
    };

    renderEndpoint = () => {
      const { classes } = this.props;
      return (
        <Grid className={classes.mainGridItem}>
          <Grid className={classes.notPaper}>
            <H3>Endpoint Builder</H3>
            {this.renderEndpointURLGenerator()}
          </Grid>
        </Grid>
      );
    };

    // renderDetails renders the content of the "details" tab
    renderDetails = () => {
      // get variable from the props
      const { classes, user } = this.props;

      // get variable from state
      const { isBulkUpdate } = this.state;

      // Check permissions
      const canReadChannelTimeout = IS_AUTHORIZED(
        ['channel_timeouts_read'],
        user.user,
      ).isAuthorized;
      const canWriteChannelTimeout = IS_AUTHORIZED(
        ['channel_timeouts_write'],
        user.user,
      ).isAuthorized;
      const isSuperUser = hasRoleSuperUser(user.user);

      return (
        <Grid className={classes.mainGridItem}>
          {/* Super-User Settings - NOT supported by bulk updating */}
          {(canReadChannelTimeout || canWriteChannelTimeout || isSuperUser) && !isBulkUpdate && (
            <Grid className={classes.notPaper}>
              {/* Global Timeout + Debug Slider */}
              <Grid item>
                <Grid
                  container
                  direction='column'
                  justify='space-between'
                  alignItems='flex-start'
                  spacing={2}
                >
                  {/* Global Timeout */}
                  {(canReadChannelTimeout || canWriteChannelTimeout) && (
                    <Grid item>
                      <TextField
                        label='Global Timeout'
                        name='Timeout'
                        style={{ width: '140px' }}
                        value={this.state.Timeout}
                        onChange={this.handleChange}
                        disabled={!(canWriteChannelTimeout || isSuperUser)}
                      />
                    </Grid>
                  )}

                  {isSuperUser &&
                    this.props.session.publisher.LogSamplingEnabled === EBool.EBool_TRUE && (
                      <Grid item>
                        <TextField
                          label='Sampling Days Disabled'
                          name='disable sampling (max 8 days)'
                          style={{ width: '180px' }}
                          value={this.state.samplingPercentageDisabledUntilDays}
                          onChange={this.handleChangeSamplingDays}
                        />
                        <Typography>
                          Sampling Disabled Until *: {this.state.SamplingPercentageDisabledUntil}
                        </Typography>
                        <Typography>
                          Sampling Percentage: {this.state.SamplingPercentageRequests}
                        </Typography>
                      </Grid>
                    )}

                  {/* Debug Slider - super-user only */}
                  {isSuperUser && (
                    <Grid item style={{ fontSize: '15px', fontWeight: 500 }}>
                      <Grid container direction='column' alignItems='flex-end' spacing={2}>
                        <Grid item>
                          Debug Mode *:{' '}
                          <Switch
                            className={classes.centeredSwitch}
                            checked={this.state.DebugHeaderBidder === 2}
                            name='Debug'
                            onChange={this.handleChangeSwitch}
                            value={this.state.DebugHeaderBidder}
                            color='primary'
                          />
                          {this.state.DebugHeaderBidder === 2 && (
                            <>
                              <TextField
                                label='Debug Days Enabled'
                                name='debugHeaderBidderEnabledUntilDays (max 8)'
                                style={{ width: '180px' }}
                                value={this.state.debugHeaderBidderEnabledUntilDays}
                                onChange={this.handleChangeDebugDays}
                              />
                              Debug Enabled Until: {this.state.DebugHeaderBidderEnabledUntil}
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          )}

          {/* RokuProviderChannelID Settings - NOT supported by bulk updating */}
          {isRoku() && !isBulkUpdate && (
            <Grid className={classes.notPaper}>
              <Grid item>
                <Grid
                  container
                  direction='row'
                  justify='space-between'
                  alignItems='center'
                  spacing={10}
                >
                  {/* Roku Provider Channel ID */}
                  <Grid item>
                    <TextField
                      label='Roku Provider Channel ID'
                      name='RokuProviderChannelIDStr'
                      style={{ width: '220px' }}
                      value={this.state.RokuProviderChannelIDStr}
                      onChange={this.handleChange}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {/* render the rest of the channel settings */}
          <Grid classes={{ root: classes.notPaper }}>
            <H3>Channel settings</H3>
            {this.renderInventorySettings()}
          </Grid>
        </Grid>
      );
    };

    // renderBulkUpdateSidebar renders the summary sidebar when doing bulk updates.
    renderBulkUpdateSidebar(): JSX.Element {
      // get values from state
      const { fieldsSelectedForBulkUpdate, bulkUpdateChannelIDs } = this.state;
      // get values from props
      const { classes } = this.props;

      // build the messages for the "Active Fields" section
      const activeFieldsMessages = [];
      if (fieldsSelectedForBulkUpdate.size === 0) {
        activeFieldsMessages.push('Select a field to edit.');
      }
      const activeFieldsContent = activeFieldsMessages.join(',');

      // build the list of selected fields for bulk update + their value
      const selectedFieldsAndValues = this.bulkUpdateGenerateFieldNameValueArray();

      // render
      return (
        <Grid
          item
          style={{
            backgroundColor: '#F5F5F5',
            width: '100%',
            height: '90vh',
            padding: '15px',
          }}
        >
          {/* summary section */}
          <Typography className={classes.headingCategoryTitle}>Summary</Typography>
          <Typography className={classes.insideAccordionText}>
            Current edits will impact the following:
          </Typography>

          {/* channels section */}
          <Typography className={classes.headingCategorySubTitle}>Channels</Typography>
          <Typography className={classes.insideAccordionText}>
            {`${bulkUpdateChannelIDs.length} Selected`}
          </Typography>

          {/* active fields section*/}
          <Typography className={classes.headingCategorySubTitle}>Active Fields</Typography>
          {/* alert messages */}
          <Typography className={classes.insideAccordionText}>{activeFieldsContent}</Typography>
          {/* list of all the selected fields */}
          <Grid container direction='column' alignItems='flex-start' spacing={1}>
            {selectedFieldsAndValues.map((field) => (
              // for each selected field
              <Grid item container direction='row' alignItems='center' spacing={1}>
                {/* checkbox */}
                <Grid item xs={1}>
                  <Checkbox
                    className={classes.checkbox}
                    checked={true}
                    onChange={() => this.handleBulkUpdateSelectionChange(false, field.name)}
                  />
                </Grid>
                {/* margin */}
                <Grid item xs={1} />
                {/* field name and value */}
                <Grid item xs={8}>
                  <Typography className={classes.insideAccordionTextBold}>
                    {field.name + ':'}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography className={classes.insideAccordionValue}>{field.value}</Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      );
    }

    // bulkUpdateRenderReview renders the change summary in the save confirmation popup.
    bulkUpdateRenderReview(): JSX.Element {
      // get variables from props
      const { classes } = this.props;

      // get the list of the selected fields and their value
      const selectedFields = this.bulkUpdateGenerateFieldNameValueArray();

      // render
      return (
        <Grid>
          {/* title */}
          <Typography style={{ color: '#666EFA' }}>Review edited fields:</Typography>

          {/* frame and grid around changes */}
          <Grid
            style={{
              border: '#cbcbcb',
              borderStyle: 'solid',
              borderWidth: 'thin',
              display: 'block',
              padding: 10,
              marginTop: 10,
            }}
          >
            <Grid container direction='column' alignItems='flex-start' spacing={1}>
              {/* for each selected fields */}
              {selectedFields.map((field) => (
                <Grid item container direction='row' alignItems='center' spacing={1}>
                  {/* checkbox */}
                  <Grid item xs={1}>
                    <Checkbox
                      className={classes.checkbox}
                      checked={true}
                      onChange={() => this.handleBulkUpdateSelectionChange(false, field.name)}
                    />
                  </Grid>
                  {/* margin */}
                  <Grid item xs={1} />
                  {/* field name */}
                  <Grid item xs={6}>
                    <Typography className={classes.insideAccordionTextBold}>
                      {field.name + ':'}
                    </Typography>
                  </Grid>
                  {/* field value */}
                  <Grid item xs={4}>
                    <Typography className={classes.insideAccordionText}>{field.value}</Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      );
    }

    renderBrandSafety = () => {
      const { classes } = this.props;
      return (
        <Grid className={classes.mainGridItem}>
          {/* Adomain Blocklist */}

          {/* BRAND SAFETY RULES */}
          <Paper classes={{ root: classes.paper }}>
            <Grid item container direction='row' alignItems='center' spacing={1}>
              <Grid item>
                <H3>Brand Safety Rules</H3>
              </Grid>
              {!!this.state.ID && (
                <Grid item>
                  <Button
                    onClick={() => this.gotoCreativeURLs()}
                    style={{
                      marginBottom: 7,
                      fontSize: 12,
                      color: '#666EFA',
                      textTransform: 'none',
                      fontWeight: 'normal',
                    }}
                  >
                    {'Creative URLs'}
                  </Button>
                </Grid>
              )}
            </Grid>
            {this.renderBrandSafetyRules()}
          </Paper>
        </Grid>
      );
    };

    renderEndpointShield = () => {
      const isReseller = this.props.session.publisher.IsResellerPublisher === EBool.EBool_TRUE;
      return (
        <EndpointShieldView
          siteId={this.state.ID}
          publisherId={this.props.session.publisher.ID}
          isReseller={isReseller}
        />
      );
    };

    renderEndpointScorecardLevels = () => {
      // PANEL HEADERS
      const Header = {
        renderType: 'custom',
        customRender: RenderEndpointScorecardPanelHeaders,
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      };

      // LEVEL 1 - Optimization score 30%
      const AppBundleOrSitePage = {
        title1: 'App Bundle or Site Page',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'App Bundle or Site Page',
            percent: this.state.endpointScorecardLevel1Scores.CountRequestHasAppBundleOrSitePage,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const PodDurationOrSlotCount = {
        title1: 'Pod Duration or Slot Count',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Pod Duration or Slot Count',
            percent: this.state.endpointScorecardLevel1Scores.CountRequestHasPodDurationOrSlotCount,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;

      const Level1 = {
        title: 'Level 1 - Bare Minimum',
        panelInactiveRowTag: '',
        panelActiveChipTitle: 'Custom',
        rows: [Header, AppBundleOrSitePage, PodDurationOrSlotCount],
        endpointScorecard: true,
        percentCompleted:
          Math.round(this.state.endpointScorecardLevel1Scores.percentCompleted * 100) / 100,
        paramsLeft: this.state.endpointScorecardLevel1Scores.paramsLeft,
        percentLeft: this.state.endpointScorecardLevel1Scores.percentLeft,
      } as IAccordionPanel;

      // LEVEL 2 - Optimization Score 25%
      const IP = {
        title1: 'IP',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'IP',
            percent: this.state.endpointScorecardLevel2Scores.CountRequestHasIP,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const UserAgent = {
        title1: 'User Agent',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'User Agent',
            percent: this.state.endpointScorecardLevel2Scores.CountRequestHasUserAgent,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const MaxAdDuration = {
        title1: 'Max Ad Duration',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Max Ad Duration',
            percent: this.state.endpointScorecardLevel2Scores.CountRequestHasMaxAdDuration,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const MinAdDuration = {
        title1: 'Min Ad Duration',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Min Ad Duration',
            percent: this.state.endpointScorecardLevel2Scores.CountRequestHasMinAdDuration,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;

      const Level2 = {
        title: 'Level 2 - Level Up',
        panelInactiveRowTag: '',
        panelActiveChipTitle: 'Custom',
        rows: [Header, IP, UserAgent, MaxAdDuration, MinAdDuration],
        endpointScorecard: true,
        percentCompleted:
          Math.round(this.state.endpointScorecardLevel2Scores.percentCompleted * 100) / 100,
        paramsLeft: this.state.endpointScorecardLevel2Scores.paramsLeft,
        percentLeft: this.state.endpointScorecardLevel2Scores.percentLeft,
      } as IAccordionPanel;

      // Level 3 - Optimization Score 20%
      // App Name and App Store URL only included if there are App requests for this site (this.state.CountRequestHasAppBundle > 0)
      const AppStoreUrl = {
        title1: 'App Store URL',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'App Store URL',
            percent: this.state.endpointScorecardLevel3Scores.CountRequestHasAppStoreUrl,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const AppName = {
        title1: 'App Name',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'App Name',
            percent: this.state.endpointScorecardLevel3Scores.CountRequestHasAppName,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const AppDomain = {
        title1: 'App Domain',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'App Domain',
            percent: this.state.endpointScorecardLevel3Scores.CountRequestHasAppDomain,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const ContentCategory = {
        title1: 'Content Category',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Content Category',
            percent: this.state.endpointScorecardLevel3Scores.CountRequestHasContentCategory,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const ContentChannel = {
        title1: 'Content Channel',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Content Channel',
            percent: this.state.endpointScorecardLevel3Scores.CountRequestHasContentChannel,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;

      const Level3 = {
        title: 'Level 3 - PMP Bait',
        panelInactiveRowTag: '',
        panelActiveChipTitle: 'Custom',
        rows:
          this.state.CountRequestHasAppBundle > 0
            ? [Header, AppStoreUrl, AppName, AppDomain, ContentCategory, ContentChannel]
            : [Header, ContentCategory, ContentChannel],
        endpointScorecard: true,
        percentCompleted:
          Math.round(this.state.endpointScorecardLevel3Scores.percentCompleted * 100) / 100,
        paramsLeft: this.state.endpointScorecardLevel3Scores.paramsLeft,
        percentLeft: this.state.endpointScorecardLevel3Scores.percentLeft,
      } as IAccordionPanel;

      // Level 4 - Optimization Score 15%
      const ContentGenre = {
        title1: 'Content Genre',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Content Genre',
            percent: this.state.endpointScorecardLevel4Scores.CountRequestHasContentGenre,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const ContentRating = {
        title1: 'Content Rating',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Content Rating',
            percent: this.state.endpointScorecardLevel4Scores.CountRequestHasContentRating,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;

      const Level4 = {
        title: 'Level 4 - Show Me the Money',
        panelInactiveRowTag: '',
        panelActiveChipTitle: 'Custom',
        rows: [Header, ContentGenre, ContentRating],
        endpointScorecard: true,
        percentCompleted:
          Math.round(this.state.endpointScorecardLevel4Scores.percentCompleted * 100) / 100,
        paramsLeft: this.state.endpointScorecardLevel4Scores.paramsLeft,
        percentLeft: this.state.endpointScorecardLevel4Scores.percentLeft,
      } as IAccordionPanel;

      // Level 5 - Optimization Score 10%
      const ContentTitle = {
        title1: 'Content Title',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Content Title',
            percent: this.state.endpointScorecardLevel5Scores.CountRequestHasContentTitle,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const ContentID = {
        title1: 'Content ID',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Content ID',
            percent: this.state.endpointScorecardLevel5Scores.CountRequestHasContentID,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;
      const ContentNetwork = {
        title1: 'Content Network',
        renderType: 'custom',
        customRender: () =>
          RenderEndpointScorecardPanel({
            title1: 'Content Network',
            percent: this.state.endpointScorecardLevel5Scores.CountRequestHasContentNetwork,
          }),
        isActiveValue1: () => false,
        getActiveTag1: () => '',
      } as IInputRow;

      const Level5 = {
        title: 'Level 5 - Chicken Dinner',
        panelInactiveRowTag: '',
        panelActiveChipTitle: 'Custom',
        rows: [Header, ContentTitle, ContentID, ContentNetwork],
        endpointScorecard: true,
        percentCompleted:
          Math.round(this.state.endpointScorecardLevel5Scores.percentCompleted * 100) / 100,
        paramsLeft: this.state.endpointScorecardLevel5Scores.paramsLeft,
        percentLeft: this.state.endpointScorecardLevel5Scores.percentLeft,
      } as IAccordionPanel;

      const panels = [Level1, Level2, Level3, Level4, Level5];
      return (
        <Grid item style={{ marginTop: 24, marginBottom: 96 }}>
          <MultiAccordion
            title='Optimize Data Parameters Sent in the Stream Endpoint Request'
            subtitle='•  Try completing all 5 levels below by adding params to the stream url calling this channel in your SSAI service.'
            subtitle2='•  Each param added moves the optimization score towards 100% when visibile in at least 50% of the requests.'
            panels={panels}
            disableEdit={true}
            endpointScorecard={true}
          />
        </Grid>
      );
    };

    getSmartFloorsTabIndex = (): number => {
      return this.buildTabs().findIndex((tab) => tab.label === ct('SmartFloors'));
    };

    updateTab = (idx: number) => {
      this.setState(
        {
          newTab: undefined,
        },
        () => {
          this.setState({
            newTab: idx,
          });
        },
      );
    };

    calculateIndividualLevelScores = (
      levelParams: string[],
      scorecard: IEndpointRequestScore,
      optimizationPercent: number,
    ) => {
      const scores = Object.create({});
      let score = 0;
      let numParams: number;
      if (scorecard.CountRequestHasAppBundle === 0) {
        numParams = levelParams.filter(
          (param) =>
            param !== 'CountRequestHasAppBundle' &&
            param !== 'CountRequestHasAppName' &&
            param !== 'CountRequestHasAppStoreUrl',
        ).length;
      } else {
        numParams = levelParams.filter((param) => param !== 'CountRequestHasAppBundle').length;
      }
      let paramsMet = 0;
      levelParams.forEach((param) => {
        if (param === 'CountRequestHasAppBundle') {
          this.setState({
            CountRequestHasAppBundle: scorecard.CountRequestHasAppBundle,
          });
          return;
        } else if (param === 'CountRequestHasAppName' || param === 'CountRequestHasAppStoreUrl') {
          if (scorecard.CountRequestHasAppBundle > 0) {
            score =
              (scorecard[param as keyof typeof scorecard] / scorecard.CountRequestHasAppBundle) *
              100;
            scores[param] = score;
            if (score >= 50) {
              paramsMet += 1;
            }
          }
        } else {
          score =
            (scorecard[param as keyof typeof scorecard] / scorecard.CountEndpointRequests) * 100;
          scores[param] = score;
          if (score >= 50) {
            paramsMet += 1;
          }
        }
      });

      const paramsLeft = numParams - paramsMet;
      scores.paramsLeft = paramsLeft;
      const percentCompleted = (optimizationPercent / numParams) * (numParams - paramsLeft);
      scores.percentCompleted = percentCompleted;
      scores.percentLeft = optimizationPercent - percentCompleted;

      return scores;
    };

    calculateLevelScores = (scorecard: IEndpointRequestScore) => {
      const level1Scores = this.calculateIndividualLevelScores(
        [
          'CountRequestHasAppBundle',
          'CountRequestHasAppBundleOrSitePage',
          'CountRequestHasPodDurationOrSlotCount',
        ],
        scorecard,
        30,
      );
      const level2Scores = this.calculateIndividualLevelScores(
        [
          'CountRequestHasIP',
          'CountRequestHasUserAgent',
          'CountRequestHasMaxAdDuration',
          'CountRequestHasMinAdDuration',
        ],
        scorecard,
        25,
      );
      const level3Scores = this.calculateIndividualLevelScores(
        [
          'CountRequestHasAppStoreUrl',
          'CountRequestHasAppName',
          'CountRequestHasContentCategory',
          'CountRequestHasContentChannel',
        ],
        scorecard,
        20,
      );
      const level4Scores = this.calculateIndividualLevelScores(
        ['CountRequestHasContentGenre', 'CountRequestHasContentRating'],
        scorecard,
        15,
      );
      const level5Scores = this.calculateIndividualLevelScores(
        [
          'CountRequestHasContentTitle',
          'CountRequestHasContentID',
          'CountRequestHasContentNetwork',
        ],
        scorecard,
        10,
      );

      this.setState({
        endpointScorecardLevel1Scores: level1Scores,
        endpointScorecardLevel2Scores: level2Scores,
        endpointScorecardLevel3Scores: level3Scores,
        endpointScorecardLevel4Scores: level4Scores,
        endpointScorecardLevel5Scores: level5Scores,
      });
    };

    handleSuperSiteAcceptClick = (values: IMenuList): void => {
      let foundSite = false;
      for (const item of Object.values(values)) {
        if (item.selected) {
          this.setState({
            SuperSiteID: parseInt(item.ID, 10),
          });
          foundSite = true;
          break;
        }
      }
      if (!foundSite) {
        this.setState({
          SuperSiteID: undefined,
        });
      }
    };

    handleParamListAcceptClick = (values: IMenuList): void => {
      for (const item of Object.values(values)) {
        if (item.selected) {
          this.setState({
            SuperSiteTargetingType: parseInt(item.ID, 10),
          });
          break;
        }
      }
    };

    updateCurrentlyWritingABTest = (status: boolean) => {
      this.setState({
        currentlyWritingABTest: status,
      });
    };

    updateTriggerTestLaunch = (status: boolean) => {
      this.setState({
        triggerTestLaunch: status,
      });
    };

    updateSnackbarMessage = (message: string, error: boolean, warning: boolean) => {
      this.setState(
        {
          snackbarError: error,
          snackbarWarning: warning,
          snackbarMessage: message,
        },
        () => {
          setTimeout(this.snackbarClose, 6000);
        },
      );
    };

    // pass null to delete a config
    updateSuperSiteTargetingConfigObjectInState = (
      indexOfUpdated: number,
      updatedObject: ISuperSiteTargetingObject | null,
    ) => {
      const newList = [] as ISuperSiteTargetingObject[];

      this.state.SuperSiteTargetingConfig.map((obj: ISuperSiteTargetingObject, idx: number) => {
        if (idx === indexOfUpdated) {
          if (updatedObject !== null) {
            // ensure that default endpoint param is cleaned up for other targeting object types
            if (
              updatedObject.SuperSiteTargetingObjectType !==
              ESuperSiteTargetingObjectType.ENDPOINT_PARAM
            ) {
              // @ts-ignore
              updatedObject.CustomConfigEndpointParam = null;
            }
            newList.push(updatedObject);
          }
        } else {
          newList.push(obj);
        }
      });
      if (this.state.SuperSiteTargetingConfig.length < indexOfUpdated && updatedObject !== null) {
        newList.push(updatedObject);
      }

      this.setState({
        SuperSiteTargetingConfig: newList,
      });
    };

    // isFieldSelectedForBulkUpdate checks if the given field is selected to be updated as part of the bulk update.
    // The field name is its name in the state.
    isFieldSelectedForBulkUpdate(fieldStateName: keyof IState): boolean {
      return this.state.fieldsSelectedForBulkUpdate.has(fieldStateName);
    }

    // bulkUpdateGenerateFieldNameValueArray generates an array of object that contains the name and the value of all the
    // fields selected in the bulk update. The name of the field is their state name.
    bulkUpdateGenerateFieldNameValueArray(): Array<{ name: keyof IState; value: string }> {
      // get value from state
      const { fieldsSelectedForBulkUpdate } = this.state;

      // create list
      const selectedFieldsAndValues: Array<{ name: keyof IState; value: string }> = [];

      // for every field, get their values as a string and add them to the list
      for (const fieldName of fieldsSelectedForBulkUpdate.keys()) {
        // get raw value of field from its name
        const fieldRawValue = this.getFieldValueFromName(fieldName);
        // transform the field raw value to a displayable string
        const fieldStringValue = this.transformValueToDisplayableValue(fieldRawValue, fieldName);
        // store the name and the value as string in the list
        selectedFieldsAndValues.push({
          name: fieldName,
          value: fieldStringValue,
        });
      }

      // return the list
      return selectedFieldsAndValues;
    }

    // handleBulkUpdateCheckboxFieldDependency handles the dependency of the bulk update checkboxes. For example
    // 'Max Lookups' is only available if 'Elea AI Recognition' is enabled. If we unselect
    // 'Elea AI Recognition', then we also need to make sure that 'Max Lookups' is unselected too.
    async handleBulkUpdateCheckboxFieldDependency(
      newFieldState: boolean,
      fieldName: keyof IState,
    ): Promise<void> {
      // if the field is selected, there is no dependency to apply
      if (newFieldState) {
        return; // do nothing
      }

      // get the dependant fields
      const dependantFields = BulkUpdateFieldDependency.get(fieldName);

      // iterate over the dependant fields
      if (dependantFields !== undefined) {
        mainLoop: for (const field of dependantFields) {
          // check if one of the dependant's main field is still active
          const mainFields = this.state.bulkUpdateReverseFieldDependency.get(field);
          if (mainFields !== undefined) {
            for (const mainField of mainFields) {
              if (
                (mainField === fieldName
                  ? newFieldState
                  : this.isFieldSelectedForBulkUpdate(mainField)) &&
                this.isFieldSwitchOn(mainField)
              ) {
                continue mainLoop; // don't disable this field as one of its main field is still enabled
              }
            }
          }
          // disable the dependant fields
          await this.handleBulkUpdateSelectionChange(false, field);
        }
      }
    }

    // handleBulkUpdateSelectionChange handles when the user clicks the checkbox to select or deselect a field to be
    // updated as part of the bulk update.
    async handleBulkUpdateSelectionChange(
      isSelected: boolean,
      fieldStateName: keyof IState,
    ): Promise<void> {
      // handle the dependency of this field
      await this.handleBulkUpdateCheckboxFieldDependency(isSelected, fieldStateName);

      // apply the change in the state
      return this.setState((prevState: IState) => {
        if (isSelected) {
          prevState.fieldsSelectedForBulkUpdate.set(fieldStateName, undefined);
        } else {
          prevState.fieldsSelectedForBulkUpdate.delete(fieldStateName);
        }
        return { fieldsSelectedForBulkUpdate: prevState.fieldsSelectedForBulkUpdate };
      });
    }

    // handleBulkUpdateSavePopupClose handles the closing of the bulk update save popup. This is called when the user
    // close the popup manually or save the changes (which also closes the popup).
    handleBulkUpdateSavePopupClose(): void {
      this.setState({
        openBulkUpdateSavePopup: false,
      });
    }

    // handleBulkUpdateSaving handles the saving of the bulk update. This is called when the user hit the 'Save' button
    // on the bulk update validation popup.
    handleBulkUpdateSaving(): void {
      // get all the selected fields as an object, where the key is the field name and the value the field value
      const updateMap: { [key: string]: any } = {};
      this.state.fieldsSelectedForBulkUpdate.forEach((_, fieldName) => {
        updateMap[fieldName] = this.getFieldValueFromName(fieldName);
      });

      // send request to API
      bulkUpdateChannel({
        query: {
          publisher_id: this.props.session.publisher.ID,
          site_ids: this.state.bulkUpdateChannelIDs.join(','),
          updates: updateMap,
        },
      });

      // navigate back to the channel list
      navigate(RouteChannelsView, extractRouteParams(this.props));
    }

    // isBulkUpdateCheckboxDisabled checks if the bulk update checkbox should be disabled for the current field.
    // The checkbox are disabled when the field is dependent on another one, and the other one is not checked or switched
    // on.
    isBulkUpdateCheckboxDisabled(fieldStateName: keyof IState): boolean {
      // get all the main fields from which this field depends on
      const mainFields = this.state.bulkUpdateReverseFieldDependency.get(fieldStateName);

      // if the field is not dependent on anything, then it's always enabled
      if (mainFields === undefined || mainFields.length === 0) {
        return false; // this field checkbox is enabled, so NOT disabled
      }

      // if at least one of the main fields is enabled, then this field checkbox is enabled
      for (const mainField of mainFields) {
        if (this.isFieldSelectedForBulkUpdate(mainField) && this.isFieldSwitchOn(mainField)) {
          return false; // this field checkbox & switch are enabled, so NOT disabled
        }
      }

      // all the main fields have their checkbox or switch disabled, so this field checkbox is disabled
      return true; // this field checkbox is disabled
    }

    // isFieldSwitchOn checks if the switch associated with a field is on. This is NOT the bulk update checkbox, this is
    // the actual switch.
    isFieldSwitchOn(fieldName: keyof IState): boolean {
      // get the value from the state
      const fieldValue = this.getFieldValueFromName(fieldName);

      // handle EBool fields
      if (EBoolFieldsName.includes(fieldName)) {
        return fieldValue === EBool.EBool_TRUE;
      }

      // handle regular boolean
      return fieldValue;
    }

    getCountryGroupsByPublisherIDWrapper = () => {
      const { session } = this.props;
      getCountryGroupsByPublisherID(session.publisher.ID).then((countryGroups: ICountryGroup[]) => {
        this.setState({
          publisherCountryGroups: countryGroups,
          fetchedPublisherCountryGroups: true,
        });
      });
    };

    renderSuperSiteTargetingForEndpointParams = (
      idx: number,
      config: ISuperSiteTargetingObject,
    ) => {
      let configForThisType = config.CustomConfigEndpointParam;
      if (configForThisType === undefined || configForThisType === null) {
        // default config
        configForThisType = {
          ParamType: ESuperSiteTargetingObjectEndpointParamsType.CUSTOM_4,
          Value: '',
        };
      }
      return (
        <>
          <Grid item style={{ width: '100%' }}>
            <Grid container direction='row' alignItems='center'>
              <Grid item xs={3}>
                <Typography className={this.props.classes.typographyTitle}>
                  Targeting Endpoint Param
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <MaterialSearchDropdownMulti
                  width='300px'
                  fontSize='14px'
                  menuTitle='Targeting Param'
                  list={CreateMenuList(
                    ESuperSiteTargetingObjectEndpointParamsTypeValues as any,
                    (id: any) => ESuperSiteTargetingObjectEndpointParamsTypeToString(id),
                    [configForThisType.ParamType as any],
                  )}
                  onChange={(paramList: IMenuList) => {
                    configForThisType.ParamType = (GetSelectedValuesFromMenuList(paramList) || [
                      ESuperSiteTargetingObjectType.ENDPOINT_PARAM,
                    ])[0] as any;
                    config.CustomConfigEndpointParam = configForThisType;
                    this.updateSuperSiteTargetingConfigObjectInState(idx, config);
                  }}
                  disabled={!this.state.writeAuthorization.isAuthorized}
                  selectAll={false}
                  enableMultiSelect={false}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ width: '100%' }}>
            <Grid container direction='row' alignItems='center'>
              <Grid item xs={3}>
                <Typography className={this.props.classes.typographyTitle}>
                  Targeting Keys
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ maxWidth: 300 }}>
                <TextField
                  fullWidth
                  InputProps={{ style: { fontSize: 14 } }}
                  value={configForThisType.Value}
                  helperText='Comma separated values'
                  onChange={({ target }) => {
                    configForThisType.Value = target.value;
                    config.CustomConfigEndpointParam = configForThisType;
                    this.updateSuperSiteTargetingConfigObjectInState(idx, config);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </>
      );
    };

    renderSuperSiteTargetingForDeviceEnvironment = (
      idx: number,
      config: ISuperSiteTargetingObject,
    ) => {
      let configForThisType = config.CustomConfigDeviceEnvironment;
      if (configForThisType === undefined || configForThisType === null) {
        // default config
        configForThisType = [0]; // All
      }

      // We generate the list and select the saved items
      const listOfDeviceEnv = deviceEnvironmentsAsIMenu();
      Object.keys(listOfDeviceEnv).forEach((key) => {
        if (configForThisType.includes(+listOfDeviceEnv[key].ID)) {
          listOfDeviceEnv[key].selected = true;
        }
      });

      return (
        <>
          <Grid item style={{ width: '100%' }}>
            <Grid container direction='row' alignItems='center'>
              <Grid item xs={3}>
                <Typography className={this.props.classes.typographyTitle}>
                  Targeting Device Environment
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <MaterialSearchDropdownMulti
                  width='300px'
                  fontSize='14px'
                  menuTitle='Device Environment'
                  list={listOfDeviceEnv}
                  onChange={(paramList: IMenuList) => {
                    configForThisType = (
                      (GetSelectedValuesFromMenuList(paramList) || ['0']) as string[]
                    ).map((str) => +str);
                    config.CustomConfigDeviceEnvironment = configForThisType;
                    this.updateSuperSiteTargetingConfigObjectInState(idx, config);
                  }}
                  disabled={!this.state.writeAuthorization.isAuthorized}
                  selectAll={false}
                  enableMultiSelect={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </>
      );
    };

    renderSuperSiteTargetingForDeviceType = (idx: number, config: ISuperSiteTargetingObject) => {
      let configForThisType = config.CustomConfigDeviceType;
      if (configForThisType === undefined || configForThisType === null) {
        // default config
        configForThisType = [EDeviceTypes.DEVICETYPE_UNKNOWN];
      }

      return (
        <>
          <Grid item style={{ width: '100%' }}>
            <Grid container direction='row' alignItems='center'>
              <Grid item xs={3}>
                <Typography className={this.props.classes.typographyTitle}>
                  Targeting Device Type
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <MaterialSearchDropdownMulti
                  width='300px'
                  fontSize='14px'
                  menuTitle='Device Type'
                  list={CreateMenuList(
                    EDeviceTypesValues as any,
                    (id: any) => EDeviceTypesToString(id),
                    configForThisType as any,
                  )}
                  onChange={(paramList: IMenuList) => {
                    configForThisType = (GetSelectedValuesFromMenuList(paramList) || ['0']).map(
                      (str) => +str,
                    );
                    config.CustomConfigDeviceType = configForThisType;
                    this.updateSuperSiteTargetingConfigObjectInState(idx, config);
                  }}
                  disabled={!this.state.writeAuthorization.isAuthorized}
                  selectAll={false}
                  enableMultiSelect={true}
                />
              </Grid>
            </Grid>
          </Grid>
        </>
      );
    };

    renderSuperSiteTargetingForGenericStringInput = (
      idx: number,
      config: ISuperSiteTargetingObject,
      inputName: string,
    ) => {
      let configForThisType = config.CustomConfigOnlyString;
      if (configForThisType === undefined || configForThisType === null) {
        // default config
        configForThisType = '';
      }
      return (
        <Grid item style={{ width: '100%' }}>
          <Grid container direction='row' alignItems='center'>
            <Grid item xs={3}>
              <Typography className={this.props.classes.typographyTitle}>
                Targeting {inputName}
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ maxWidth: 300 }}>
              <TextField
                fullWidth
                InputProps={{ style: { fontSize: 14 } }}
                value={configForThisType}
                helperText='Comma separated values'
                onChange={({ target }) => {
                  configForThisType = target.value;
                  config.CustomConfigOnlyString = configForThisType;
                  this.updateSuperSiteTargetingConfigObjectInState(idx, config);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderSuperSiteTargetingForEachType = (idx: number, config: ISuperSiteTargetingObject) => {
      switch (config.SuperSiteTargetingObjectType) {
        case ESuperSiteTargetingObjectType.ENDPOINT_PARAM:
          return this.renderSuperSiteTargetingForEndpointParams(idx, config);
        case ESuperSiteTargetingObjectType.WSEAT:
          return this.renderSuperSiteTargetingForGenericStringInput(idx, config, 'WSeat');
        case ESuperSiteTargetingObjectType.DEALID:
          return this.renderSuperSiteTargetingForGenericStringInput(idx, config, 'Deal ID');
        case ESuperSiteTargetingObjectType.APP_BUNDLE:
          return this.renderSuperSiteTargetingForGenericStringInput(idx, config, 'App Bundle');
        case ESuperSiteTargetingObjectType.DEVICE_ENVIRONMENT:
          return this.renderSuperSiteTargetingForDeviceEnvironment(idx, config);
        case ESuperSiteTargetingObjectType.DEVICE_TYPE:
          return this.renderSuperSiteTargetingForDeviceType(idx, config);
      }
      return <></>;
    };

    renderSuperSiteTargetingConfigObject = (idx: number, config: ISuperSiteTargetingObject) => {
      return (
        <Paper style={{ padding: '10px' }}>
          <Grid item style={{ width: '100%' }}>
            <Grid container direction='row' alignItems='center'>
              <Grid item xs={3}>
                <Typography className={this.props.classes.typographyTitle}>
                  Targeting Type
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <MaterialSearchDropdownMulti
                  width='300px'
                  fontSize='14px'
                  menuTitle='Targeting Type'
                  list={CreateMenuList(
                    ESuperSiteTargetingObjectTypeValues as any,
                    (id: any) => ESuperSiteTargetingObjectTypeToString(id),
                    [config.SuperSiteTargetingObjectType as any],
                  )}
                  onChange={(paramList: IMenuList) => {
                    config.SuperSiteTargetingObjectType = (GetSelectedValuesFromMenuList(
                      paramList,
                    ) || [ESuperSiteTargetingObjectType.ENDPOINT_PARAM])[0] as any;
                    this.updateSuperSiteTargetingConfigObjectInState(idx, config);
                  }}
                  disabled={!this.state.writeAuthorization.isAuthorized}
                  selectAll={false}
                  enableMultiSelect={false}
                />
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  aria-label='delete'
                  style={{ color: getColorTheme('secondaryButtonText') }}
                  onClick={() => {
                    this.updateSuperSiteTargetingConfigObjectInState(idx, null);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
          {this.renderSuperSiteTargetingForEachType(idx, config)}
        </Paper>
      );
    };

    renderSelectSuperSite = () => {
      const { classes } = this.props;
      const { siteList, SuperSiteID, SuperSiteTargetingConfig } = this.state;
      return (
        <Grid className={classes.mainGridItem}>
          <Grid className={classes.notPaper}>
            <Grid container direction='column' alignItems='flex-start' spacing={4}>
              <Grid item style={{ width: '100%' }}>
                <Typography className={this.props.classes.typographyNonTitle}>
                  If a super channel selected, this channel will become a sub channel. When an
                  endpoint request is sent to the super channel, it will look for a sub channel
                  matching the targeting and redirect the request. If no targeting matches, the
                  request will continue to the super channel.
                </Typography>
              </Grid>
              <Grid item style={{ width: '100%' }}>
                <Grid container direction='row' alignItems='center'>
                  <Grid item xs={3}>
                    <Typography className={this.props.classes.typographyTitle}>
                      Super Channel
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <MaterialSearchDropdownMulti
                      width='300px'
                      fontSize='14px'
                      menuTitle='Super Channel'
                      list={siteList}
                      onChange={(list: IMenuList) => {
                        this.setState({
                          siteList: list,
                        });
                      }}
                      disabled={!this.state.writeAuthorization.isAuthorized}
                      handleMenuAcceptClick={(src: IMenuList) => {
                        this.handleSuperSiteAcceptClick(src);
                      }}
                      selectAll={false}
                      enableMultiSelect={false}
                      showPrefixID
                    />
                  </Grid>
                </Grid>
              </Grid>
              {SuperSiteID && (
                <>
                  {SuperSiteTargetingConfig.map((obj: ISuperSiteTargetingObject, idx: number) => {
                    if (idx !== 0) {
                      // render the AND/OR (we only support AND for now)
                      return (
                        <>
                          <p>
                            {this.state.SuperSiteTargetingLogicOperator ===
                            ESuperSiteTargetingLogicOperator.AND
                              ? 'AND'
                              : 'OR'}
                          </p>
                          {this.renderSuperSiteTargetingConfigObject(idx, obj)}
                        </>
                      );
                    }
                    return this.renderSuperSiteTargetingConfigObject(idx, obj);
                  })}
                  <Button
                    disabled={!this.state.writeAuthorization.isAuthorized}
                    onClick={() => {
                      this.setState({
                        SuperSiteTargetingConfig: [
                          ...SuperSiteTargetingConfig,
                          {
                            SuperSiteTargetingObjectType:
                              ESuperSiteTargetingObjectType.ENDPOINT_PARAM,
                            // populate with default value in case of save
                            CustomConfigEndpointParam: {
                              ParamType: ESuperSiteTargetingObjectEndpointParamsType.CUSTOM_4,
                              Value: '',
                            },
                          } as any,
                        ],
                      });
                    }}
                    style={{
                      color: getColorTheme('secondaryButtonText'),
                      marginBottom: '20px',
                    }}
                  >
                    + Add a targeting option
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderRoutes = () => {
      const { classes } = this.props;
      const { publisherCountryGroups } = this.state;
      const Route = cloneDeep(this.state.Route);
      if (!Route) {
        return <></>;
      }
      const Destinations = Route['Destinations' as IInventoryRouteDesinationKey];
      // @ts-ignore
      for (let i = 0; i < Destinations.length; i++) {
        // @ts-ignore
        Destinations[i].targetingCountriesList = genCountriesMenuListFromSelectedAndDisable(
          Destinations[i].TargetingDeviceCountry,
        ) as IMenuList;
        // @ts-ignore
        Destinations[i].targetingCountryGroupList =
          genTargetingCountryGroupListFromSelectedAndDisable(
            publisherCountryGroups,
            Destinations[i].TargetingCountryGroupIDs,
          ) as IMenuList;
        // @ts-ignore
        Destinations[i].localTargetingParameters = importLocalTargetingParamFromJSON(
          Destinations[i].LocalTargeting,
        );
        // @ts-ignore
        if (Destinations[i].DestinationType === DestinationTypeSite) {
          // @ts-ignore
          Destinations[i]['inventoryRouteChannelList' as DestinationMenuLists] =
            genInvenRouteChannelListFromSelected(
              Destinations[i].SiteID,
              this.state.sites,
              this.props.user.user.Username,
            ) as IMenuList;
        } else if (Destinations[i].DestinationType === DestinationTypeRoute) {
          Destinations[i].inventoryRouteRouteList = genInvenRouteRouteListFromSelected(
            Destinations[i].ForwardingRouteID,
            this.state.inventoryRoutesForPublisher,
            this.props.user.user.Username,
          ) as IMenuList;
          Destinations[i].inventoryRouteChannelList = {} as IMenuList;
        } else {
          // @ts-ignore
          Destinations[i]['inventoryRouteChannelList' as DestinationMenuLists] = {} as IMenuList;
        }
      }

      return (
        <Grid className={classes.mainGridItem}>
          <RouteSettingsView
            publisherCountryGroups={publisherCountryGroups || []}
            currentRoute={Route}
            readOnly={true}
            disableAppBar={true}
            sites={this.state.sites}
            inventoryRoutesForPublisher={this.state.inventoryRoutesForPublisher}
          />
        </Grid>
      );
    };

    createDetailPanel = (rowData: ISiteRowData) => {
      if (
        rowData.Site.SuperSiteTargetingConfig.length === 0 ||
        !Array.isArray(rowData.Site.SuperSiteTargetingConfig)
      ) {
        return undefined;
      }
      return (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Targeting Type</TableCell>
              <TableCell align='right'>Targeting Values</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData.Site.SuperSiteTargetingConfig.map(
              (row: ISuperSiteTargetingObject, idx: number) => (
                <TableRow key={idx}>
                  <TableCell component='th' scope='row'>
                    {ESuperSiteTargetingObjectTypeToString(row.SuperSiteTargetingObjectType)}
                  </TableCell>
                  <TableCell align='right'>{extractSuperSiteTargetingValue(row)}</TableCell>
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
      );
    };

    renderSubSitesList = () => {
      const { classes, user } = this.props;
      const { SubSites } = this.state;

      const columns: IListTableColumn[] = [
        {
          field: 'Name',
          title: 'Name',
          renderType: 'namelink',
          searchable: true,
          maxWidth: '200px',
        },
        {
          field: 'SuperSiteTargeting',
          title: 'Targeting Value',
          renderType: 'normal',
          render: (rowData: ISiteRowData) => {
            if (rowData.Site.SuperSiteTargetingConfig.length === 1) {
              return (
                <p>{extractSuperSiteTargetingValue(rowData.Site.SuperSiteTargetingConfig[0])}</p>
              );
            }
            return <p />;
          },
        },
        {
          field: 'SuperSiteTargetingType',
          title: 'Targeting Type',
          renderType: 'normal',
          render: (rowData: ISiteRowData) => {
            if (rowData.Site.SuperSiteTargetingConfig.length === 1) {
              return (
                <p>
                  {ESuperSiteTargetingObjectTypeToString(
                    rowData.Site.SuperSiteTargetingConfig[0].SuperSiteTargetingObjectType,
                  )}
                </p>
              );
            }
            return (
              <p>
                {Array.isArray(rowData.Site.SuperSiteTargetingConfig)
                  ? rowData.Site.SuperSiteTargetingConfig.length
                  : 'No'}{' '}
                targeting(s)
              </p>
            );
          },
        },
      ];

      const data: ISiteRowData[] = SubSites.map((site: ISite) => {
        return {
          ID: site.ID,
          Name: checkUserInfoMasked(user.user) ? `demo_site_${site.ID}` : site.Name,
          Site: site,
          SubSites: 0,
          Active: true,
        };
      });

      return (
        <Grid className={classes.mainGridItem}>
          <MaterialTable
            detailPanel={(rowData: ISiteRowData) => this.createDetailPanel(rowData)}
            style={{
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
            title=''
            options={{
              search: true,
              pageSize: 15,
              pageSizeOptions: [5, 15, 30],
            }}
            columns={columns}
            data={data}
          />
        </Grid>
      );
    };

    // Builds the ordered tab list. Keep this as the single source of truth for tab ordering —
    // getSmartFloorsTabIndex() relies on it to find Smart Floors by label automatically.
    buildTabs(): ITab[] {
      const { user } = this.props;
      const { SubSites, fetchedPublisherCountryGroups } = this.state;

      // if a new tab is added, update the call to changeTabView in endpoint-request-scorecard-progressbar.tsx
      // to take in the index of the Recommendations tab. Note the Endpoint tab exists between details and rewrites

      // this defines the tabs that are COMMON between bulk update and singe channel edit
      const tabs: ITab[] = [
        {
          label: 'Details',
          render: this.renderDetails,
        },
      ];

      if (!this.state.isBulkUpdate) {
        // this defined the table ONLY for single channel edit
        tabs.push(
          {
            label: 'Rewrites',
            render: this.renderChannelLevelRewrite,
          },
          {
            label: ct('AdQualityTools'),
            render: this.renderAdQualityTools,
            icon: <IconV2 name='ai-icon' small />,
          },
          {
            label: 'Brand Safety',
            render: this.renderBrandSafety,
          },
          {
            label: 'Recommendations',
            render: this.renderEndpointScorecardLevels,
          },
        );
        if (hasRoleSuperUser(user.user)) {
          tabs.push({
            label: 'Endpoint Shield *',
            render: this.renderEndpointShield,
          });
        }
        if (this.state.Route && fetchedPublisherCountryGroups) {
          tabs.push({
            label: 'Inventory Route',
            render: this.renderRoutes,
          });
        }
        if (
          (hasRoleSuperUser(user.user) || isSamsungPublisher(this.props.session.publisher.ID)) &&
          !SubSites.length
        ) {
          tabs.push({
            label: 'Mapping *',
            render: this.renderSelectSuperSite,
          });
        }
        if (
          (hasRoleSuperUser(user.user) || isSamsungPublisher(this.props.session.publisher.ID)) &&
          SubSites.length
        ) {
          tabs.push({
            label: 'Mapping *',
            render: this.renderSubSitesList,
          });
        }
        if (!isEndpointBuilderDisabled(this.props.session.publisher)) {
          tabs.splice(1, 0, {
            label: 'Endpoint',
            render: this.renderEndpoint,
          });
        }
        if (this.state.isSmartFloorActive) {
          tabs.splice(2, 0, {
            label: ct('SmartFloors'),
            render: this.renderSiteSmartFloors,
          });
        }
        if (hasRoleSuperUser(user.user)) {
          tabs.push({
            label: 'Price Granularity *',
            render: this.renderPriceIncrements,
          });
        }
        if (hasRoleSuperUser(user.user) || isSamsungPublisher(this.props.session.publisher.ID)) {
          tabs.push({
            label: 'AB Tests *',
            render: this.renderChannelABTests,
          });
        }
      }

      return tabs;
    }

    // define tabs and corresponding render functions
    renderTabs(): ReactElement {
      const { startingTab } = this.state;
      const tabs = this.buildTabs();

      return (
        <SettingsTabs
          tabs={tabs}
          marginTop={0}
          startingTab={startingTab}
          newTab={this.state.newTab}
          enableTrackEvents={true}
          user={this.props.user.user}
          resource='Channels'
        />
      );
    }

    render() {
      // get values from the state
      const {
        loading,
        loadingBidders,
        isBulkUpdate,
        openBulkUpdateSavePopup,
        bulkUpdateChannelIDs,
        fieldsSelectedForBulkUpdate,
      } = this.state;
      const { classes, user, session, location } = this.props;
      const { pathname } = location;
      const loc = parseLocation(this.props.location.pathname);

      return loading || loadingBidders ? (
        <LoadingView active={true} text='Loading your settings' />
      ) : (
        <Panels max vertical relative minWidthMain>
          <Panel largeHorizontalPadding verticalPadding>
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel>
            {this.renderEndpointParamsCustomizeDialog()}
            {this.renderAppBar()}
          </Panel>
          <Panel maxHeight scroll largePadding>
            {loc.channel !== '' && this.props.session.site && (
              <Grid>
                <LiveData
                  sites={[this.props.session.site]}
                  resourceIDs={this.props.session.site.ID.toString()}
                  resourceType='Site'
                  timezone={this.props.session.publisher.Timezone}
                  publisher={this.props.session.publisher}
                  userInfo={this.props.user.user}
                  marginTop={8}
                />
              </Grid>
            )}
            {!this.state.readAuthorization.isAuthorized ? (
              <ModelMissingPermission
                missingPermissions={this.state.readAuthorization.missingPermissions}
              />
            ) : (
              // grid containing both the content and the bulk update sidebar
              <Grid container direction='row' alignItems='flex-start' spacing={0}>
                {/* main page content */}
                <Grid item xs={isBulkUpdate ? 8 : 12}>
                  {/* renders the different tabs */}
                  {this.renderTabs()}

                  <ConfirmationDialogButton
                    title='Confirm Bulk Edit Channels'
                    description={`The ${bulkUpdateChannelIDs.length} selected channels will be updated with new values as displayed in the summary.`}
                    renderReactElement={() => this.bulkUpdateRenderReview()}
                    generateAcceptButtonStyles={() => ({
                      backgroundColor: getColorTheme('channelBidderPrimaryButton'),
                      color: getColorTheme('channelBidderPrimaryButtonText'),
                    })}
                    acceptButtonTitle='Yes, confirm updates'
                    acceptButtonCallBack={() => this.handleBulkUpdateSaving()}
                    refuseButtonTitle='Cancel'
                    refuseButtonCallBack={noopVoid}
                    manualOpen={openBulkUpdateSavePopup}
                    handleClose={() => this.handleBulkUpdateSavePopupClose()}
                    disableSave={isBulkUpdate && fieldsSelectedForBulkUpdate.size === 0}
                  />

                  {/* renders the livelogs - NOT supported by bulk updating */}
                  {!isBulkUpdate && this.renderLiveLogs()}
                  {!isBulkUpdate && (
                    <Fab
                      style={{
                        margin: 0,
                        top: 'auto',
                        right: 20,
                        bottom: 20,
                        left: 'auto',
                        position: 'fixed',
                      }}
                      variant='extended'
                      color='primary'
                      onClick={() => {
                        this.trackEvent('Channel Settings - Open Live Logs');
                        this.setState({
                          openLogsView: true,
                        });
                      }}
                    >
                      Open Live logs
                    </Fab>
                  )}
                </Grid>

                {/* sidebar for the bulk update summary */}
                {isBulkUpdate && (
                  <Grid item xs={4} style={{ height: '100%' }}>
                    {this.renderBulkUpdateSidebar()}
                  </Grid>
                )}
              </Grid>
            )}

            {/* render snackbar */}
            <SnackbarView
              open={!!this.state.snackbarMessage}
              error={this.state.snackbarError}
              warning={this.state.snackbarWarning}
              onClose={this.snackbarClose}
            >
              {this.state.snackbarMessage}
            </SnackbarView>
          </Panel>
        </Panels>
      );
    }

    // renderSwitches renders the min/max bitrate options and all the switches in the "details" tab.
    renderSwitches = () => {
      // get variables from props
      const { classes, session, user } = this.props;
      // get variables from state
      const { isBulkUpdate } = this.state;

      // "deduplication" switches
      // base dedup switches
      let dedupSwitches: ISiteSwitch[] = [
        { name: 'Enforce Unique Mediafile', stateName: 'HeaderBidderDedup', dataType: 'boolean' },
        {
          name: 'Enforce Unique Advertiser Domain',
          stateName: 'HeaderBidderDedupAdomain',
          dataType: 'boolean',
        },
        {
          name: 'Enforce Unique IAB Category',
          stateName: 'HeaderBidderDedupCategory',
          dataType: 'boolean',
        },
        { name: 'Enforce Unique Ad ID', stateName: 'AdIDDedup', dataType: 'EBool' },
        { name: 'Enforce Unique Creative ID', stateName: 'CreativeIDDedup', dataType: 'EBool' },
        {
          name: 'Session-Level Deduplication',
          stateName: 'HeaderBidderGlobalDedup',
          dataType: 'EBool',
        },
      ];
      if (hasRoleSuperUser(user.user) || this.props.session.publisher.ID === '381') {
        // Philo or super only
        dedupSwitches = [
          { name: 'Enforce Unique Mediafile', stateName: 'HeaderBidderDedup', dataType: 'boolean' },
          {
            name: 'Enforce Unique Advertiser Domain',
            stateName: 'HeaderBidderDedupAdomain',
            dataType: 'boolean',
          },
          {
            name: 'Enforce Unique IAB Category',
            stateName: 'HeaderBidderDedupCategory',
            dataType: 'boolean',
          },
          {
            name: 'Enforce Unique APS Key',
            stateName: 'HeaderBidderDedupAPSKey',
            dataType: 'boolean',
          },
          { name: 'Enforce Unique Ad ID', stateName: 'AdIDDedup', dataType: 'EBool' },
          { name: 'Enforce Unique Creative ID', stateName: 'CreativeIDDedup', dataType: 'EBool' },
        ];
        if (
          this.state.HeaderBidderDedup ||
          this.state.HeaderBidderDedupAdomain ||
          this.state.HeaderBidderDedupCategory ||
          this.state.HeaderBidderDedupAPSKey ||
          this.state.AdIDDedup === EBool.EBool_TRUE ||
          this.state.CreativeIDDedup === EBool.EBool_TRUE
        ) {
          dedupSwitches.push({
            name: 'Session-Level Deduplication',
            stateName: 'HeaderBidderGlobalDedup',
            dataType: 'EBool',
          });
        }
      }

      if (
        hasRoleSuperUser(user.user) ||
        EBool.isTrue(this.props.session.publisher.EnableAPSDemand)
      ) {
        if (dedupSwitches.every((ele) => ele.name !== 'Enforce Unique APS Key')) {
          dedupSwitches.push({
            name: 'Enforce Unique APS Key',
            stateName: 'HeaderBidderDedupAPSKey',
            dataType: 'boolean',
          });
        }
      }

      // "other features" switches
      const otherSwitches: ISiteSwitch[] = [
        {
          name: 'Block Bids Without Advertiser Domain',
          stateName: 'HeaderBidderEnforceAdomain',
          dataType: 'boolean',
        },
        {
          name: 'Reject non-secure VAST',
          stateName: 'RejectNonsecureVAST',
          tooltipText: 'Will reject bid responses that contain non-secure URLs',
          dataType: 'EBool',
        },
      ];

      // enable comscore UI for spachmob and fox
      if (
        hasRoleSuperUser(user.user) ||
        session.publisher.ComscoreContextualSegmentsEnabled === EBool.EBool_TRUE
      ) {
        otherSwitches.push({
          name: 'Enable Comscore Signal',
          stateName: 'ComscoreSignalEnabled',
          dataType: 'EBool',
        });
      }

      if (isXMLCommentWritePublisher(this.props.session.publisher.ID)) {
        otherSwitches.push({
          name: 'Enable XML Comment Writes',
          stateName: 'EnableXMLCommentWrites',
          dataType: 'EBool',
        });
      }

      const notRokuSwitches: ISiteSwitch[] = [
        {
          name: 'Reject Pods With All House Ads',
          stateName: 'RejectPodsWithAllHouseAds',
          dataType: 'boolean',
        },
      ];
      if (!isRoku()) {
        otherSwitches.push(...notRokuSwitches);
      }

      // "super-only options" switches - NOT supported by bulk updating
      const superUserSwitches: ISiteSwitch[] = [];
      if (!isBulkUpdate) {
        superUserSwitches.push(
          { name: 'Enable DD Monitoring *', stateName: 'DDMonitoring', dataType: 'boolean' },
          { name: 'Enable HLS Transcoder *', stateName: 'EnableHlsTranscoder', dataType: 'EBool' },
          {
            name: 'Enable Single Auction *',
            stateName: 'HeaderBidderSingleAuction',
            dataType: 'boolean',
          },
          {
            name: 'Enable Enforce Slot Targeting *',
            stateName: 'HeaderBidderEnforceSlotTargeting',
            dataType: 'boolean',
          },
          {
            name: 'Enable Server Side Trackers *',
            stateName: 'ServerSideTrackersEnabled',
            dataType: 'EBool',
          },
          {
            name: 'Machine Learning for Max Auctions *',
            stateName: 'MachineLearningForMaxAuctionsEnabled',
            dataType: 'EBool',
            tooltipText: 'Determines the ideal slot count for auctions through past data analysis.',
          },
          {
            name: 'Enable Enforce Auction Cutoff',
            stateName: 'EnforceAuctionCutoff',
            dataType: 'EBool',
          },
        );
        if (this.props.session.publisher.ID === '381') {
          // Philo and super-user only
          superUserSwitches.push({
            name: 'Honor Sequence Order *',
            stateName: 'HonorSequenceOrder',
            dataType: 'EBool',
            tooltipText: 'Ensures that primary ads are prioritized over fallback ads.',
          });
        }
      }

      // renderer
      return (
        <Grid style={{ marginTop: 10 }}>
          {/* min/max bitrate - NOT supported by bulk updating */}
          {!isBulkUpdate && this.renderNumberTextfield('Min Bitrate', 'MinBitrate', false, '')}
          {!isBulkUpdate && this.renderNumberTextfield('Max Bitrate', 'MaxBitrate', false, '')}

          {/* deduplication section */}
          <Typography className={classes.typographyTitle} style={{ marginTop: 25 }}>
            Deduplication
          </Typography>
          {dedupSwitches.map((s: ISiteSwitch) => {
            let extraOptions;

            // handle dependency for the 'Elea AI Recognition' field
            if (s.stateName === 'BrandRecognitionEnabled') {
              if (this.state.BrandRecognitionEnabled === EBool.EBool_TRUE) {
                // brand recognition is enabled
                // render the 'Max Lookups' number field when the 'Elea AI Recognition' is enabled
                extraOptions = (
                  <Grid item>
                    <Grid container direction='row' justify='flex-start' alignItems='center'>
                      <Grid item style={{ width: '80px' }} />
                      {/* if we are bulk updating, render the checkbox */}
                      {isBulkUpdate && (
                        <Grid item>
                          <Checkbox
                            disabled={!this.isFieldSelectedForBulkUpdate('BrandRecognitionEnabled')}
                            checked={this.isFieldSelectedForBulkUpdate('BrandRecognitionLimit')}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                              const isChecked = event.target.checked;
                              // this checkbox act for both BrandRecognitionLimit and BrandRecognitionLimitUnit
                              this.handleBulkUpdateSelectionChange(
                                isChecked,
                                'BrandRecognitionLimit',
                              ).then(() => {
                                this.handleBulkUpdateSelectionChange(
                                  isChecked,
                                  'BrandRecognitionLimitUnit',
                                ).then();
                              });
                            }}
                          />
                        </Grid>
                      )}
                      <Grid item>
                        {this.renderNumberTextfield(
                          'Max Lookups (0 is unlimited)',
                          'BrandRecognitionLimit',
                          false,
                          '',
                        )}
                        <InputLabel style={{ fontSize: 12 }}>Per</InputLabel>
                        <Select
                          name='BrandRecognitionLimitUnit'
                          onChange={this.handleChange}
                          value={this.state.BrandRecognitionLimitUnit}
                          fullWidth
                        >
                          {[
                            { key: TimeUnit.TimeUnit_HOUR, text: 'Hour' },
                            { key: TimeUnit.TimeUnit_DAY, text: 'Day' },
                            { key: TimeUnit.TimeUnit_WEEK, text: 'Week' },
                            { key: TimeUnit.TimeUnit_MONTH, text: 'Month' },
                          ].map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.key}>
                                {item.text}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>
                );
              } else if (this.isFieldSelectedForBulkUpdate('BrandRecognitionLimit')) {
                // if the 'Max Lookups' field is not visible, then unselect it for bulk update
                this.handleBulkUpdateSelectionChange(false, 'BrandRecognitionLimit').then(() => {
                  this.handleBulkUpdateSelectionChange(false, 'BrandRecognitionLimitUnit').then();
                });
              }
            }

            if (s.stateName === 'HeaderBidderGlobalDedup') {
              if (this.state.HeaderBidderGlobalDedup === EBool.EBool_TRUE) {
                extraOptions = (
                  <Grid item>
                    <Grid
                      container
                      direction='row'
                      justify='flex-start'
                      alignItems='center'
                      spacing={1}
                    >
                      {/* margin left */}
                      <Grid item style={{ width: '80px' }} />
                      {/* checkbox for bulk update */}
                      {isBulkUpdate && (
                        <Grid item>
                          <Checkbox
                            disabled={this.isBulkUpdateCheckboxDisabled(
                              'HeaderBidderGlobalDedupExpiration',
                            )}
                            checked={(() => {
                              const res = this.isFieldSelectedForBulkUpdate(
                                'HeaderBidderGlobalDedupExpiration',
                              );
                              return res;
                            })()}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                              this.handleBulkUpdateSelectionChange(
                                event.target.checked,
                                'HeaderBidderGlobalDedupExpiration',
                              ).then();
                            }}
                          />
                        </Grid>
                      )}
                      <Grid item>
                        {this.renderNumberTextfield(
                          'Session-Level Deduplication Expiration (seconds)',
                          'HeaderBidderGlobalDedupExpiration',
                          false,
                          '',
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                );
              } else {
                if (this.isFieldSelectedForBulkUpdate('HeaderBidderGlobalDedupExpiration')) {
                  this.handleBulkUpdateSelectionChange(
                    false,
                    'HeaderBidderGlobalDedupExpiration',
                  ).then();
                }
              }
            }

            return (
              <>
                {this.renderSwitch(s)}
                {extraOptions}
              </>
            );
          })}

          {/* bypass deduplication section */}
          {/* section title */}
          <Typography className={classes.typographyTitle} style={{ marginTop: 25 }}>
            Bypass Deduplication
            <Tooltip title='This will allow ads that would normally be deduplicated to serve within the same pod if they meet the selected options below. Please note that these options only bypass IAB category and Adomain Deduplication'>
              <span>
                <InfoIcon
                  style={{
                    verticalAlign: 'bottom',
                    width: '1rem',
                    color: '#929599',
                    paddingBottom: '2px',
                    marginLeft: '5px',
                  }}
                />
              </span>
            </Tooltip>
          </Typography>
          {!isBulkUpdate && this.renderBypassDedupConfig()}

          {/* other features section - NOT supported by bulk updating */}
          {!isBulkUpdate && (
            <Panel>
              <Text small bold>
                Other Features
              </Text>
              {hasRoleSuperUser(user.user) && this.renderCombineCreatives()}
              {sortBy(otherSwitches, 'name').map((s: ISiteSwitch) => this.renderSwitch(s))}

              {this.renderPublicaVault()}

              {this.renderSwitch({
                name: 'Enable Measurement',
                stateName: 'EnableIASFirstPartyVASTTracking',
                tooltipText:
                  'This appends an IAS tag to your endpoint responses, measuring statistics such as rendered ads, viewable impressions, and invalid traffic.',
                dataType: 'EBool',
              })}
              {this.state.EnableIASFirstPartyVASTTracking === EBool.EBool_TRUE && (
                <div className={this.props.classes.optionRowIndented}>
                  {this.renderNumberTextfield(
                    'Measurement Percentage',
                    'MeasurementPercentage',
                    false,
                    '',
                    true,
                  )}
                  {this.renderSwitch({
                    name: 'Enable Dynamic Measurement Strategy',
                    stateName: 'EnableDynamicMeasurementStrategy',
                    tooltipText:
                      'By default, measurement strategy will be determined by the header bidder delivery type set on the site. If dynamic measurement strategy is enabled, we will use the device type from the ua in the request to determine measurement strategy.',
                    dataType: 'EBool',
                  })}
                </div>
              )}
              {isPhiloFallbackEnabledPublisher(this.props.session.publisher.ID) &&
                this.renderFallbackAds()}
              {(hasRoleSuperUser(user.user) ||
                !!this.props.session.site?.IsMarketplaceConnection) &&
                this.renderSwitch({
                  name: 'Return Partner CPM for Platform Connect',
                  stateName: 'ReturnGrossCPMInResponse',
                  dataType: 'EBool',
                  tooltipText:
                    'Return the Partner CPM as price, i.e. the Gross CPM minus the eCPM. If Gross CPM = eCPM, then the Gross CPM is returned as price.',
                })}
              {(hasRoleSuperUser(user.user) || isPhiloPublisher(this.props.session.publisher.ID)) &&
                this.renderSwitch({
                  name: 'Enable Secondary Requests',
                  stateName: 'EnableSecondaryRequests',
                  dataType: 'EBool',
                })}
              {this.state.EnableSecondaryRequests === EBool.EBool_TRUE && (
                <div className={this.props.classes.optionRowIndented}>
                  {this.renderNumberTextfield(
                    'Secondary Requests Percentage',
                    'EnableSecondaryRequestPercentage',
                    false,
                    'Enables secondary requests on a percentage of endpoint requests to this channel',
                  )}
                </div>
              )}
              {this.state.EnableSecondaryRequests === EBool.EBool_TRUE && (
                <div className={this.props.classes.optionRowIndented}>
                  {this.renderNumberTextfield(
                    'Secondary Requests Timeout',
                    'EnableSecondaryRequestTimeout',
                    false,
                    'Time for first wave of requests to respond before second wave is started (0 stands for default value, max is 2000)',
                  )}
                </div>
              )}
              {this.renderSwitch({
                name: 'Enable Price Extension in response',
                stateName: 'SitePriceExtension',
                tooltipText: 'Enable VAST extension nodes for price',
                dataType: 'EBool',
              })}

              {hasRoleSuperUser(user.user) && this.renderLiveVideoContext()}

              {isSamsungPublisher(session.publisher.ID) && this.renderEPGMetadataToggle()}
            </Panel>
          )}

          {/* super-user only options - NOT supported by bulk updating */}
          {hasRoleSuperUser(user.user) && !isBulkUpdate && (
            <>
              <Typography className={classes.typographyTitle}>Super-User Only Options</Typography>
              {superUserSwitches.map((s: ISiteSwitch) => this.renderSwitch(s))}
              {this.renderSuperUserSwitches()}
            </>
          )}
        </Grid>
      );
    };

    toggleSmartFloorActive = (): void => {
      this.setState({
        isSmartFloorActive: !this.state.isSmartFloorActive,
        smartFloorConfigs: this.buildNewSmartFloorConfigs(
          0,
          'InventorySmartFloors',
          true,
          0,
          this.state.isSmartFloorActive,
          false,
        ),
      });
    };

    renderSmartBidFloorSwitch = (): React.JSX.Element | null => {
      if (!EBool.isTrue(this.props.session.publisher.InventorySmartFloorsEnabled)) {
        return null;
      }

      const options: ISimpleOptionSelect[] = [
        {
          key: 'fixed',
          value: EBool.toBoolString(EBool.EBool_FALSE),
          label: ct('Fixed'),
          icon: 'checkmark-2',
          isSelected: !this.state.isSmartFloorActive,
          isDisabled: false,
        },
        {
          key: 'smart',
          value: EBool.toBoolString(EBool.EBool_TRUE),
          label: ct('Smart'),
          icon: 'arrow-up',
          isSelected: this.state.isSmartFloorActive,
          isDisabled: false,
        },
      ];

      return (
        <Row noPadding>
          <Cols noPadding>
            <Col style={{ marginRight: spacing.small }}>
              <PillSwitcherV2
                size='small'
                options={options}
                onChange={() => this.toggleSmartFloorActive()}
              />
              {this.state.isSmartFloorActive && (
                <Cols
                  paddingTop={spacing.small}
                  onClick={() => this.updateTab(this.getSmartFloorsTabIndex())}
                  style={{ width: 'fit-content', alignItems: 'center', cursor: 'pointer' }}
                >
                  <Col>
                    <Text
                      bold
                      small
                      color={publicaColors.blue}
                      tKey={'SetItem'}
                      tProps={{ item: ct('SmartFloors') }}
                    />
                  </Col>
                  <Col style={{ marginLeft: spacing.extraSmall }}>
                    <IconV2 small name='externalLink' color={publicaColors.blue} />
                  </Col>
                </Cols>
              )}
            </Col>
            <Col style={{ maxWidth: '395px' }}>
              <Text
                bold
                extraSmall
                style={{
                  borderRadius: borderRadius.small,
                  background: publicaColors.skyBlue,
                  paddingLeft: spacing.small,
                  paddingRight: spacing.small,
                }}
                tKey={'BiddersMessageSmartFloors'}
              />
            </Col>
          </Cols>
        </Row>
      );
    };
    renderSwitch = (switchInfo: ISiteSwitch, disable?: boolean): React.JSX.Element => {
      // get values from props
      const { classes } = this.props;
      // get values from state
      const { isBulkUpdate } = this.state;

      // check authorization
      const disabled = disable || !this.state.writeAuthorization.isAuthorized;

      // render
      return (
        <Cols style={{ alignItems: 'center' }}>
          {/* checkbox for bulk update */}
          {isBulkUpdate && (
            <Col>
              <Checkbox
                disabled={this.isBulkUpdateCheckboxDisabled(switchInfo.stateName)}
                checked={this.isFieldSelectedForBulkUpdate(switchInfo.stateName)}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  this.handleBulkUpdateSelectionChange(
                    event.target.checked,
                    switchInfo.stateName,
                  ).then();
                }}
              />
            </Col>
          )}

          {/* switch */}

          <Col paddingRight={spacing.small}>
            <Switch
              id={switchInfo.dataType}
              name={String(switchInfo.stateName)}
              checked={
                switchInfo.dataType === 'EBool'
                  ? this.state[switchInfo.stateName] === EBool.EBool_TRUE
                  : (this.state[switchInfo.stateName] as boolean)
              }
              onChange={this.handleChangeSwitch}
              disabled={disabled}
            />
          </Col>

          {/* text */}
          {switchInfo.tooltipText ? (
            <Col flex style={{ display: 'flex', alignItems: 'center' }}>
              <Text
                extraSmall
                style={{
                  fontWeight: 400,
                  color: disabled ? publicaColors.lightGray : undefined,
                }}
              >
                {switchInfo.name}
              </Text>
              {switchInfo.isBeta ? (
                <Div marginLeft='8px'>
                  <BetaTooltipIcon />
                </Div>
              ) : (
                <Tooltip title={switchInfo.tooltipText || ''}>
                  <InfoIcon
                    style={{
                      verticalAlign: 'bottom',
                      width: '1rem',
                      color: '#929599',
                      paddingBottom: '5px',
                      marginLeft: '5px',
                    }}
                  />
                </Tooltip>
              )}
            </Col>
          ) : (
            <Col flex>
              <Typography className={classes.typographyNonTitle}>{switchInfo.name}</Typography>
            </Col>
          )}
        </Cols>
      );
    };

    // handles click on the delete button in the adomain list table
    handleAdomainDelete = (idx: number, adomainIdx: number): void => {
      const BypassDedupConfig = this.state.BypassDedupConfig;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      BypassDedupConfig[idx].Adomain = update(BypassDedupConfig[idx].Adomain, {
        $splice: [[adomainIdx, 1]],
      });
      BypassDedupConfig[idx].AdomainStrings = BypassDedupConfig[idx].Adomain.join(',');
      // remove element in list
      this.setState({
        BypassDedupConfig,
      });
    };

    renderBypassDedupSwitch = (
      switchInfo: IBypassDedupConfigSwitch,
      index: number,
    ): React.JSX.Element => {
      // get values from props
      const { classes } = this.props;
      // check authorization
      const disabled = !this.state.writeAuthorization.isAuthorized;

      // render
      return (
        <Cols style={{ alignItems: 'center', paddingLeft: spacingV2.large }}>
          {/* switch */}

          <Col paddingRight={spacing.medium}>
            <Switch
              id={switchInfo.dataType}
              name={String(switchInfo.stateNameBypassDedup)}
              // @ts-ignore
              checked={
                switchInfo.dataType === 'EBool'
                  ? this.state.BypassDedupConfig[index][switchInfo.stateNameBypassDedup] ===
                    EBool.EBool_TRUE
                  : this.state.BypassDedupConfig[index][switchInfo.stateNameBypassDedup]
              }
              onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                const bypassDedupConfig = this.state.BypassDedupConfig;
                if (target.name === 'BypassDedupByAdAsSeparation') {
                  // if BypassDedupByAdAsSeparation is true, toggle off the other two bypass options
                  if (EBool.fromBool(target.checked) === EBool.EBool_TRUE) {
                    bypassDedupConfig[index].BypassDedupByAdAsSeparation = EBool.EBool_TRUE;
                    bypassDedupConfig[index].BypassDedupByDurationAsSeparation = EBool.EBool_FALSE;
                    bypassDedupConfig[index].BypassDedupIfSurroundedByDedupedAds =
                      EBool.EBool_FALSE;
                  } else {
                    bypassDedupConfig[index].BypassDedupByAdAsSeparation = EBool.EBool_FALSE;
                  }
                  this.setState({
                    BypassDedupConfig: bypassDedupConfig,
                  });
                } else if (target.name === 'BypassDedupByDurationAsSeparation') {
                  // if BypassDedupByDurationAsSeparation is true, toggle off the other two bypass options
                  if (EBool.fromBool(target.checked) === EBool.EBool_TRUE) {
                    bypassDedupConfig[index].BypassDedupByAdAsSeparation = EBool.EBool_FALSE;
                    bypassDedupConfig[index].BypassDedupByDurationAsSeparation = EBool.EBool_TRUE;
                    bypassDedupConfig[index].BypassDedupIfSurroundedByDedupedAds =
                      EBool.EBool_FALSE;
                  } else {
                    bypassDedupConfig[index].BypassDedupByDurationAsSeparation = EBool.EBool_FALSE;
                  }
                  this.setState({
                    BypassDedupConfig: bypassDedupConfig,
                  });
                } else if (target.name === 'BypassDedupIfSurroundedByDedupedAds') {
                  // if BypassDedupIfSurroundedByDedupedAds is true, toggle off the other two bypass options
                  if (EBool.fromBool(target.checked) === EBool.EBool_TRUE) {
                    bypassDedupConfig[index].BypassDedupByAdAsSeparation = EBool.EBool_FALSE;
                    bypassDedupConfig[index].BypassDedupByDurationAsSeparation = EBool.EBool_FALSE;
                    bypassDedupConfig[index].BypassDedupIfSurroundedByDedupedAds = EBool.EBool_TRUE;
                  } else {
                    bypassDedupConfig[index].BypassDedupIfSurroundedByDedupedAds =
                      EBool.EBool_FALSE;
                  }
                  this.setState({
                    BypassDedupConfig: bypassDedupConfig,
                  });
                }
              }}
              disabled={disabled}
            />
          </Col>

          {/* text */}
          {switchInfo.tooltipText ? (
            <Col flex style={{ display: 'flex', alignItems: 'center' }}>
              <Typography className={classes.typographyNonTitle}>{switchInfo.name}</Typography>
              <Tooltip title={switchInfo.tooltipText || ''}>
                <InfoIcon
                  style={{
                    verticalAlign: 'bottom',
                    width: '1rem',
                    color: '#929599',
                    paddingBottom: '5px',
                    marginLeft: '5px',
                  }}
                />
              </Tooltip>
            </Col>
          ) : (
            <Col flex>
              <Typography className={classes.typographyNonTitle}>{switchInfo.name}</Typography>
            </Col>
          )}
        </Cols>
      );
    };

    // adds the Adomain user entry into the Adomain table
    addAdomainUserEntry = (index: number, adomainEntry: string): void => {
      const BypassDedupConfig = this.state.BypassDedupConfig;
      const adomain = BypassDedupConfig[index].Adomain;
      const adomainUserEntry = adomainEntry.toLowerCase();

      // check entry validity
      if (adomainUserEntry === '' || adomain.includes(adomainUserEntry)) {
        // user entry already exists in the list → error
        this.setState({
          snackbarError: true,
          snackbarMessage:
            adomainUserEntry === ''
              ? 'The adomain field is empty.'
              : `The adomain ${adomainUserEntry} already exists in the list.`,
        });
        return;
      }

      // add user entry to table data array
      adomain.push(adomainUserEntry);
      // update state

      BypassDedupConfig[index].Adomain = adomain;
      BypassDedupConfig[index].AdomainUserEntry = '';
      BypassDedupConfig[index].AdomainStrings = adomain.join(',');
      this.setState({
        BypassDedupConfig,
      });
    };

    toggleBypassAdomainExactMatchActive = (index: number): void => {
      const BypassDedupConfig = this.state.BypassDedupConfig;
      BypassDedupConfig[index].IsAdomainExactMatch = EBool.reverse(
        BypassDedupConfig[index].IsAdomainExactMatch,
      );
      this.setState({
        BypassDedupConfig,
      });
    };

    expandAdomainAllowList = (index: number): void => {
      const BypassDedupConfig = this.state.BypassDedupConfig;
      BypassDedupConfig[index].IsBypassAdomainFieldsOpen = BypassDedupConfig[index]
        .IsBypassAdomainFieldsOpen
        ? EBool.reverse(BypassDedupConfig[index].IsBypassAdomainFieldsOpen)
        : EBool.EBool_TRUE;
      this.setState({
        BypassDedupConfig,
      });
    };

    clearButtonBypassDedupConfig = (index: number) => {
      return () => {
        const BypassDedupConfig = this.state.BypassDedupConfig;
        BypassDedupConfig[index].BidderIDs = '';
        BypassDedupConfig[index].HouseAdIDs = '';
        BypassDedupConfig[index].BypassMediafileDedup = EBool.EBool_FALSE;
        BypassDedupConfig[index].BypassAdomainDedup = EBool.EBool_FALSE;
        BypassDedupConfig[index].BypassIABCatDedup = EBool.EBool_FALSE;

        this.setState({
          BypassDedupConfig,
          bypassDedupStateKey: this.state.bypassDedupStateKey + 1,
        });
      };
    };

    handleChangeAllowBidsBelowDealFloor = (value: string) => {
      if (value === 'Value') {
        this.setState({
          AllowBidsBelowDealFloor: AllowBidsBelowDealFloor_BY_VALUE,
        });
      } else if (value === 'Percent') {
        this.setState({
          AllowBidsBelowDealFloor: AllowBidsBelowDealFloor_BY_PERCENT,
        });
      }
    };

    // renderInventorySettings renders the majority of the channel settings in the "details" tab.
    renderInventorySettings() {
      // get variable from props
      const { classes } = this.props;

      // get variable from state
      const { isBulkUpdate } = this.state;

      return (
        <div>
          {/* channel name - NOT supported by bulk updating */}
          {!isBulkUpdate && (
            <div className={classes.optionRow}>
              <TextField
                label='Channel Name'
                name='SiteName'
                fullWidth
                value={obfuscateSiteName(
                  this.state as unknown as ISite,
                  this.props.user.user.Username,
                  this.state.SiteName,
                )}
                onChange={this.handleChange}
              />
            </div>
          )}

          {/* channel label - NOT supported by bulk updating */}
          {!isBulkUpdate && (
            <div className={classes.optionRow}>
              <MaterialLabelDropdownMulti
                loading={this.state.loading}
                menuTitle='Channel Label'
                list={this.state.channelLabels}
                selected={this.state.ChannelLabelsSelected}
                onChange={(list: IChannelLabel[]) => {
                  this.handleChangeChannelLabelList(list);
                }}
              />
            </div>
          )}

          {/* Default Site Weight - currently available only to Premion and Cheddar - NOT supported by bulk updating */}
          {(this.props.session.publisher.ID === '788' ||
            this.props.session.publisher.ID === '359') &&
            !isBulkUpdate && (
              <div style={{ width: '400px' }}>
                <InputLabel id='default-channel-weight-label'>Default Channel Weight</InputLabel>
                <Select
                  labelId='default-channel-weight-label'
                  name='DefaultWeight'
                  style={{ marginRight: 20 }}
                  value={this.state.DefaultWeight}
                  onChange={(event: React.ChangeEvent<{ _: string; value: string }>) => {
                    this.handleChangeDefaultWeight(event.target.value);
                  }}
                >
                  {siteWeightOptions.map((w) => {
                    return <MenuItem value={w.value}>{w.label}</MenuItem>;
                  })}
                </Select>
                <br />
                <br />
              </div>
            )}

          {/* min pod size - NOT supported by bulk updating */}
          {!isBulkUpdate && (
            <div className={classes.optionRow}>
              {this.renderNumberTextfield('Min Pod Size', 'MinPodSize', false)}
            </div>
          )}

          {/* pod floor - NOT supported for Roku - NOT supported by bulk updating */}
          {!isRoku() &&
            !isBulkUpdate &&
            this.renderNumberTextfield(
              'Pod Floor',
              'PodFloor',
              true,
              'Minimum gross CPM to accept from a pod',
            )}

          <div>
            {/* options NOT supported by bulk updating */}
            {!isBulkUpdate && (
              <div>
                <div className={classes.optionRow}>
                  <SingleSelect
                    label='Region'
                    name='Region'
                    value={this.state.Region}
                    items={Regions}
                    onChange={this.handleChangeRegionSelect}
                  />
                </div>
                {this.renderDeliveryTypes()}
                {this.state.HeaderBidderDeliveryType === 'Web' &&
                  this.renderSwitch({
                    name: 'Allow VPAID',
                    stateName: 'AllowVPAID',
                    dataType: 'boolean',
                  })}
                {this.state.HeaderBidderDeliveryType === 'Web' &&
                  hasRoleSuperUser(this.props.user.user) &&
                  this.renderSwitch({
                    name: 'Enable Publica VPAID *',
                    stateName: 'EnablePublicaVPAID',
                    dataType: 'EBool',
                  })}
                {this.renderMimeTypes()}
                <div className={classes.optionRowWide}>
                  <div className={classes.singleSelectWithToolTip}>
                    <SingleSelect
                      label='Header Bidder Vast Version (Default 3)'
                      name='HeaderBidderVastVersion'
                      value={this.state.HeaderBidderVastVersion}
                      items={HeaderBidderVastVersions}
                      onChange={this.handleChangeSelect}
                    />
                  </div>
                  <Tooltip
                    title='Determines the VAST version returned in responses from this channel'
                    placement='bottom-start'
                  >
                    <InfoIcon className={classes.inputInfoIcon} />
                  </Tooltip>
                </div>
                {hasRoleSuperUser(this.props.user.user) && (
                  <>
                    {this.renderWinnerModel()}
                    {this.renderUserSync()}
                  </>
                )}
              </div>
            )}

            {/* max auction cap - NOT supported by bulk updating */}
            {!isBulkUpdate &&
              this.renderNumberTextfield(
                this.state.FrequencyLimit === 0 ? 'Frequency Limit (Disabled)' : 'Frequency Limit',
                'FrequencyLimit',
                false,
                'Frequency limit for unique device id / site over a 1 hour period.  Default 0 will disable frequency capping.',
              )}
            {!isBulkUpdate &&
              this.state.FrequencyLimit !== 0 &&
              this.props.session.publisher.ID === '530' &&
              this.renderNumberTextfield(
                'Duration of Frequency Limit (in minutes)',
                'FrequencyLimitDuration',
                false,
                'Default is 60 minutes.',
              )}
            {!isBulkUpdate &&
              (() => {
                let label = 'Max Auction Cap';
                if (this.state.MaxAuctionCap === 0 || (this.state.MaxAuctionCap as any) === '0') {
                  if (EBool.toBool(this.state.CombineCreatives)) {
                    label += ' (Default 2)';
                  } else {
                    label += ' (Default 8)';
                  }
                }
                return this.renderNumberTextfield(
                  label,
                  'MaxAuctionCap',
                  false,
                  'Max Auction Cap allowed per endpoint request. Default value is 8. If Combine Creatives is enabled, default value is 2.',
                );
              })()}

            {/* bid floor - NOT supported by bulk updating */}
            <Row noPadding>
              <Cols style={{ alignItems: 'center' }} gap={spacing.small}>
                <Col>
                  {/* eslint-disable-next-line i18next/no-literal-string */}
                  {!isBulkUpdate && this.renderNumberTextfield(ct('BidFloor'), 'BidFloor', true)}
                </Col>
                <Col>{!isBulkUpdate && this.renderSmartBidFloorSwitch()}</Col>
              </Cols>
            </Row>
            {!isBulkUpdate && isPhiloPublisher(this.props.session.publisher.ID) && (
              <Row>
                {this.renderSwitch({
                  name: 'Allow Bids Below Deal Floor',
                  stateName: 'BidsBelowDealFloorIsAllowed',
                  dataType: 'EBool',
                })}
                {this.state.BidsBelowDealFloorIsAllowed === EBool.EBool_TRUE && (
                  <Row>
                    <PillSwitcher
                      currentText={allowBidsBelowDealFloorTypeToString(
                        this.state.AllowBidsBelowDealFloor,
                      )}
                      pills={[{ text: 'Value' }, { text: 'Percent' }]}
                      onChange={(value: string) => {
                        this.handleChangeAllowBidsBelowDealFloor(value);
                      }}
                      defaultBackgroundColor={'#ffffff'}
                    />
                    {this.renderNumberTextfield(
                      'Value (Allow bids below the deal floor by this amount)',
                      'AllowBidsBelowDealFloorValue',
                      false,
                      '',
                      this.state.AllowBidsBelowDealFloor === AllowBidsBelowDealFloor_BY_PERCENT,
                    )}
                  </Row>
                )}
              </Row>
            )}
            {/* bid adjustment - NOT supported by bulk updating */}
            {!isBulkUpdate &&
              this.renderNumberTextfield(
                'Bid Adjustment',
                'BidAdjustmentFactor',
                false,
                'Bid Adjustment should be a % representing your net share in case of rev-share agreement.',
                true,
              )}
            {/* bid adj. value - NOT supported by bulk updating */}
            {!isBulkUpdate &&
              this.renderNumberTextfield(
                'Bid Adj. Value',
                'BidAdjustmentValue',
                true,
                'Use this field to enter a value that all bids will be lowered by.  This will impact both the auction and reporting.',
              )}
            {/* rendering of min/max bitrate, and all the switched */}
            {this.renderSwitches()}
          </div>
        </div>
      );
    }

    renderLiveLogs() {
      const { classes } = this.props;
      const {
        endpointsRequestLiveLogs,
        endpointResponseLiveLogs,
        vmapEndpointsRequestLiveLogs,
        vmapEndpointResponseLiveLogs,
        liveStreamWatcherAdBreakLiveLogs,
        liveLogsTabIndex,
        openLogsView,
        requestLiveLogFilter,
        responseLiveLogFilter,
        vmapRequestLiveLogFilter,
        vmapResponseLiveLogFilter,
        liveStreamWatcherAdBreakLiveLogFilter,
        refreshingLiveLogsTimestamp,
        refreshingLiveLogs,
        garmScoreFilter,
      } = this.state;

      const garmScoreOptions = [
        {
          value: 'All',
          label: 'All',
          description: 'All',
          key: 'All',
          backgroundColor: publicaColors.veryLightGreen,
          color: publicaColors.black,
        },
        {
          value: 'Safe',
          label: 'Safe',
          description: 'Safe',
          key: 'Safe',
          backgroundColor: publicaColors.lighterGray,
          color: publicaColors.darkGray,
        },
        {
          value: 'Low',
          label: 'Low',
          description: 'Low',
          key: 'Low',
          backgroundColor: publicaColors.lighterYellow,
          color: publicaColors.darkGoldenRod,
        },
        {
          value: 'Medium',
          label: 'Medium',
          description: 'Medium',
          key: 'Medium',
          backgroundColor: publicaColors.lightOrange,
          color: publicaColors.darkGoldenRod,
        },
        {
          value: 'High',
          label: 'High',
          description: 'High',
          key: 'High',
          backgroundColor: publicaColors.veryLightRed,
          color: publicaColors.maroon,
        },
      ].map((option) => ({
        ...option,
        isSelected: option.value === garmScoreFilter,
      }));

      const handleGarmScoreChange = (value: string): void => {
        this.setState({
          garmScoreFilter: value,
        });
      };

      let name = 'requestLiveLogFilter';
      let value = requestLiveLogFilter;
      let isLiveContextTab = false;

      switch (liveLogsTabIndex) {
        case 1:
          name = 'responseLiveLogFilter';
          value = responseLiveLogFilter;
          break;
        case 2:
          if (vmapEndpointsRequestLiveLogs.length > 0) {
            name = 'vmapRequestLiveLogFilter';
            value = vmapRequestLiveLogFilter;
          } else {
            name = 'liveStreamWatcherAdBreakLiveLogFilter';
            value = liveStreamWatcherAdBreakLiveLogFilter;
            isLiveContextTab = true;
          }
          break;
        case 3:
          name = 'vmapResponseLiveLogFilter';
          value = vmapResponseLiveLogFilter;
          break;
        case 4:
          name = 'liveStreamWatcherAdBreakLiveLogFilter';
          value = liveStreamWatcherAdBreakLiveLogFilter;
          isLiveContextTab = true;
          break;
        default:
      }

      const tabs = [];
      const tabPanels = [];
      tabs.push('Endpoint Requests');
      tabPanels.push(
        <LogEndpointRequestTable
          logs={filterLiveLogs(endpointsRequestLiveLogs, requestLiveLogFilter, [
            'endpointBody',
            'endpointURI',
            'timestamp',
          ])}
        />,
      );

      tabs.push('Endpoint Responses');
      tabPanels.push(
        <LogEndpointResponseTable
          data={filterLiveLogs(endpointResponseLiveLogs, responseLiveLogFilter)}
        />,
      );

      if (vmapEndpointsRequestLiveLogs.length > 0) {
        tabs.push('VMAP Endpoint Requests');
        tabPanels.push(
          <LogEndpointRequestTable
            logs={filterLiveLogs(vmapEndpointsRequestLiveLogs, vmapRequestLiveLogFilter, [
              'endpointBody',
              'endpointURI',
              'timestamp',
            ])}
          />,
        );
      }

      if (vmapEndpointResponseLiveLogs.length > 0) {
        tabs.push('VMAP Endpoint Responses');
        tabPanels.push(
          <LogEndpointResponseTable
            data={filterLiveLogs(vmapEndpointResponseLiveLogs, vmapResponseLiveLogFilter)}
          />,
        );
      }

      if (isSuper(this.props.user.user) && this.state.EnableLiveContext === EBool.EBool_TRUE) {
        tabs.push('Live Context Ad Break *');
        const liveAdbreakData = filterLiveLogsByGarmScoreWrapper(
          liveStreamWatcherAdBreakLiveLogs,
          liveStreamWatcherAdBreakLiveLogFilter,
          garmScoreFilter,
        );

        tabPanels.push(
          <LiveContextAdBreakTable data={liveAdbreakData} siteID={this.props.session.site?.ID} />,
        );
      }

      return (
        <Drawer
          anchor='right'
          open={openLogsView}
          onClose={() => this.setState({ openLogsView: false })}
          classes={{ paper: classes.drawerPaper }}
        >
          <Grid
            container
            direction='row'
            justify='flex-start'
            alignItems='center'
            style={{
              paddingLeft: '20px',
              width: '100%',
            }}
          >
            <Grid item style={{ paddingRight: '20px' }}>
              <h1>Live Logs</h1>
            </Grid>
            <Grid item>
              <ButtonView
                onClick={() => this.getLiveLogs()}
                text='Refresh'
                active={refreshingLiveLogs}
              />
            </Grid>
            {refreshingLiveLogsTimestamp && (
              <Grid item style={{ paddingLeft: '10px' }}>
                {`Last Updated At ${refreshingLiveLogsTimestamp}`}
              </Grid>
            )}
          </Grid>
          <Paper classes={{ root: classes.paper }}>
            <Grid
              container
              direction='row'
              alignItems='center'
              spacing={5}
              style={{ marginTop: 10, marginBottom: 10 }}
            >
              <div
                style={{
                  backgroundColor: '#F8F8F8',
                  display: 'inline-block',
                  marginBottom: '10px',
                  minWidth: 350,
                  width: '100%',
                }}
                onClick={() => this.trackEvent('Channel Settings - Search Live Logs')}
              >
                <IconButton classes={{ root: classes.iconButton }}>
                  <SearchIcon />
                </IconButton>
                <InputBase
                  style={{ width: 'calc(100% - 3em)' }}
                  classes={{ root: classes.input }}
                  placeholder='search by keyword or value'
                  name={name}
                  value={value}
                  onChange={this.handleChange}
                />
              </div>
            </Grid>
            {isLiveContextTab &&
              this.state.EnableLiveContext === EBool.EBool_TRUE &&
              isSuper(this.props.user.user) && (
                <Grid item>
                  <div>Filter by Garm Score</div>
                  <GarmScoreSelector options={garmScoreOptions} onChange={handleGarmScoreChange} />
                </Grid>
              )}
          </Paper>
          <AppBar position='static' style={{ backgroundColor, boxShadow: 'none', color: 'black' }}>
            <Tabs
              value={liveLogsTabIndex}
              onChange={(_: any, newIndex: number) => {
                // clear search filters whenever the live log tab changes
                if (newIndex === 0) {
                  this.setState({
                    liveLogsTabIndex: newIndex,
                    responseLiveLogFilter: '',
                  });
                } else {
                  this.setState({
                    liveLogsTabIndex: newIndex,
                    requestLiveLogFilter: '',
                  });
                }
              }}
              aria-label='simple tabs'
            >
              {tabs.map((label, index) => (
                <Tab label={label} {...MakeTabProps(index)} />
              ))}
            </Tabs>
          </AppBar>
          {tabPanels.map((panel, index) => (
            <TabPanel value={liveLogsTabIndex} index={index}>
              {panel}
            </TabPanel>
          ))}
        </Drawer>
      );
    }

    renderEndpointURLGenerator() {
      return (
        <div className='endpoint-url-generator'>
          <p>
            Select the following settings to create the endpoint URL associated with this channel.
            If you need more information about {getResellerTitle()} params please check out&nbsp;
            {/* NOTE: add rel='noopener' since _blank is a potential security issue https://web.dev/external-anchors-use-rel-noopener/ */}
            <a href={getTechnicalDocumentationWiki()} target='_blank' rel='noopener'>
              our wiki
            </a>
            &nbsp;or reach out to your {getResellerTitle()} account manager.
          </p>

          {/* Endpoint builder */}
          <Grid container direction='column'>
            <Grid item>
              <EndpointBuilder service={this.state.endpointBuilderService} />
            </Grid>
            <Grid item>
              <Divider style={{ marginBottom: '10px', marginTop: '10px' }} />
            </Grid>
            <Grid item style={{ paddingTop: '20px' }}>
              {this.renderStitchedUrl()}
            </Grid>
          </Grid>
        </div>
      );
    }

    renderStitchedUrl = () => {
      return (
        <Grid item>
          {/* Subheader*/}
          <Grid item container direction='row' justify='flex-start' alignItems='center'>
            <Grid item>
              <img src='/assets/shared/svg/stitch_arrow.svg' alt='Arrow' />
            </Grid>
            <Grid item style={{ paddingLeft: '10px', marginTop: '-4px' }}>
              <ModelParagraphSubtitle>Endpoint URL</ModelParagraphSubtitle>
            </Grid>
          </Grid>
          {/* URL*/}
          <BlueBackground classes={{ root: this.props.classes.paper }}>
            <p style={{ width: 'inherit', wordBreak: 'break-word' }}>{this.state.EndpointURL}</p>
          </BlueBackground>
          {/* Buttons*/}
          <Grid item container direction='row' justify='flex-start' alignItems='center'>
            {/* Copy button*/}
            <Grid item>
              <CopyButton
                style={{
                  fontSize: '15px',
                  backgroundColor: 'rgba(239,239,239,0)',
                  color: getColorTheme('secondaryButtonText'),
                }}
                text='COPY'
                copy={this.state.EndpointURL}
              />
            </Grid>
            {/* Custom values button*/}
            <Grid item style={{ paddingLeft: '10px' }}>
              {(hasRoleSuperUser(this.props.user.user) ||
                this.state.writeAuthorization.isAuthorized) && (
                <ModelWhiteButton
                  style={{ color: '#CC5B83' }}
                  onClick={() => {
                    this.setState({
                      openEndpointParamsCustomizeMenu: true,
                    });
                  }}
                  disabled={this.state.updating}
                >
                  [-] Customize Params Value
                </ModelWhiteButton>
              )}
            </Grid>
          </Grid>
          {/* Wiki documentation*/}
          <Grid item container direction='row' justify='flex-start' alignItems='center'>
            <Grid item style={{ paddingLeft: '10px' }}>
              <p className={this.props.classes.smallText}>
                Trafficking endpoint in your ad server? Please replace macros using&nbsp;
                <a href={getMacrosWiki()} target='_blank' rel='noopener'>
                  our documentation
                </a>
                .
              </p>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    renderEndpointParamsCustomizeDialog = () => {
      const required_params: string[] = Object.keys({ ...SITE_PARAMS_REQUIRED_TYPE });
      const notEditableParams: string[] = Object.keys({ ...SITE_PARAMS_NOT_EDITABLE_TYPE });

      return (
        <Dialog
          fullWidth
          maxWidth='sm'
          open={this.state.openEndpointParamsCustomizeMenu}
          onClose={() => {
            this.setState({ openEndpointParamsCustomizeMenu: false });
          }}
        >
          <EndpointCustomTable
            currentParams={this.state.endpointParams}
            requiredParams={required_params}
            notEditableParams={notEditableParams}
            onSave={(params: IParam[]) => {
              // add new user-values to endpoint before saving
              const newEndpoint = this.URLWithCustomParams(this.state.EndpointURL, params);
              this.setState({
                openEndpointParamsCustomizeMenu: false,
                endpointParams: params,
                EndpointURL: newEndpoint,
              });
            }}
          />
        </Dialog>
      );
    };

    // transform an URL with default-params to an URL with user-custom params
    URLWithCustomParams = (endpoint: string, params: IParam[]): string => {
      const domain = endpoint.split('?')[0]; // endpoint without parameters - 'test.com?lalala=test' => 'test.com'
      const separator = params.length > 0 ? '?' : ''; // parameter separation (if any)
      const paramsStr = params.map((param: IParam) => param.name + '=' + param.value).join('&'); // new parameters
      return domain + separator + paramsStr;
    };

    renderDeliveryTypes() {
      const { classes } = this.props;
      return (
        <div className={classes.optionRow}>
          <InputLabel style={{ fontSize: 12 }}>Header Bidder Delivery Type</InputLabel>
          <Select
            name='HeaderBidderDeliveryType'
            onChange={(event: React.ChangeEvent<{ value: string }>) => {
              this.handleChangeDeliveryType(event.target.value);
            }}
            value={this.state.HeaderBidderDeliveryType}
            fullWidth
          >
            {this.getHeaderBidderDeliveryTypes().map((item, index) => {
              return (
                <MenuItem key={index} value={item.value}>
                  {item.label}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      );
    }

    renderMimeTypes() {
      const { classes } = this.props;
      let mimeTypes = this.getMimeTypes(this.state.HeaderBidderDeliveryType);
      // if pause ad ('image/...') is selected, user can deselect 'video/mp4'
      if (this.state.MimeTypes.some((typ) => typ.startsWith('image/'))) {
        mimeTypes = mimeTypes.map((mime) => {
          if (mime.key === 'video/mp4') {
            return {
              ...mime,
              locked: false,
            };
          }
          return mime;
        });
      }
      return (
        <div className={classes.optionRowWide}>
          <CategoryMultiSelect
            label='Mime Types Allowed'
            name='MimeTypes'
            items={mimeTypes}
            onChange={(_: any, newMimeTypes: string[]) => {
              this.handleChangeMimeType(newMimeTypes);
            }}
            values={this.state.MimeTypes}
          />
        </div>
      );
    }

    renderNumberTextfield = (
      label: string,
      name: string,
      isCurrency: boolean,
      tooltipText?: string,
      isPercentage?: boolean,
    ) => {
      const { classes } = this.props;
      const currencySymbol = convertECurrencyTypeToSymbol(
        this.props.session.publisher.CurrencyDisplayed,
      );
      // @ts-ignore
      let value = this.state[name];
      if (isPercentage) {
        let newValue;
        // TTD requests that percentages for allowing bids below deal floor to include up to 1 decimal place
        if (name === 'AllowBidsBelowDealFloorValue') {
          newValue = isNaN(parseFloat(value)) ? '' : (parseFloat(value) * 100).toString();
          if (newValue.includes('.')) {
            const decimals = newValue.split('.');
            if (decimals[1].length === 0) {
              newValue += '.';
            } else if (decimals[1].length > 1) {
              newValue = decimals[0] + '.' + decimals[1][0];
            }
          }

          if (value[value.length - 1] === '.') {
            newValue += '.';
          }
        } else {
          newValue = isNaN(parseFloat(value)) ? '' : Math.round(parseFloat(value) * 100).toString();
        }

        value = newValue;
      }
      const showExchange =
        isCurrency && !Number.isNaN(value) && value !== -1 && value !== 0 && currencySymbol !== '$';
      return (
        <div className={tooltipText ? classes.optionRowWide : classes.optionRow}>
          {EBool.isTrue(this.props.session.publisher.EnableOtherCurrency) && name === 'BidFloor' ? (
            this.renderCurrencyConverter(String(value))
          ) : (
            <>
              <TextField
                style={{ width: tooltipText ? 390 : 400 }}
                name={name}
                label={label}
                // @ts-ignore
                value={value}
                onChange={(elem: React.ChangeEvent<HTMLInputElement>) =>
                  this.handleChange(elem, isPercentage)
                }
                helperText={this.state.errors[name]}
                error={!!this.state.errors[name]}
                InputProps={{
                  startAdornment: isCurrency ? (
                    <InputAdornment position='start'>$</InputAdornment>
                  ) : isPercentage ? (
                    <InputAdornment position='start'>%</InputAdornment>
                  ) : (
                    <></>
                  ),
                  endAdornment: showExchange ? (
                    <InputAdornment position='end'>
                      {currencySymbol +
                        (
                          value * this.props.session.publisher.ExchangeRate.ExchangeValueToUSD
                        ).toFixed(2)}
                    </InputAdornment>
                  ) : (
                    <></>
                  ),
                }}
              />
              {tooltipText && (
                <Tooltip title={tooltipText} placement='bottom-start'>
                  <InfoIcon className={classes.inputInfoIcon} />
                </Tooltip>
              )}
            </>
          )}
        </div>
      );
    };

    renderCurrencyConverter(value: string) {
      return (
        <CurrencyConverter
          className='pb-bidder-settings-form-view_textfield-bid-floor'
          currencies={CurrencyDisplayedItem}
          currency={convertECurrencyTypeToString(this.state.CurrencyDisplayed) || CurrencyTypeUSD}
          isDisabled={!this.state.writeAuthorization.isAuthorized}
          isErrored={!!this.state.errors.BidFloor}
          onChange={({ uiPrice, uiCurrency }) =>
            this.handleChangeBidFloorAndBidFloorCurrency(Number(uiPrice), uiCurrency)
          }
          price={value}
          displayCurrencyLabel={false}
          priceLabel={ct('BidFloor')}
          style={{
            maxWidth: '390px',
            justifyContent: 'space-between',
          }}
        />
      );
    }

    renderSuperUserSwitches() {
      return (
        <Grid>
          {this.renderSwitch({
            name: 'Enable Auction Split *',
            stateName: 'AuctionSplit',
            dataType: 'EBool',
          })}
          {this.state.AuctionSplit === EBool.EBool_TRUE && (
            <div className={this.props.classes.optionRowIndented}>
              {this.renderNumberTextfield(
                'Auction Split Timeout *',
                'AuctionSplitTimeout',
                false,
                '',
              )}
            </div>
          )}

          {this.renderSwitch({
            name: 'Enable Pod Duration Override *',
            stateName: 'PodDurationOverrideEnabled',
            dataType: 'EBool',
          })}
          {this.state.PodDurationOverrideEnabled === EBool.EBool_TRUE && (
            <div className={this.props.classes.optionRowIndented}>
              {this.renderNumberTextfield(
                'Pod Duration Override *',
                'PodDurationOverride',
                false,
                '',
              )}
            </div>
          )}
        </Grid>
      );
    }

    renderCombineCreatives() {
      return (
        <div>
          <div>
            {this.renderSwitch({
              name: 'Combine Creatives *',
              stateName: 'CombineCreatives',
              dataType: 'EBool',
            })}
          </div>
          {EBool.toBool(this.state.CombineCreatives) && (
            <div className={this.props.classes.optionRowIndented}>
              <SingleSelect
                label='Combine Creatives Max'
                name='CombineCreativesMax'
                value={this.state.CombineCreativesMax}
                items={CombineCreativesMaxValues}
                onChange={this.handleChangeSelect}
              />
            </div>
          )}
          {EBool.toBool(this.state.CombineCreatives) && isSuper(this.props.user.user) && (
            <div className={this.props.classes.optionRowIndented}>
              <SingleSelect
                label='Combine Creatives Priority *'
                name='CombineCreativesPriority'
                value={this.state.CombineCreativesPriority}
                items={CombineCreativesPriorityValues}
                onChange={this.handleChangeSelect}
              />
            </div>
          )}
        </div>
      );
    }

    renderLiveVideoContext() {
      return (
        <div>
          <div>
            {this.renderSwitch({
              name: 'Enable Live Contextualization *',
              stateName: 'EnableLiveContext',
              dataType: 'EBool',
            })}
          </div>
          {EBool.isTrue(this.state.EnableLiveContext) && (
            <div className={this.props.classes.optionRowIndented}>
              <TextField
                style={{ width: 400 }}
                name='LiveContextStreamURL'
                label='Live Context StreamURL'
                value={this.state.LiveContextStreamURL}
                onChange={this.handleChange}
                helperText={this.state.errors['LiveContextStreamURL']}
                error={!!this.state.errors['LiveContextStreamURL']}
              />
            </div>
          )}
          {EBool.isTrue(this.state.EnableLiveContext) && (
            <div className={this.props.classes.optionRowIndented}>
              {this.renderNumberTextfield('Lookback Minutes', 'LiveContextLookbackMinutes', false)}
            </div>
          )}
        </div>
      );
    }

    renderFallbackAds() {
      return (
        <Rows>
          <Row noPadding>
            {this.renderSwitch({
              name: 'Fallback Ads',
              stateName: 'EnableFallbackAds',
              dataType: 'EBool',
            })}
          </Row>
          <Row smallPadding marginLeft='85px'>
            {EBool.toBool(this.state.EnableFallbackAds) && (
              <Col width={160}>
                <SingleSelect
                  label='Fallback Ads Mode'
                  name='FallbackAdsMode'
                  value={this.state.FallbackAdsMode.toString()}
                  items={FallbackAdsModeValues}
                  onChange={(name: string, value: string) =>
                    this.handleChangeSelect(name, parseInt(value, 10))
                  }
                />
              </Col>
            )}
          </Row>
          {this.state.FallbackAdsMode === EFallbackAdsMode.FALLBACK_ADS_MODE_ADDITIONAL_ADS && (
            <Row smallPadding marginLeft='85px'>
              <Col width={160}>
                <SingleSelect
                  label='Number of Ads'
                  name='FallbackAdsAdditionalAds'
                  value={this.state.FallbackAdsAdditionalAds.toString()}
                  items={FallbackAdsNumberOfAdsValues}
                  onChange={(name: string, value: string | string[]) =>
                    this.handleChangeSelect(name, +value)
                  }
                  disableAlphanumSort={true}
                  sortComparefn={(a, b) => (parseInt(a.value, 10) > parseInt(b.value, 10) ? 1 : -1)}
                />
              </Col>
            </Row>
          )}
        </Rows>
      );
    }

    renderPublicaVault(): JSX.Element {
      const { session } = this.props;
      const {
        demandSourceList,
        bidderOptions,
        PublicaVaultExcludedDemandSources,
        PublicaVaultExcludedBidderIDs,
      } = this.state;
      const publicaVaultEnabledByPublisher = EBool.isTrue(session.publisher.EnablePublicaVault);
      const hasWriteAuth =
        publicaVaultEnabledByPublisher && this.state.writeAuthorization.isAuthorized;
      const selectedDemandSources =
        PublicaVaultExcludedDemandSources.length > 0
          ? new Set(PublicaVaultExcludedDemandSources.split(','))
          : new Set([]);
      const selectedBidders =
        PublicaVaultExcludedBidderIDs.length > 0
          ? new Set(PublicaVaultExcludedBidderIDs.split(','))
          : new Set([]);

      const publicaVaultUseDefaultOptions = [
        {
          key: 'default',
          value: 'True',
          label: 'Default',
          isSelected: EBool.isTrue(this.state.PublicaVaultUseDefault),
          isDisabled: false,
        },
        {
          key: 'custom',
          value: 'False',
          label: 'Custom',
          isSelected: !EBool.isTrue(this.state.PublicaVaultUseDefault),
          isDisabled: false,
        },
      ];

      const maxUnderFloorTypeOptions = [
        {
          key: 'default',
          value: '0',
          label: '%',
          isSelected: this.state.BidSaverConfig.MaxUnderFloorType === MaxUnderFloorType.Percent,
          isDisabled: false,
        },
        {
          key: 'custom',
          value: '1',
          label: convertECurrencyTypeToSymbol(this.state.CurrencyDisplayed),
          isSelected: this.state.BidSaverConfig.MaxUnderFloorType !== MaxUnderFloorType.Percent,
          isDisabled: false,
        },
      ] as ISimpleOptionSelect[];

      return (
        <Div>
          {this.renderSwitch(
            {
              name: ct('PublicaVault'),
              stateName: 'PublicaVaultEnabled',
              dataType: 'EBool',
              tooltipText: publicaVaultEnabledByPublisher
                ? undefined
                : ct('PublicaVaultTooltipText'),
            },
            !EBool.isTrue(session.publisher.EnablePublicaVault),
          )}

          {EBool.toBool(this.state.PublicaVaultEnabled) && (
            <Row marginLeft={spacing.huge} marginBottom={spacing.small} noHorizontalPadding>
              <Cols noPadding style={{ alignItems: 'center' }}>
                <Col style={{ marginRight: spacing.small }}>
                  <PillSwitcherV2
                    size='small'
                    options={publicaVaultUseDefaultOptions}
                    onChange={(data) => {
                      this.setState({ PublicaVaultUseDefault: EBool.fromBoolString(data) });
                    }}
                  />
                </Col>
                <Col>
                  <Text
                    bold
                    extraSmall
                    style={{
                      borderRadius: borderRadius.small,
                      backgroundColor: publicaColors.lighterBlue,
                      paddingLeft: spacing.small,
                      paddingRight: spacing.small,
                    }}
                  >
                    {EBool.isTrue(this.state.PublicaVaultUseDefault) ? (
                      'Use default configurations defined from general settings.'
                    ) : (
                      <>
                        Use custom settings to override the default configurations. Customize
                        settings per channel to <br /> optimize feature control.
                      </>
                    )}
                  </Text>
                </Col>
              </Cols>
            </Row>
          )}
          {EBool.toBool(this.state.PublicaVaultEnabled) &&
            !EBool.toBool(this.state.PublicaVaultUseDefault) && (
              <Rows
                marginLeft={spacing.huge}
                marginBottom={spacing.small}
                largeVerticalPadding
                gap={spacing.small}
                smallPadding
                style={{
                  width: 'fit-content',
                  border: `1px solid ${publicaColors.lightGray}`,
                  borderRadius: borderRadius.base,
                  backgroundColor: publicaColors.white,
                }}
              >
                <Row noVerticalPadding>
                  <Cols>
                    <Col style={{ margin: spacing.extraSmall }}>
                      <IconV2 name='safety' />
                    </Col>
                    <Col noPadding>
                      <Text style={{ fontSize: fontSizing.base, fontWeight: 500 }}>
                        Publica Vault Configurations
                      </Text>
                    </Col>
                  </Cols>
                </Row>
                <Row noVerticalPadding largeHorizontalPadding>
                  <Rows>
                    <Row smallVerticalPadding>
                      <Text extraSmall style={{ marginBottom: spacing.extraSmall }}>
                        Exclude selected demand sources
                      </Text>
                      <IndependentSelect
                        handleApplySelect={this.handlePublicaVaultDemandSourceExclusionItemAccept}
                        placeholder='Select Demand Sources'
                        listLabel='Demand Sources'
                        singularLabel='Demand Source'
                        options={demandSourceList}
                        selectedOptionIDs={selectedDemandSources}
                        key='demandSource'
                        maxWidth={280}
                        isDisabled={
                          !publicaVaultEnabledByPublisher ||
                          !this.state.writeAuthorization.isAuthorized
                        }
                      />
                    </Row>
                    <Row smallVerticalPadding>
                      <Text extraSmall style={{ marginBottom: spacing.extraSmall }}>
                        Exclude selected bidders
                      </Text>
                      <IndependentSelect
                        handleApplySelect={this.handlePublicaVaultBiddersExclusionItemAccept}
                        placeholder='Select Bidders'
                        listLabel='Bidders'
                        singularLabel='Bidder'
                        options={bidderOptions}
                        selectedOptionIDs={selectedBidders}
                        key='bidders'
                        maxWidth={280}
                        isDisabled={
                          !publicaVaultEnabledByPublisher ||
                          !this.state.writeAuthorization.isAuthorized
                        }
                      />
                    </Row>
                    <Row smallVerticalPadding>
                      <Text extraSmall style={{ marginBottom: spacing.extraSmall }}>
                        TTL
                      </Text>
                      <IndependentSelect
                        handleApplySelect={this.handlePublicaVaultTTLItemAccept}
                        placeholder='Select TTL'
                        listLabel='TTL'
                        singularLabel='TTL'
                        selectedLimit={1}
                        options={PublicaVaultTTLs}
                        selectedOptionIDs={new Set([this.state.BidSaverConfig.TTL])}
                        key='ttl'
                        maxWidth={280}
                        isDisabled={
                          !publicaVaultEnabledByPublisher ||
                          !this.state.writeAuthorization.isAuthorized
                        }
                      />
                    </Row>
                    <Row smallVerticalPadding>
                      <Cols style={{ alignItems: 'center' }}>
                        <Col>
                          <Text extraSmall>
                            Bids are delivered in environments that align with their original
                            targeting intent. Matching is based on Device ID, <br /> Channel ID, IP,
                            Content Genre, and Content Rating. Content ID and App Bundle are
                            optional
                          </Text>
                        </Col>
                      </Cols>

                      <Cols
                        style={{ alignItems: 'center', marginTop: spacing.extraSmall }}
                        gap={spacing.large}
                      >
                        <Cols style={{ alignItems: 'center' }}>
                          <Col marginRight={spacing.extraSmall}>
                            <Checkbox
                              checked={this.state.BidSaverConfig.ContentId}
                              name='BidSaverConfig.ContentId'
                              onChange={this.handleCheckboxChange}
                              size='small'
                              style={{ padding: '0 0 2px 0' }}
                              disabled={!hasWriteAuth}
                            />
                          </Col>
                          <Col>
                            <Text extraSmall muted={!hasWriteAuth}>
                              Content ID
                            </Text>
                          </Col>
                        </Cols>

                        <Cols style={{ alignItems: 'center' }}>
                          <Col marginRight={spacing.extraSmall}>
                            <Checkbox
                              checked={this.state.BidSaverConfig.AppBundle}
                              name='BidSaverConfig.AppBundle'
                              onChange={this.handleCheckboxChange}
                              size='small'
                              style={{ padding: '0 0 2px 0' }}
                              disabled={!hasWriteAuth}
                            />
                          </Col>
                          <Col>
                            <Text extraSmall muted={!hasWriteAuth}>
                              App Bundle
                            </Text>
                          </Col>
                        </Cols>
                      </Cols>
                    </Row>
                    <Row
                      smallVerticalPadding
                      smallHorizontalPadding
                      displayFlex
                      style={{ alignItems: 'center' }}
                    >
                      <Switch
                        id={'boolean'}
                        name='BidSaverConfig.StoreBelowFloorBids'
                        checked={this.state.BidSaverConfig.StoreBelowFloorBids}
                        onChange={(e) => {
                          const newPublicaVaultConfig = this.state.BidSaverConfig;
                          newPublicaVaultConfig.StoreBelowFloorBids = e.target.checked;
                          this.setState({
                            BidSaverConfig: newPublicaVaultConfig,
                          });
                        }}
                        disabled={!hasWriteAuth}
                      />
                      <Text extraSmall tKey='PublicaVaultStoreBelowFloorBids' />
                      <Tooltip
                        title='Extend Vault functionality to include bid responses rejected for being below your specified floor.'
                        placement='top'
                      >
                        <InfoIcon
                          style={{
                            verticalAlign: 'bottom',
                            width: '1rem',
                            color: '#929599',
                            marginLeft: '5px',
                          }}
                        />
                      </Tooltip>
                    </Row>
                    {this.state.BidSaverConfig.StoreBelowFloorBids && (
                      <Row smallVerticalPadding>
                        <Text
                          extraSmall
                          style={{ marginBottom: spacing.extraSmall }}
                          tKey='PublicaVaultStoreBelowFloorBidsTooltipText'
                        />
                        <Col>
                          <Cols wrap style={{ alignItems: 'center' }}>
                            <Col style={{ marginRight: spacing.base, marginTop: spacing.small }}>
                              <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
                                <Col>
                                  <Text small bold tKey='Unit' />
                                </Col>
                                <Col>
                                  <PillSwitcherV2
                                    size='extraSmall'
                                    options={maxUnderFloorTypeOptions}
                                    backgroundColor={publicaColors.whiteOrchid}
                                    onChange={(data) => {
                                      const newPublicaVaultConfig = this.state.BidSaverConfig;
                                      newPublicaVaultConfig.MaxUnderFloorType = Number(data);
                                      this.setState({
                                        BidSaverConfig: newPublicaVaultConfig,
                                      });
                                    }}
                                  />
                                </Col>
                              </Cols>
                            </Col>

                            <Col style={{ marginTop: spacing.small }}>
                              <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
                                <Col>
                                  <Text small bold tKey='Value' />
                                </Col>
                                <Col>
                                  <TextInput
                                    type='number'
                                    min={0}
                                    max={50}
                                    initialValue={String(
                                      this.state.BidSaverConfig.MaxUnderFloorValue,
                                    )}
                                    width='5rem'
                                    inputSize='small'
                                    step={0.5}
                                    handleOnChange={(data) => {
                                      const newPublicaVaultConfig = this.state.BidSaverConfig;
                                      newPublicaVaultConfig.MaxUnderFloorValue = Number(data);
                                      this.setState({
                                        BidSaverConfig: newPublicaVaultConfig,
                                      });
                                    }}
                                    onBlur={(e) => {
                                      // Default value 20% if there's no input
                                      if (
                                        e.currentTarget.value === '' &&
                                        this.state.BidSaverConfig.MaxUnderFloorType ===
                                          MaxUnderFloorType.Percent
                                      ) {
                                        e.currentTarget.value = '20';
                                      }
                                    }}
                                  />
                                </Col>
                              </Cols>
                            </Col>
                          </Cols>
                        </Col>
                        <Col>
                          <Text
                            extraSmall
                            style={{ marginBottom: spacing.extraSmall, marginTop: spacing.base }}
                            tKey='PublicaVaultAbsoluteMinimumTooltipText'
                          />
                        </Col>
                        <Col>
                          <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
                            <Col>
                              <Text
                                small
                                bold
                                tKey='PublicaVaultAbsoluteMinimum'
                                tProps={{
                                  label: convertECurrencyTypeToSymbol(this.state.CurrencyDisplayed),
                                }}
                              />
                            </Col>
                            <Col>
                              <TextInput
                                type='number'
                                min={0}
                                max={50}
                                initialValue={String(this.state.BidSaverConfig.MinBidFloor)}
                                width='5rem'
                                inputSize='small'
                                step={0.5}
                                handleOnChange={(data) => {
                                  const newPublicaVaultConfig = this.state.BidSaverConfig;
                                  newPublicaVaultConfig.MinBidFloor = Number(data);
                                  this.setState({
                                    BidSaverConfig: newPublicaVaultConfig,
                                  });
                                }}
                              />
                            </Col>
                          </Cols>
                        </Col>
                      </Row>
                    )}
                  </Rows>
                </Row>
              </Rows>
            )}
        </Div>
      );
    }

    renderEPGMetadataToggle(): JSX.Element {
      const { classes } = this.props;
      return (
        <>
          <Cols style={{ alignItems: 'center' }}>
            <Col marginRight={spacing.medium}>
              <Switch
                id='EnableEPGMetadata'
                name='EnableEPGMetadata'
                checked={EBool.isTrue(this.state.EnableEPGMetadata)}
                onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
                  const isEPGEnabled = target.checked;
                  if (isEPGEnabled) {
                    this.setState({
                      EnableEPGMetadata: EBool.EBool_TRUE,
                    });
                  } else {
                    // disable all EPG options if toggle is off
                    this.setState({
                      EnableEPGMetadata: EBool.EBool_FALSE,
                      EnableEPGContentDuration: EBool.EBool_FALSE,
                      EnableEPGContentGenre: EBool.EBool_FALSE,
                      EnableEPGContentLanguage: EBool.EBool_FALSE,
                      EnableEPGContentRating: EBool.EBool_FALSE,
                    });
                  }
                }}
              />
            </Col>
            <Col>
              <Text extraSmall>Enable EPG Metadata</Text>
            </Col>
          </Cols>
          {EBool.isTrue(this.state.EnableEPGMetadata) && (
            <Div marginLeft={spacing.huge}>
              <Cols style={{ alignItems: 'center' }}>
                <Col>
                  <Checkbox
                    className={classes.checkbox}
                    checked={EBool.isTrue(this.state.EnableEPGContentDuration)}
                    onChange={() =>
                      this.setState({
                        EnableEPGContentDuration: EBool.reverse(
                          this.state.EnableEPGContentDuration,
                        ),
                      })
                    }
                  />
                </Col>
                <Col>
                  <Text extraSmall>Content Duration Override</Text>
                </Col>
              </Cols>
              <Cols style={{ alignItems: 'center' }}>
                <Col>
                  <Checkbox
                    className={classes.checkbox}
                    checked={EBool.isTrue(this.state.EnableEPGContentGenre)}
                    onChange={() =>
                      this.setState({
                        EnableEPGContentGenre: EBool.reverse(this.state.EnableEPGContentGenre),
                      })
                    }
                  />
                </Col>
                <Col>
                  <Text extraSmall>Content Genre Override</Text>
                </Col>
              </Cols>
              <Cols style={{ alignItems: 'center' }}>
                <Col>
                  <Checkbox
                    className={classes.checkbox}
                    checked={EBool.isTrue(this.state.EnableEPGContentLanguage)}
                    onChange={() =>
                      this.setState({
                        EnableEPGContentLanguage: EBool.reverse(
                          this.state.EnableEPGContentLanguage,
                        ),
                      })
                    }
                  />
                </Col>
                <Col>
                  <Text extraSmall>Content Language Override</Text>
                </Col>
              </Cols>
              <Cols style={{ alignItems: 'center' }}>
                <Col>
                  <Checkbox
                    className={classes.checkbox}
                    checked={EBool.isTrue(this.state.EnableEPGContentRating)}
                    onChange={() =>
                      this.setState({
                        EnableEPGContentRating: EBool.reverse(this.state.EnableEPGContentRating),
                      })
                    }
                  />
                </Col>
                <Col>
                  <Text extraSmall>Content Rating Override</Text>
                </Col>
              </Cols>
            </Div>
          )}
        </>
      );
    }

    renderWinnerModel() {
      const { classes } = this.props;
      return (
        <div className={classes.optionRow}>
          <InputLabel style={{ fontSize: 12 }}>Winner Model *</InputLabel>
          <Select
            name='HeaderBidderWinnerModel'
            onChange={this.handleChangeWinnerModel}
            value={this.state.HeaderBidderWinnerModel}
            fullWidth
          >
            {winnerModels.map((item, index) => {
              return (
                <MenuItem key={index} value={item.key}>
                  {item.text}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      );
    }

    handleChangeWinnerModel = (event: React.ChangeEvent<{ value: number }>): void => {
      this.setState({
        HeaderBidderWinnerModel: event.target.value as ESite_HeaderBidderWinnerModel,
      });
    };

    renderUserSync() {
      const { classes } = this.props;
      let selectedProviders = [] as string[];
      if ((this.state.UserSyncProviders || '') !== '') {
        selectedProviders = this.state.UserSyncProviders.split(',');
      }
      return (
        <div className={classes.optionRowWide}>
          <CategoryMultiSelect
            items={userSyncModels.map((item: IUserSync) => {
              return {
                key: item.key,
                text: item.text,
              };
            })}
            label='User Sync Providers *'
            name='UserSyncProviders'
            onChange={this.handleChangeUserSyncProviders}
            values={selectedProviders}
            style={{ marginBottom: '12px' }}
          />
        </div>
      );
    }

    handleChangeUserSyncProviders = (_: string, value: string[]) => {
      this.setState({
        UserSyncProviders: value.join(','),
      });
    };

    // returns a chip component and a label that match the rule's type (IAB or adomain)
    getRuleTypeChip(rule: IBrandSafetyRule) {
      const chip = getRuleTypeChip(rule);
      const ChipComponent = chip.component;
      return <ChipComponent label={chip.label} style={{ alignItems: 'right' }} />;
    }

    // handles when the user clicks on one of the channel's rule title
    // navigate to the rule's edition page
    editBrandSafetyRule = ({ currentTarget }: React.MouseEvent<HTMLButtonElement>) => {
      this.props.session.brandSafetyReferrer = 'channel-edit'; // set referrer for the 'close' button
      navigate(RouteBrandSafetyEdit, extractRouteParams(this.props), {
        brandSafetyRuleID: currentTarget.value,
      });
    };

    // renders the list of brand-safety rules that targets this channel
    renderBrandSafetyRules = () => {
      return (
        <TableContainer>
          <Table>
            {/* TABLE HEAD*/}
            <TableHead>
              <TableCell>Rule Name</TableCell>
              <TableCell align={'center'}>Type</TableCell>
              <TableCell align={'center'}>Response Blocked</TableCell>
            </TableHead>
            {/* TABLE BODY*/}
            <TableBody>
              {this.state.channelBrandSafetyRules.map((rule: IBrandSafetyRule) => (
                <TableRow>
                  {/* rule name*/}
                  <TableCell>
                    {/* button that handle click on rule's name to go to its settings */}
                    <Button onClick={this.editBrandSafetyRule} value={rule.ID}>
                      <div
                        style={{
                          textAlign: 'left',
                        }}
                      >
                        {/* display rule name */}
                        <strong>
                          {checkUserInfoMasked(this.props.user.user)
                            ? 'demo_rule_' + rule.ID
                            : rule.Name}
                        </strong>
                      </div>
                    </Button>
                  </TableCell>
                  {/* rule type*/}
                  <TableCell align={'center'}>{this.getRuleTypeChip(rule)}</TableCell>
                  {/* nbr response blocked*/}
                  <TableCell align={'center'}>{rule.NbrResponseBlocked}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    };

    renderChannelABTests = () => {
      return (
        <Div style={{ marginBottom: '10em' }}>
          <ChannelABTestsContainer channelID={String(this.props.session.site?.ID)} />
        </Div>
      );
    };

    renderAdQualityTools = (): React.JSX.Element => {
      const { classes, session } = this.props;

      // "ad quality review tool" switches
      const standardSwitches: ISiteSwitch[] = [
        {
          name: ct('ClickThroughAdomainRecognitionEnabledName'),
          stateName: 'ClickThroughAdomainRecognitionEnabled',
          dataType: 'EBool',
          tooltipText: ct('ClickThroughAdomainRecognitionEnabledTooltipText'),
        },
        {
          name: ct('WebShrinkerCategoryEnabledName'),
          stateName: 'WebShrinkerCategoryEnabled',
          dataType: 'EBool',
          tooltipText: ct('WebShrinkerCategoryEnabledTooltipText'),
        },
      ];

      const premiumFeatureArr = session.publisher.PremiumFeaturesSelectionEleaAI
        ? session.publisher.PremiumFeaturesSelectionEleaAI.split(',').map(Number)
        : [];

      const featureMap: Record<string, PremiumFeaturesSelectionEleaAI> = {
        BrandRecognitionEnabled: PremiumFeaturesSelectionEleaAI.ADOMAIN_ENRICHMENT,
        LanguageDetectionEnabled: PremiumFeaturesSelectionEleaAI.LANGUAGE_ENRICHMENT,
        EnableCreativeQualityAssurance: PremiumFeaturesSelectionEleaAI.CQA,
      };

      const shouldDisable = EBool.isTrue(session.publisher.AllowPublisherToEnableEleaAI)
        ? Object.fromEntries(
            Object.entries(featureMap).map(([key, feature]) => [
              key,
              !premiumFeatureArr.includes(feature),
            ]),
          )
        : {
            BrandRecognitionEnabled: true,
            LanguageDetectionEnabled: true,
            EnableCreativeQualityAssurance: true,
          };

      const premiumSwitches: ISiteSwitch[] = [
        {
          name: ct('AdomainEnrichment'),
          stateName: 'BrandRecognitionEnabled',
          dataType: 'EBool',
          tooltipText: shouldDisable.BrandRecognitionEnabled
            ? ct('DisabledFeatureText')
            : ct('AdomainEnrichmentTooltipText'),
        },
        {
          name: ct('LanguageEnrichment'),
          stateName: 'LanguageDetectionEnabled',
          dataType: 'EBool',
          tooltipText: shouldDisable.LanguageDetectionEnabled
            ? ct('DisabledFeatureText')
            : ct('LanguageEnrichmentTooltipText'),
        },
        {
          name: ct('CreativeQualityAssurance'),
          stateName: 'EnableCreativeQualityAssurance',
          dataType: 'EBool',
          tooltipText: shouldDisable.EnableCreativeQualityAssurance ? (
            ct('DisabledFeatureText')
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: spacing.small }}>
              {ct('CreativeQualityAssuranceTooltipText1')} <br />
              {ct('CreativeQualityAssuranceTooltipText2')} <br />-{' '}
              {ct('CreativeQualityAssuranceTooltipText3')} <br />-{' '}
              {ct('CreativeQualityAssuranceTooltipText4')} <br />-{' '}
              {ct('CreativeQualityAssuranceTooltipText5')}
            </div>
          ),
        },
      ];

      return (
        <Grid className={classes.mainGridItem}>
          <Paper classes={{ root: classes.paper }}>
            <Grid item container direction='row' alignItems='center' spacing={1}>
              <Rows>
                <Row noPadding paddingBottom='16px'>
                  <Cols style={{ alignItems: 'center' }}>
                    <Col>
                      <Text title bold style={{ whiteSpace: 'nowrap' }} tKey='AdQualityTools' />
                    </Col>
                    <Col
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '2px 6px',
                        backgroundColor: publicaColors.lighterGreen,
                        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.1)',
                        borderRadius: '3px',
                        marginLeft: '10px',
                      }}
                    >
                      <Text
                        extraSmall
                        color={getColorTheme('betaIconText')}
                        tKey='AdQualityToolsText'
                      />
                    </Col>
                  </Cols>
                </Row>
                <Row paddingLeft={spacing.large} paddingBottom='16px'>
                  <Cols style={{ alignItems: 'center' }}>
                    <Col
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <Text
                        small
                        bold
                        style={{
                          marginRight: spacing.large,
                          marginTop: spacing.base,
                          marginBottom: spacing.base,
                        }}
                        tKey='Standard'
                      />
                    </Col>
                    <Col
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '2px 6px',
                        backgroundColor: publicaColors.veryLightGray,
                        borderRadius: '3px',
                      }}
                    >
                      <Text
                        extraSmall
                        color={publicaColors.black}
                        tKey='StandardFeatureDescription'
                      />
                    </Col>
                  </Cols>
                  {standardSwitches.map((s: ISiteSwitch) => this.renderSwitch(s))}
                </Row>
                <Row paddingLeft={spacing.large} paddingBottom='16px'>
                  <Cols style={{ alignItems: 'center' }}>
                    <Col
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <Text
                        small
                        bold
                        style={{
                          marginRight: spacing.large,
                          marginTop: spacing.base,
                          marginBottom: spacing.base,
                        }}
                        tKey='Premium'
                      />
                    </Col>
                    <Col
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '2px 6px',
                        backgroundColor: publicaColors.lighterBlue,
                        borderRadius: '3px',
                      }}
                    >
                      <Cols>
                        <Col noPadding>
                          <IconV2 name='ai-icon' small />
                        </Col>
                        <Col noPadding>
                          <Text
                            extraSmall
                            color={publicaColors.black}
                            tKey='PremiumFeatureDescription1'
                          />
                          <Text
                            extraSmall
                            color={publicaColors.black}
                            tKey='PremiumFeatureDescription2'
                          />
                        </Col>
                      </Cols>
                    </Col>
                  </Cols>
                  {premiumSwitches.map((s: ISiteSwitch) => {
                    if (s.stateName === 'EnableCreativeQualityAssurance') {
                      return (
                        <>
                          {this.renderSwitch(s, shouldDisable[s.stateName])}
                          <Row paddingLeft={spacing.huge} paddingBottom='16px'>
                            <CreativeQualityAssuranceView
                              enable={
                                shouldDisable.EnableCreativeQualityAssurance
                                  ? EBool.EBool_FALSE
                                  : this.state.EnableCreativeQualityAssurance
                              }
                              videoResolution={this.state.CreativeQualityAssuranceVideoResolution}
                              videoBitrate={this.state.CreativeQualityAssuranceVideoBitrate}
                              videoFormat={this.state.CreativeQualityAssuranceVideoFormat}
                              frameRate={this.state.CreativeQualityAssuranceFrameRate}
                              codec={this.state.CreativeQualityAssuranceCodec}
                              audioBitrate={this.state.CreativeQualityAssuranceAudioBitrate}
                              samplingFrequency={
                                this.state.CreativeQualityAssuranceSamplingFrequency
                              }
                              handleChangeValue={this.handleChangeCreativeQualityAssurance}
                            />
                          </Row>
                        </>
                      );
                    } else {
                      return this.renderSwitch(s, shouldDisable[s.stateName]);
                    }
                  })}
                </Row>
              </Rows>
            </Grid>
          </Paper>
        </Grid>
      );
    };

    renderSiteSmartFloors = (): React.JSX.Element => {
      return (
        <SiteSmartFloors
          smartFloorConfigs={this.state.smartFloorConfigs}
          selectedBidderIDForSmartFloorsChart={this.state.selectedBidderIDForSmartFloorsChart}
          handleChangeSmartFloorConfig={this.handleChangeSmartFloorConfig}
          connectedBidders={this.state.connectedBidders}
          siteId={this.props.session.site?.ID ?? 0}
        />
      );
    };

    renderPriceIncrements = () => {
      const { classes } = this.props;

      if (!this.state.PriceIncrements || this.state.PriceIncrements.length === 0) {
        return (
          <Grid className={classes.mainGridItem}>
            <Paper classes={{ root: classes.paper }}>
              <H3>Price Granularity *</H3>
              <div>
                <p className={classes.smallText}>Price increment is not set. The default is:</p>
                <pre>{this.state.defaultPriceIncrement}</pre>

                <div className={classes.section}>
                  <Button
                    color='primary'
                    classes={{ root: classes.button }}
                    onClick={this.addPriceIncrement}
                    disabled={true}
                  >
                    Add
                  </Button>
                </div>
              </div>
            </Paper>
          </Grid>
        );
      }

      return this.state.PriceIncrements.map(
        (priceIncrement: IHeaderBidderPriceIncrement, index: number) => {
          const isLast = index === this.state.PriceIncrements.length - 1;
          return (
            <Grid className={classes.mainGridItem}>
              <Paper classes={{ root: classes.paper }}>
                <H3>Price Granularity *</H3>
                <div>
                  <Grid container>
                    <Grid item xs={3}>
                      <div className={classes.section}>
                        <TextField
                          label='Min'
                          name='Min'
                          fullWidth
                          value={priceIncrement.Min}
                          onChange={this.handleChangePriceIncrement(index)}
                          disabled={true}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={3}>
                      <div className={classes.section}>
                        <TextField
                          label='Max'
                          name='Max'
                          fullWidth
                          value={priceIncrement.Max}
                          onChange={this.handleChangePriceIncrement(index)}
                          disabled={true}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={4}>
                      <div className={classes.section}>
                        <TextField
                          label='Increment'
                          name='Increment'
                          fullWidth
                          value={priceIncrement.Increment}
                          onChange={this.handleChangePriceIncrement(index)}
                          disabled={true}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={2} alignContent='center' alignItems='center'>
                      <br />
                      <Button
                        color='primary'
                        size='medium'
                        classes={{ root: classes.button }}
                        onClick={this.removePriceIncrement(index)}
                        disabled={true}
                      >
                        Remove
                      </Button>
                    </Grid>
                  </Grid>
                  {isLast ? (
                    <div className={classes.section}>
                      <Button
                        color='primary'
                        classes={{ root: classes.button }}
                        onClick={this.addPriceIncrement}
                        disabled={true}
                      >
                        Add
                      </Button>
                    </div>
                  ) : (
                    <span />
                  )}
                </div>
              </Paper>
            </Grid>
          );
        },
      );
    };

    renderBypassDedupConfig = () => {
      const { classes } = this.props;
      const { BypassDedupConfig } = this.state;

      if (!BypassDedupConfig || BypassDedupConfig.length === 0) {
        let bypassDedupConfig = BypassDedupConfig;
        if (!bypassDedupConfig) {
          bypassDedupConfig = [];
        }
        bypassDedupConfig.push({
          BypassMediafileDedup: EBool.EBool_FALSE,
          BypassAdomainDedup: EBool.EBool_FALSE,
          BypassIABCatDedup: EBool.EBool_FALSE,
          BypassDedupByAdAsSeparation: EBool.EBool_FALSE,
          BypassDedupAdCount: 1,
          BypassDedupByDurationAsSeparation: EBool.EBool_FALSE,
          BypassDedupDuration: 15,
          BypassDedupIfSurroundedByDedupedAds: EBool.EBool_FALSE,
          BidderIDs: '',
          BidderOptions: this.state.bidderOptions,
          HouseAdIDs: '',
          HouseAdsOptions: this.state.houseAdsOptions,
          IsBypassAdomainFieldsOpen: EBool.EBool_FALSE,
          IsAdomainExactMatch: EBool.EBool_TRUE,
          Adomain: [],
          AdomainUserEntry: '',
          AdomainStrings: '',
        });

        this.setState({
          BypassDedupConfig: bypassDedupConfig,
        });
      } else {
        // populates options if they are empty
        const bidders: ISmallBidder[] = this.state.bidders as ISmallBidder[];
        const campaigns: IAdserverCampaign[] = this.state.campaigns as IAdserverCampaign[];
        BypassDedupConfig.forEach((config: IBypassDedupConfig) => {
          config.Adomain = config.AdomainStrings !== '' ? config.AdomainStrings.split(',') : [];
          if (!config.BidderOptions) {
            config.BidderOptions = [];
            for (const bidder of bidders) {
              config.BidderOptions.push({
                id: bidder.ID,
                label: bidder.Name,
              });
            }
          }

          if (!config.HouseAdsOptions) {
            config.HouseAdsOptions = [];
            for (const campaign of campaigns) {
              config.HouseAdsOptions.push({
                id: campaign.ID,
                label: campaign.Name,
              });
            }
          }
        });
      }

      return BypassDedupConfig.map((bypassDedupConfig: IBypassDedupConfig, index: number) => {
        const isLast = index === BypassDedupConfig.length - 1;

        // "bypass deduplication" switches
        const selectedBypassDedupOptions: Set<string> = new Set([]);
        const bypassDeduplicationOptions: ISelectOption[] = [
          {
            id: 'BypassMediafileDedup',
            label: 'Mediafile',
          },
          {
            id: 'BypassAdomainDedup',
            label: 'Adomain',
          },
          {
            id: 'BypassIABCatDedup',
            label: 'IAB Category',
          },
        ];
        if (bypassDedupConfig.BypassMediafileDedup === EBool.EBool_TRUE) {
          selectedBypassDedupOptions.add('BypassMediafileDedup');
        }
        if (bypassDedupConfig.BypassAdomainDedup === EBool.EBool_TRUE) {
          selectedBypassDedupOptions.add('BypassAdomainDedup');
        }
        if (bypassDedupConfig.BypassIABCatDedup === EBool.EBool_TRUE) {
          selectedBypassDedupOptions.add('BypassIABCatDedup');
        }

        const biddersSet: Set<number | string> = new Set(
          BypassDedupConfig[index].BidderIDs !== ''
            ? BypassDedupConfig[index].BidderIDs.split(',')
            : [],
        );
        const houseAdsSet: Set<number | string> = new Set(
          BypassDedupConfig[index].HouseAdIDs !== ''
            ? BypassDedupConfig[index].HouseAdIDs.split(',')
            : [],
        );

        return (
          <div>
            <Rows
              marginLeft={spacing.huge}
              marginBottom={spacing.small}
              largeVerticalPadding
              gap={spacing.small}
              smallPadding
              style={{
                width: 'fit-content',
                border: `1px solid ${publicaColors.lightGray}`,
                borderRadius: borderRadius.base,
                backgroundColor: publicaColors.white,
              }}
            >
              <Row noVerticalPadding>
                <Cols>
                  <Col style={{ margin: spacing.extraSmall }}>
                    <IconV2 name='customize' small />
                  </Col>
                  <Col noPadding>
                    <Text style={{ fontSize: fontSizing.base, fontWeight: 500 }}>Bypass Rule</Text>
                  </Col>
                  <Col smallHorizontalPadding>
                    <Text
                      style={{
                        fontSize: fontSizing.extraSmall,
                        backgroundColor: publicaColors.lighterGreen,
                        paddingLeft: spacing.small,
                        paddingRight: spacing.small,
                        borderRadius: '3px',
                      }}
                    >
                      Define how you want to bypass deduplication by specifying granularity &
                      conditions where running the same ad is allowed.
                    </Text>
                  </Col>
                  <Col style={{ paddingLeft: '140px' }}></Col>
                  <Col noPadding>
                    <Button
                      style={{
                        color: publicaColors.gray,
                        padding: '0px',
                      }}
                      onClick={() => {
                        this.setState({
                          deleteBypassModelActive: true,
                        });
                      }}
                    >
                      <Col
                        style={{ marginRight: spacing.extraSmall, marginTop: spacing.extraSmall }}
                      >
                        <IconV2 name='delete' color={publicaColors.maroon} />
                      </Col>
                      <Col noPadding>
                        <Text
                          style={{
                            fontSize: fontSizing.base,
                            fontWeight: 500,
                            color: publicaColors.maroon,
                            textTransform: 'none',
                          }}
                        >
                          Delete
                        </Text>
                      </Col>
                    </Button>
                    {/* DELETE MODAL */}
                    <Dialog
                      open={this.state.deleteBypassModelActive}
                      onClose={() => {
                        this.setState({
                          deleteBypassModelActive: false,
                        });
                      }}
                      aria-labelledby='alert-dialog-update-preset'
                      aria-describedby='alert-dialog-update-preset'
                    >
                      <Rows largePadding gap={spacing.base} style={{ minWidth: '600px' }}>
                        <Row noPadding>
                          <Col>
                            <Text bold>Confirm Delete</Text>
                          </Col>
                        </Row>
                        <Row noPadding>
                          <Text small>
                            Specified conditions to this bypass rule will be removed.
                          </Text>
                        </Row>
                        <Row noPadding>
                          <Text bold>Should this bypass rule be deleted?</Text>
                        </Row>
                        <Row noPadding>
                          <Cols
                            gap={spacing.large}
                            style={{ justifyContent: 'flex-end', alignItems: 'center' }}
                          >
                            <Col>
                              <ButtonV2
                                small
                                clearBackground
                                color={publicaColors.lightBlue}
                                onClick={() => {
                                  this.removeBypassDedupConfig(index);
                                  this.setState({
                                    deleteBypassModelActive: false,
                                  });
                                }}
                              >
                                Confirm
                              </ButtonV2>
                            </Col>
                            <Col>
                              <ButtonV2
                                small
                                clearBackground
                                onClick={() => {
                                  this.setState({
                                    deleteBypassModelActive: false,
                                  });
                                }}
                                color={publicaColors.gray}
                              >
                                Cancel
                              </ButtonV2>
                            </Col>
                          </Cols>
                        </Row>
                      </Rows>
                    </Dialog>
                  </Col>
                </Cols>
              </Row>
              <Row noVerticalPadding>
                <Rows>
                  <Row noVerticalPadding>
                    <Cols>
                      <Col smallHorizontalPadding>
                        <Text style={{ fontSize: fontSizing.small, fontWeight: 500 }}>
                          Granularity
                        </Text>
                      </Col>
                      <Cols
                        style={{
                          fontSize: fontSizing.extraSmall,
                          backgroundColor: publicaColors.veryLightGray,
                          paddingLeft: spacing.small,
                          paddingRight: spacing.small,
                          borderRadius: '3px',
                        }}
                      >
                        <Col style={{ margin: '5px', marginBottom: spacing.none }}>
                          <IconV2 name='info' small />
                        </Col>
                        <Col>
                          <Text style={{ fontSize: fontSizing.extraSmall }}>
                            Specify where this rule applies & what level of deduplication is ok to
                            by pass with associated items, if applicable.
                          </Text>
                        </Col>
                      </Cols>
                    </Cols>
                  </Row>
                  <Row extraLargeHorizontalPaddingV2 paddingBottom={'0px'}>
                    <Row noPadding>
                      <Cols gap={spacing.medium} key={this.state.bypassDedupStateKey}>
                        <Col>
                          <Text style={{ fontSize: fontSizing.small }}>For selected bidders</Text>
                        </Col>
                        <Col>
                          <IndependentSelect
                            handleApplySelect={this.handleBypassBiddersItemAccept}
                            placeholder='Select Bidders'
                            listLabel='Bidders'
                            singularLabel='Bidders'
                            options={BypassDedupConfig[index].BidderOptions}
                            selectedOptionIDs={biddersSet}
                            key='bidders'
                            selectedKey={index}
                            maxWidth={280}
                          />
                        </Col>
                        <Col>
                          <Text style={{ fontSize: fontSizing.small }}>or house ads</Text>
                        </Col>
                        <Col>
                          <IndependentSelect
                            handleApplySelect={this.handleBypassHouseAdsItemAccept}
                            placeholder='Select House Ads'
                            listLabel='House Ads'
                            singularLabel='House Ads'
                            options={BypassDedupConfig[index].HouseAdsOptions}
                            selectedOptionIDs={houseAdsSet}
                            key='houseAds'
                            selectedKey={index}
                            maxWidth={280}
                          />
                        </Col>
                      </Cols>
                    </Row>
                    <Row verticalPadding noHorizontalPadding>
                      <Cols gap={spacing.medium} key={this.state.bypassDedupStateKey}>
                        <Col>
                          <Text style={{ fontSize: fontSizing.small }}>
                            bypass deduplication for the following
                          </Text>
                        </Col>
                        <Col>
                          <IndependentSelect
                            handleApplySelect={this.handleBypassDeduplicationItemAccept}
                            placeholder='Select Element to Bypass'
                            listLabel='Bypass Element'
                            singularLabel='Bypass Element'
                            isSelectionRequired
                            options={bypassDeduplicationOptions}
                            selectedOptionIDs={selectedBypassDedupOptions}
                            key='bypassDedupOptions'
                            selectedKey={index}
                            maxWidth={280}
                          />
                        </Col>
                        <Col>
                          <ButtonV2
                            style={{ color: publicaColors.blue, fontSize: fontSizing.small }}
                            onClick={this.clearButtonBypassDedupConfig(index)}
                            disabled={!this.state.writeAuthorization.isAuthorized}
                            clearBackground
                          >
                            CLEAR
                          </ButtonV2>
                        </Col>
                      </Cols>
                    </Row>
                  </Row>
                  {/* ADOMAIN ALLOW LIST */}
                  {EBool.isTrue(BypassDedupConfig[index].BypassAdomainDedup) && (
                    <AdomainAllowList
                      index={index}
                      BypassDedupConfig={BypassDedupConfig}
                      toggleBypassAdomainExactMatchActive={this.toggleBypassAdomainExactMatchActive}
                      addAdomainUserEntry={this.addAdomainUserEntry}
                      expandAdomainAllowList={this.expandAdomainAllowList}
                      handleAdomainDelete={this.handleAdomainDelete}
                    />
                  )}
                </Rows>
              </Row>
              <Row noVerticalPadding>
                <Rows>
                  <Row noVerticalPadding>
                    <Cols>
                      <Col smallHorizontalPadding>
                        <Text style={{ fontSize: fontSizing.small, fontWeight: 500 }}>
                          Conditions
                        </Text>
                      </Col>
                      <Cols
                        style={{
                          fontSize: fontSizing.extraSmall,
                          backgroundColor: publicaColors.veryLightGray,
                          paddingLeft: spacing.small,
                          paddingRight: spacing.small,
                          borderRadius: '3px',
                        }}
                      >
                        <Col style={{ margin: '5px', marginBottom: spacing.none }}>
                          <IconV2 name='info' small />
                        </Col>
                        <Col>
                          <Text style={{ fontSize: fontSizing.extraSmall }}>
                            Set restriction for when bypassing deduplication is ok.
                          </Text>
                        </Col>
                      </Cols>
                    </Cols>
                  </Row>
                  <Row noHorizontalPadding>
                    <Rows>
                      <Row noVerticalPadding>
                        {/* allow if separated by one ad switch */}
                        {this.renderBypassDedupSwitch(
                          {
                            name: 'Allow if separated by one ad',
                            stateNameBypassDedup: 'BypassDedupByAdAsSeparation',
                            dataType: 'EBool',
                          },
                          index,
                        )}
                      </Row>
                      <Row noVerticalPadding>
                        {/* ad count required to bypass dedup */}
                        {BypassDedupConfig[index].BypassDedupByAdAsSeparation ===
                          EBool.EBool_TRUE && (
                          // "Allow if separated by one ad" is enabled
                          // render the "Ad Count Required To Bypass Dedup" switch
                          <div className={classes.optionRowIndented}>
                            <Grid
                              container
                              direction='row'
                              justify='flex-start'
                              alignItems='center'
                              spacing={1}
                            >
                              <Grid item style={{ marginLeft: 29 }}>
                                <SingleSelect
                                  label='Ad Count Required To Bypass Dedup'
                                  name='BypassDedupAdCount'
                                  value={BypassDedupConfig[index].BypassDedupAdCount.toString()}
                                  items={AdCountNeededToBypassDedup}
                                  onChange={(_name: string, value: string) => {
                                    const bypassDedupConfig = BypassDedupConfig;
                                    bypassDedupConfig[index].BypassDedupAdCount = Number(value);
                                    this.setState({
                                      BypassDedupConfig: bypassDedupConfig,
                                    });
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </div>
                        )}
                      </Row>
                    </Rows>
                    <Rows>
                      <Row noVerticalPadding>
                        {/* allow if separated by specified duration switch */}
                        {this.renderBypassDedupSwitch(
                          {
                            name: 'Allow if separated by specified duration',
                            stateNameBypassDedup: 'BypassDedupByDurationAsSeparation',
                            dataType: 'EBool',
                          },
                          index,
                        )}
                      </Row>
                      <Row noVerticalPadding>
                        {/* duration required to bypass dedup */}
                        {BypassDedupConfig[index].BypassDedupByDurationAsSeparation ===
                          EBool.EBool_TRUE && (
                          // "Allow if separated by specified duration" is enabled
                          <div className={classes.optionRowIndented}>
                            <Grid
                              container
                              direction='row'
                              justify='flex-start'
                              alignItems='center'
                              spacing={1}
                            >
                              <Grid item style={{ marginLeft: 29 }}>
                                <SingleSelect
                                  label='Duration Required To Bypass Dedup'
                                  name='BypassDedupDuration'
                                  value={BypassDedupConfig[index].BypassDedupDuration.toString()}
                                  items={DurationsNeededToBypassDedup}
                                  onChange={(_name: string, value: string) => {
                                    const bypassDedupConfig = BypassDedupConfig;
                                    bypassDedupConfig[index].BypassDedupDuration = Number(value);
                                    this.setState({
                                      BypassDedupConfig: bypassDedupConfig,
                                    });
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </div>
                        )}
                      </Row>
                    </Rows>
                    <Row noVerticalPadding>
                      {/* allow for first and last slots */}
                      {this.renderBypassDedupSwitch(
                        {
                          name: 'Allow for first and last slots',
                          stateNameBypassDedup: 'BypassDedupIfSurroundedByDedupedAds',
                          tooltipText: 'ads in pod need to be greater than 2',
                          dataType: 'EBool',
                        },
                        index,
                      )}
                    </Row>
                  </Row>
                </Rows>
              </Row>
            </Rows>
            {/* </div> */}

            {isLast ? (
              <div className={classes.section}>
                <Button
                  style={{ color: publicaColors.blue }}
                  classes={{ root: classes.button }}
                  onClick={this.addBypassDedupConfig}
                  disabled={!this.state.writeAuthorization.isAuthorized}
                >
                  + Add Apply Bypass
                </Button>
              </div>
            ) : (
              <span />
            )}
          </div>
        );
      });
    };
  },
);
